var clinical_studies = [
  {
    "ing": [
      "Anti-inflammatory",
      "Chia seeds"
    ],
    "dsc": "Alpha-linolenic acid displayed analgesic, anti-inflammatory and anti-ulcer properties are part of a fruit oil.",
    "journal": "Bioscience Reports, 2021",
    "citation": {
      "text": "Paradee N, Koonyosying P, Kusirisin W, et al. Analgesic, anti-inflammatory and anti-ulcer properties of Thai Perilla frutescence fruit oil in animals. Biosci Rep. 2021;41(1):BSR20203166. doi:10.1042/BSR20203166 [*]",
      "link": "https://www.ncbi.nlm.nih.gov/pmc/articles/PMC7823181/"
    },
    "prods": [
      {
        "text": "Perfect Kibble Beef",
        "link": "/products/perfect-kibble-beef"
      },
      {
        "text": "Perfect Kibble Chicken",
        "link": "/products/perfect-kibble"
      },
      {
        "text": "Perfect Dog Food Mix",
        "link": "/products/perfect-dog-food-mix"
      }
    ]
  },
  {
    "ing": [
      "Anti-inflammatory",
      "Carrots"
    ],
    "dsc": "Luteeolin (contained in carrots) displayed potent anti-inflammatory properties.",
    "journal": "Journal of Veterinary Medical Science, 2016",
    "citation": {
      "text": "Kanai K, Nagata S, Hatta T, et al. Therapeutic anti-inflammatory effects of luteolin on endotoxin-induced uveitis in Lewis rats. J Vet Med Sci. 2016;78(8):1381-1384. doi:10.1292/jvms.16-0196 [*]",
      "link": "https://www.ncbi.nlm.nih.gov/pmc/articles/PMC5053947/"
    },
    "prods": [
      {
        "text": "Perfect Kibble Beef",
        "link": "/products/perfect-kibble-beef"
      },
      {
        "text": "Perfect Kibble Chicken",
        "link": "/products/perfect-kibble"
      },
      {
        "text": "Perfect Dog Food Mix",
        "link": "/products/perfect-dog-food-mix"
      }
    ]
  },
  {
    "ing": [
      "Apple cider vinegar"
    ],
    "dsc": "Apple cider vinegar has antimicrobial/antioxidant properties.",
    "journal": "Natural Product Research, 2019",
    "citation": {
      "text": "Gopal J, Anthonydhason V, Muthu M, Gansukh E, Jung S, Chul S, Iyyakkannu S. Authenticating apple cider vinegar's home remedy claims: antibacterial, antifungal, antiviral properties and cytotoxicity aspect. Nat Prod Res. 2019 Mar;33(6):906-910. doi: 10.1080/14786419.2017.1413567. Epub 2017 Dec 11. PMID: 29224370. [*]",
      "link": "https://pubmed.ncbi.nlm.nih.gov/29224370/"
    },
    "prods": [
      {
        "text": "Perfect Kibble Beef",
        "link": "/products/perfect-kibble-beef"
      },
      {
        "text": "Perfect Kibble Chicken",
        "link": "/products/perfect-kibble"
      }
    ]
  },
  {
    "ing": [
      "Apple cider vinegar"
    ],
    "dsc": "ACV beneficial for suppression of obesity-induxed oxidative stress and reduce risk of obesity-associated diseases by preventing atherogenic risk.",
    "journal": "Journal of Medicinal Food, 2018",
    "citation": {
      "text": "Halima BH, Sonia G, Sarra K, Houda BJ, Fethi BS, Abdallah A. Apple Cider Vinegar Attenuates Oxidative Stress and Reduces the Risk of Obesity in High-Fat-Fed Male Wistar Rats. J Med Food. 2018 Jan;21(1):70-80. doi: 10.1089/jmf.2017.0039. Epub 2017 Nov 1. PMID: 29091513. [*]",
      "link": "https://pubmed.ncbi.nlm.nih.gov/29091513/"
    },
    "prods": [
      {
        "text": "Perfect Kibble Beef",
        "link": "/products/perfect-kibble-beef"
      },
      {
        "text": "Perfect Kibble Chicken",
        "link": "/products/perfect-kibble"
      }
    ]
  },
  {
    "ing": [
      "Apple cider vinegar"
    ],
    "dsc": "ACV reduces gastric emptying rate, aiding diabetic blood sugar levels.",
    "journal": "BMC Gastroenterology, 2007",
    "citation": {
      "text": "Hlebowicz J, Darwiche G, Björgell O, Almér LO. Effect of apple cider vinegar on delayed gastric emptying in patients with type 1 diabetes mellitus: a pilot study. BMC Gastroenterol. 2007;7:46. Published 2007 Dec 20. doi:10.1186/1471-230X-7-46 [*]",
      "link": "https://www.ncbi.nlm.nih.gov/pmc/articles/PMC2245945/"
    },
    "prods": [
      {
        "text": "Perfect Kibble Beef",
        "link": "/products/perfect-kibble-beef"
      },
      {
        "text": "Perfect Kibble Chicken",
        "link": "/products/perfect-kibble"
      }
    ]
  },
  {
    "ing": [
      "Apple cider vinegar"
    ],
    "dsc": "ACV has a powerful antimicrobial effect against MRSA and resistant E. coli.",
    "journal": "Scientific Reports, 2021",
    "citation": {
      "text": "Yagnik D, Ward M, Shah AJ. Antibacterial apple cider vinegar eradicates methicillin resistant Staphylococcus aureus and resistant Escherichia coli. Sci Rep. 2021 Jan 20;11(1):1854. doi: 10.1038/s41598-020-78407-x. PMID: 33473148; PMCID: PMC7817673. [*]",
      "link": "https://pubmed.ncbi.nlm.nih.gov/33473148/"
    },
    "prods": [
      {
        "text": "Perfect Kibble Beef",
        "link": "/products/perfect-kibble-beef"
      },
      {
        "text": "Perfect Kibble Chicken",
        "link": "/products/perfect-kibble"
      }
    ]
  },
  {
    "ing": [
      "Apple cider vinegar"
    ],
    "dsc": "ACV had a significant favourable effect on fasting plasma glucose and blood lipid levels.",
    "journal": "BMC Complementary Medicine and Therapies, 2021",
    "citation": {
      "text": "Hadi A, Pourmasoumi M, Najafgholizadeh A, Clark CCT, Esmaillzadeh A. The effect of apple cider vinegar on lipid profiles and glycemic parameters: a systematic review and meta-analysis of randomized clinical trials. BMC Complement Med Ther. 2021;21(1):179. Published 2021 Jun 29. doi:10.1186/s12906-021-03351-w [*]",
      "link": "https://www.ncbi.nlm.nih.gov/pmc/articles/PMC8243436/"
    },
    "prods": [
      {
        "text": "Perfect Kibble Beef",
        "link": "/products/perfect-kibble-beef"
      },
      {
        "text": "Perfect Kibble Chicken",
        "link": "/products/perfect-kibble"
      }
    ]
  },
  {
    "ing": [
      "Apple cider vinegar"
    ],
    "dsc": "ACV is highly beneficial in metabolic disorders (e.g., obesity or type II diabetes) caused by high-caloric food.",
    "journal": "Journal of Diabetes Research, 2020",
    "citation": {
      "text": "Ousaaid D, Laaroussi H, Bakour M, et al. Beneficial Effects of Apple Vinegar on Hyperglycemia and Hyperlipidemia in Hypercaloric-Fed Rats. J Diabetes Res. 2020;2020:9284987. Published 2020 Jul 10. doi:10.1155/2020/9284987 [*]",
      "link": "https://www.ncbi.nlm.nih.gov/pmc/articles/PMC7374219/"
    },
    "prods": [
      {
        "text": "Perfect Kibble Beef",
        "link": "/products/perfect-kibble-beef"
      },
      {
        "text": "Perfect Kibble Chicken",
        "link": "/products/perfect-kibble"
      }
    ]
  },
  {
    "ing": [
      "Apple cider vinegar"
    ],
    "dsc": "Review: ACV side effects are low to negligible. It is safe for consumption.",
    "journal": "European Journal of Nutrition, 2020",
    "citation": {
      "text": "Launholt TL, Kristiansen CB, Hjorth P. Safety and side effects of apple vinegar intake and its effect on metabolic parameters and body weight: a systematic review. Eur J Nutr. 2020 Sep;59(6):2273-2289. doi: 10.1007/s00394-020-02214-3. Epub 2020 Mar 13. PMID: 32170375. [*]",
      "link": "https://pubmed.ncbi.nlm.nih.gov/32170375/"
    },
    "prods": [
      {
        "text": "Perfect Kibble Beef",
        "link": "/products/perfect-kibble-beef"
      },
      {
        "text": "Perfect Kibble Chicken",
        "link": "/products/perfect-kibble"
      }
    ]
  },
  {
    "ing": [
      "Beef liver",
      "Fresh chicken",
      "Fresh beef"
    ],
    "dsc": "Low coenzyme Q10 (high in beef and chicken liver) reduced heart failure's effects.",
    "journal": "Journal of Cardiac Failure, 2000",
    "citation": {
      "text": "Harker-Murray AK, Tajik AJ, Ishikura F, Meyer D, Burnett JC, Redfield MM. The role of coenzyme Q10 in the pathophysiology and therapy of experimental congestive heart failure in the dog. J Card Fail. 2000 Sep;6(3):233-42. doi: 10.1054/jcaf.2000.8839. PMID: 10997750. [*]",
      "link": "https://pubmed.ncbi.nlm.nih.gov/10997750/"
    },
    "prods": [
      {
        "text": "Perfect Kibble Beef",
        "link": "/products/perfect-kibble-beef"
      },
      {
        "text": "Perfect Kibble Chicken",
        "link": "/products/perfect-kibble"
      },
      {
        "text": "Perfect Dog Food Mix",
        "link": "/products/perfect-dog-food-mix"
      }
    ]
  },
  {
    "ing": [
      "Beef liver"
    ],
    "dsc": "Overviw of bef liver composition - rich source of amino acids (more nutritious than muscle tissue).",
    "journal": "Korean Journal for Food Science of Animal Resources, 2014",
    "citation": {
      "text": "Li RR, Yu QL, Han L, Cao H. Nutritional Characteristics and Active Components in Liver from Wagyu×Qinchuan Cattle. Korean J Food Sci Anim Resour. 2014;34(2):214-220. doi:10.5851/kosfa.2014.34.2.214 [*]",
      "link": "https://www.ncbi.nlm.nih.gov/pmc/articles/PMC4597842/"
    },
    "prods": [
      {
        "text": "Perfect Kibble Beef",
        "link": "/products/perfect-kibble-beef"
      },
      {
        "text": "Perfect Kibble Chicken",
        "link": "/products/perfect-kibble"
      },
      {
        "text": "Perfect Dog Food Mix",
        "link": "/products/perfect-dog-food-mix"
      }
    ]
  },
  {
    "ing": [
      "Beef liver"
    ],
    "dsc": "Beef liver improved hemoglobin production in dogs.",
    "journal": "Journal of Clinical Investigation, 1927",
    "citation": {
      "text": "Riecker HH. A STUDY OF EXPERIMENTAL ANEMIA IN DOGS: THE ACTION OF BEEF LIVER AND IRON SALTS ON HEMOGLOBIN REGENERATION. J Clin Invest. 1927 Dec;5(1):141-60. doi: 10.1172/JCI100146. PMID: 16693780; PMCID: PMC434702. [*]",
      "link": "https://pubmed.ncbi.nlm.nih.gov/16693780/"
    },
    "prods": [
      {
        "text": "Perfect Kibble Beef",
        "link": "/products/perfect-kibble-beef"
      },
      {
        "text": "Perfect Kibble Chicken",
        "link": "/products/perfect-kibble"
      },
      {
        "text": "Perfect Dog Food Mix",
        "link": "/products/perfect-dog-food-mix"
      }
    ]
  },
  {
    "ing": [
      "Beef liver"
    ],
    "dsc": "Liver is a source of vitamin A, all B vitamins, vitamin C, iron, selenium, and polyunsaturated fatty acids.",
    "journal": "International Journal of Circumpolar Health, 2012",
    "citation": {
      "text": "Hassan AA, Sandanger TM, Brustad M. Level of selected nutrients in meat, liver, tallow and bone marrow from semi-domesticated reindeer (Rangifer t. tarandus L.). Int J Circumpolar Health. 2012;71:17997. Published 2012 Mar 19. doi:10.3402/ijch.v71i0.17997 [*]",
      "link": "https://www.ncbi.nlm.nih.gov/pmc/articles/PMC3417664/"
    },
    "prods": [
      {
        "text": "Perfect Kibble Beef",
        "link": "/products/perfect-kibble-beef"
      },
      {
        "text": "Perfect Kibble Chicken",
        "link": "/products/perfect-kibble"
      },
      {
        "text": "Perfect Dog Food Mix",
        "link": "/products/perfect-dog-food-mix"
      }
    ]
  },
  {
    "ing": [
      "Blueberries"
    ],
    "dsc": "Blueberry and grape extract did not affect renal or hepatic function.",
    "journal": "BMC Veterinary Research, 2016",
    "citation": {
      "text": "Martineau AS, Leray V, Lepoudere A, Blanchard G, Bensalem J, Gaudout D, Ouguerram K, Nguyen P; Neurophenols Consortium. A mixed grape and blueberry extract is safe for dogs to consume. BMC Vet Res. 2016 Aug 3;12(1):162. doi: 10.1186/s12917-016-0786-5. PMID: 27487916; PMCID: PMC4973095. [*]",
      "link": "https://pubmed.ncbi.nlm.nih.gov/27487916/"
    },
    "prods": [
      {
        "text": "Perfect Kibble Beef",
        "link": "/products/perfect-kibble-beef"
      },
      {
        "text": "Perfect Kibble Chicken",
        "link": "/products/perfect-kibble"
      },
      {
        "text": "Perfect Dog Food Mix",
        "link": "/products/perfect-dog-food-mix"
      }
    ]
  },
  {
    "ing": [
      "Blueberries"
    ],
    "dsc": "Blueberry and grape extract led to cognitive improvement in dogs, suggesting a benefit to working memory.",
    "journal": "Journal of Nutritional Science, 2017",
    "citation": {
      "text": "Fragua V, Lepoudère A, Leray V, Baron C, Araujo JA, Nguyen P, Milgram NW. Effects of dietary supplementation with a mixed blueberry and grape extract on working memory in aged beagle dogs. J Nutr Sci. 2017 Jul 12;6:e35. doi: 10.1017/jns.2017.33. PMID: 29152239; PMCID: PMC5672304. [*]",
      "link": "https://pubmed.ncbi.nlm.nih.gov/29152239/"
    },
    "prods": [
      {
        "text": "Perfect Kibble Beef",
        "link": "/products/perfect-kibble-beef"
      },
      {
        "text": "Perfect Kibble Chicken",
        "link": "/products/perfect-kibble"
      },
      {
        "text": "Perfect Dog Food Mix",
        "link": "/products/perfect-dog-food-mix"
      }
    ]
  },
  {
    "ing": [
      "Blueberries",
      "High antioxidants"
    ],
    "dsc": "Blueberries protect against renal structural injury and dysfunction.",
    "journal": "PLoS One, 2014",
    "citation": {
      "text": "Nair AR, Elks CM, Vila J, Del Piero F, Paulsen DB, Francis J. A blueberry-enriched diet improves renal function and reduces oxidative stress in metabolic syndrome animals: potential mechanism of TLR4-MAPK signaling pathway. PLoS One. 2014;9(11):e111976. Published 2014 Nov 5. doi:10.1371/journal.pone.0111976 [*]",
      "link": "https://www.ncbi.nlm.nih.gov/pmc/articles/PMC4221362/"
    },
    "prods": [
      {
        "text": "Perfect Kibble Beef",
        "link": "/products/perfect-kibble-beef"
      },
      {
        "text": "Perfect Kibble Chicken",
        "link": "/products/perfect-kibble"
      },
      {
        "text": "Perfect Dog Food Mix",
        "link": "/products/perfect-dog-food-mix"
      }
    ]
  },
  {
    "ing": [
      "Blueberries",
      "High antioxidants",
      "Anti-inflammatory"
    ],
    "dsc": "Blueberries contain anthocyanins which benefit and protect eye health via anti-oxidantant and anti-inflammatory mechanisms.",
    "journal": "Oxidative Medicine and Cellular Longevity, 2018",
    "citation": {
      "text": "Huang W, Yan Z, Li D, Ma Y, Zhou J, Sui Z. Antioxidant and Anti-Inflammatory Effects of Blueberry Anthocyanins on High Glucose-Induced Human Retinal Capillary Endothelial Cells. Oxid Med Cell Longev. 2018;2018:1862462. Published 2018 Feb 22. doi:10.1155/2018/1862462 [*]",
      "link": "https://www.ncbi.nlm.nih.gov/pmc/articles/PMC5842687/"
    },
    "prods": [
      {
        "text": "Perfect Kibble Beef",
        "link": "/products/perfect-kibble-beef"
      },
      {
        "text": "Perfect Kibble Chicken",
        "link": "/products/perfect-kibble"
      },
      {
        "text": "Perfect Dog Food Mix",
        "link": "/products/perfect-dog-food-mix"
      }
    ]
  },
  {
    "ing": [
      "Blueberries"
    ],
    "dsc": "Blueberries rich in polyphenols (incuding anthocyanins) - improve vascular function.",
    "journal": "Food & Function, 2019",
    "citation": {
      "text": "Wood E , Hein S , Heiss C , Williams C , Rodriguez-Mateos A . Blueberries and cardiovascular disease prevention. Food Funct. 2019 Dec 11;10(12):7621-7633. doi: 10.1039/c9fo02291k. PMID: 31776541. [*]",
      "link": "https://pubmed.ncbi.nlm.nih.gov/31776541/"
    },
    "prods": [
      {
        "text": "Perfect Kibble Beef",
        "link": "/products/perfect-kibble-beef"
      },
      {
        "text": "Perfect Kibble Chicken",
        "link": "/products/perfect-kibble"
      },
      {
        "text": "Perfect Dog Food Mix",
        "link": "/products/perfect-dog-food-mix"
      }
    ]
  },
  {
    "ing": [
      "Blueberries",
      "High antioxidants"
    ],
    "dsc": "Supplementing the diet with blueberries may protect against oxidative damage in sled dogs.",
    "journal": "Comparative Biochemistry and Physiology, 2006",
    "citation": {
      "text": "Dunlap KL, Reynolds AJ, Duffy LK. Total antioxidant power in sled dogs supplemented with blueberries and the comparison of blood parameters associated with exercise. Comp Biochem Physiol A Mol Integr Physiol. 2006 Apr;143(4):429-34. doi: 10.1016/j.cbpa.2005.09.007. Epub 2006 Mar 6. PMID: 16520073. [*]",
      "link": "https://pubmed.ncbi.nlm.nih.gov/16520073/"
    },
    "prods": [
      {
        "text": "Perfect Kibble Beef",
        "link": "/products/perfect-kibble-beef"
      },
      {
        "text": "Perfect Kibble Chicken",
        "link": "/products/perfect-kibble"
      },
      {
        "text": "Perfect Dog Food Mix",
        "link": "/products/perfect-dog-food-mix"
      }
    ]
  },
  {
    "ing": [
      "Blueberries",
      "High antioxidants",
      "Anti-inflammatory"
    ],
    "dsc": "Blueberry is rich in flavonoids (mainly anthocyanidins), polyphenols (procyanidin), phenolic acids, pyruvic acid, chlorogenic acid, and others, which have anticancer, anti-obesity, prevent degenerative diseases, anti-inflammation, protective properties for vision and liver, prevent heart diseases, antidiabetes, improve brain function, protective lung properties, strong bones, enhance immunity, prevent cardiovascular diseases, and improve cognitive decline.",
    "journal": "International Journal of Molecular Sciencies, 2018",
    "citation": {
      "text": "Ma L, Sun Z, Zeng Y, Luo M, Yang J. Molecular Mechanism and Health Role of Functional Ingredients in Blueberry for Chronic Disease in Human Beings. Int J Mol Sci. 2018;19(9):2785. Published 2018 Sep 16. doi:10.3390/ijms19092785 [*]",
      "link": "https://www.ncbi.nlm.nih.gov/pmc/articles/PMC6164568/"
    },
    "prods": [
      {
        "text": "Perfect Kibble Beef",
        "link": "/products/perfect-kibble-beef"
      },
      {
        "text": "Perfect Kibble Chicken",
        "link": "/products/perfect-kibble"
      },
      {
        "text": "Perfect Dog Food Mix",
        "link": "/products/perfect-dog-food-mix"
      }
    ]
  },
  {
    "ing": [
      "Blueberries"
    ],
    "dsc": "Blueberries reduce pain, stiffness, and difficulty performing daily activites in osteoarthritic individuals; improve gait performance.",
    "journal": "Nutrients, 2019",
    "citation": {
      "text": "Du C, Smith A, Avalos M, et al. Blueberries Improve Pain, Gait Performance, and Inflammation in Individuals with Symptomatic Knee Osteoarthritis. Nutrients. 2019;11(2):290. Published 2019 Jan 29. doi:10.3390/nu11020290 [*]",
      "link": "https://www.ncbi.nlm.nih.gov/pmc/articles/PMC6413191/"
    },
    "prods": [
      {
        "text": "Perfect Kibble Beef",
        "link": "/products/perfect-kibble-beef"
      },
      {
        "text": "Perfect Kibble Chicken",
        "link": "/products/perfect-kibble"
      },
      {
        "text": "Perfect Dog Food Mix",
        "link": "/products/perfect-dog-food-mix"
      }
    ]
  },
  {
    "ing": [
      "Blueberries",
      "High antioxidants"
    ],
    "dsc": "Balanced antioxidant diet may be a valid approach to restoring good cell metabolism and neutralizing excess free radicals in therapy dogs.",
    "journal": "Canadian Journal of Veterinary Research, 2017",
    "citation": {
      "text": "Sechi S, Fiore F, Chiavolelli F, Dimauro C, Nudda A, Cocco R. Oxidative stress and food supplementation with antioxidants in therapy dogs. Can J Vet Res. 2017;81(3):206-216. [*]",
      "link": "https://www.ncbi.nlm.nih.gov/pmc/articles/PMC5508397/"
    },
    "prods": [
      {
        "text": "Perfect Kibble Beef",
        "link": "/products/perfect-kibble-beef"
      },
      {
        "text": "Perfect Kibble Chicken",
        "link": "/products/perfect-kibble"
      },
      {
        "text": "Perfect Dog Food Mix",
        "link": "/products/perfect-dog-food-mix"
      }
    ]
  },
  {
    "ing": [
      "Blueberries"
    ],
    "dsc": "Blueberries can beneficially affect cardiometabolic health parameters.",
    "journal": "Currrent Developments in Nutrition, 2020",
    "citation": {
      "text": "Stote KS, Wilson MM, Hallenbeck D, Thomas K, Rourke JM, Sweeney MI, Gottschall-Pass KT, Gosmanov AR. Effect of Blueberry Consumption on Cardiometabolic Health Parameters in Men with Type 2 Diabetes: An 8-Week, Double-Blind, Randomized, Placebo-Controlled Trial. Curr Dev Nutr. 2020 Mar 9;4(4):nzaa030. doi: 10.1093/cdn/nzaa030. PMID: 32337475; PMCID: PMC7170047. [*]",
      "link": "https://pubmed.ncbi.nlm.nih.gov/32337475/"
    },
    "prods": [
      {
        "text": "Perfect Kibble Beef",
        "link": "/products/perfect-kibble-beef"
      },
      {
        "text": "Perfect Kibble Chicken",
        "link": "/products/perfect-kibble"
      },
      {
        "text": "Perfect Dog Food Mix",
        "link": "/products/perfect-dog-food-mix"
      }
    ]
  },
  {
    "ing": [
      "Blueberries"
    ],
    "dsc": "Blueberries associated with improved memory function and learning in older adults.",
    "journal": "Journal of Agricultural Food Chemistry, 2010",
    "citation": {
      "text": "Krikorian R, Shidler MD, Nash TA, Kalt W, Vinqvist-Tymchuk MR, Shukitt-Hale B, Joseph JA. Blueberry supplementation improves memory in older adults. J Agric Food Chem. 2010 Apr 14;58(7):3996-4000. doi: 10.1021/jf9029332. PMID: 20047325; PMCID: PMC2850944. [*]",
      "link": "https://pubmed.ncbi.nlm.nih.gov/20047325/"
    },
    "prods": [
      {
        "text": "Perfect Kibble Beef",
        "link": "/products/perfect-kibble-beef"
      },
      {
        "text": "Perfect Kibble Chicken",
        "link": "/products/perfect-kibble"
      },
      {
        "text": "Perfect Dog Food Mix",
        "link": "/products/perfect-dog-food-mix"
      }
    ]
  },
  {
    "ing": [
      "Blueberries"
    ],
    "dsc": "Epidemiological studies associate regular, moderate intake of blueberries and/or anthocyanins with reduced risk of cardiovascular disease, death, and type 2 diabetes, and with improved weight maintenance and neuroprotection.",
    "journal": "Advances in Nutrition, 2020",
    "citation": {
      "text": "Kalt W, Cassidy A, Howard LR, et al. Recent Research on the Health Benefits of Blueberries and Their Anthocyanins. Adv Nutr. 2020;11(2):224-236. doi:10.1093/advances/nmz065 [*]",
      "link": "https://www.ncbi.nlm.nih.gov/pmc/articles/PMC7442370/"
    },
    "prods": [
      {
        "text": "Perfect Kibble Beef",
        "link": "/products/perfect-kibble-beef"
      },
      {
        "text": "Perfect Kibble Chicken",
        "link": "/products/perfect-kibble"
      },
      {
        "text": "Perfect Dog Food Mix",
        "link": "/products/perfect-dog-food-mix"
      }
    ]
  },
  {
    "ing": [
      "Carrots"
    ],
    "dsc": "Carrots are high in numerous micro- and macronutrients, including iron, vitamin C, and more.",
    "journal": "Plant Food for Human Nutrition, 2001",
    "citation": {
      "text": "Singh G, Kawatra A, Sehgal S. Nutritional composition of selected green leafy vegetables, herbs and carrots. Plant Foods Hum Nutr. 2001;56(4):359-64. doi: 10.1023/a:1011873119620. PMID: 11678441. [*]",
      "link": "https://pubmed.ncbi.nlm.nih.gov/11678441/"
    },
    "prods": [
      {
        "text": "Perfect Kibble Beef",
        "link": "/products/perfect-kibble-beef"
      },
      {
        "text": "Perfect Kibble Chicken",
        "link": "/products/perfect-kibble"
      },
      {
        "text": "Perfect Dog Food Mix",
        "link": "/products/perfect-dog-food-mix"
      }
    ]
  },
  {
    "ing": [
      "Carrots"
    ],
    "dsc": "Review: a source of beta-carotene (e.g., carrots) is critical for dogs. Low vitamin A can cause weight loss, poor immune functioning and visual problems in dogs, and impede normal growth in puppies.",
    "journal": "Scientific World Journal, 2016",
    "citation": {
      "text": "Alice S. Green, Andrea J. Fascetti, \"Meeting the Vitamin A Requirement: The Efficacy and Importance of β-Carotene in Animal Species\", The Scientific World Journal, vol. 2016, Article ID 7393620, 22 pages, 2016. https://doi.org/10.1155/2016/7393620 [*]",
      "link": "https://www.ncbi.nlm.nih.gov/pmc/articles/PMC5090096/"
    },
    "prods": [
      {
        "text": "Perfect Kibble Beef",
        "link": "/products/perfect-kibble-beef"
      },
      {
        "text": "Perfect Kibble Chicken",
        "link": "/products/perfect-kibble"
      },
      {
        "text": "Perfect Dog Food Mix",
        "link": "/products/perfect-dog-food-mix"
      }
    ]
  },
  {
    "ing": [
      "Carrots"
    ],
    "dsc": "Vitamin A essential for development, but supplementation can lead to excess vitamin A.",
    "journal": "British Journal of Nutrition, 2012",
    "citation": {
      "text": "Morris PJ, Salt C, Raila J, et al. Safety evaluation of vitamin A in growing dogs. Br J Nutr. 2012;108(10):1800-1809. doi:10.1017/S0007114512000128 [*]",
      "link": "https://www.ncbi.nlm.nih.gov/pmc/articles/PMC3513714/"
    },
    "prods": [
      {
        "text": "Perfect Kibble Beef",
        "link": "/products/perfect-kibble-beef"
      },
      {
        "text": "Perfect Kibble Chicken",
        "link": "/products/perfect-kibble"
      },
      {
        "text": "Perfect Dog Food Mix",
        "link": "/products/perfect-dog-food-mix"
      }
    ]
  },
  {
    "ing": [
      "Carrots"
    ],
    "dsc": "Oral treatment with vitamin A (rich in carrots) helps certain skin disorders.",
    "journal": "Journal of the American Veterinary Medical Association, 1983",
    "citation": {
      "text": "Ihrke PJ, Goldschmidt MH. Vitamin A-responsive dermatosis in the dog. J Am Vet Med Assoc. 1983 Apr 1;182(7):687-90. PMID: 6221006. [*]",
      "link": "https://pubmed.ncbi.nlm.nih.gov/6221006/"
    },
    "prods": []
  },
  {
    "ing": [
      "Carrots"
    ],
    "dsc": "Carrots contains high levels of beta-carotene and dietary fibre.",
    "journal": "Journal of Food Science and Technology, 2012",
    "citation": {
      "text": "Sharma KD, Karki S, Thakur NS, Attri S. Chemical composition, functional properties and processing of carrot-a review. J Food Sci Technol. 2012;49(1):22-32. doi:10.1007/s13197-011-0310-7 [*]",
      "link": "https://www.ncbi.nlm.nih.gov/pmc/articles/PMC3550877/"
    },
    "prods": [
      {
        "text": "Perfect Kibble Beef",
        "link": "/products/perfect-kibble-beef"
      },
      {
        "text": "Perfect Kibble Chicken",
        "link": "/products/perfect-kibble"
      },
      {
        "text": "Perfect Dog Food Mix",
        "link": "/products/perfect-dog-food-mix"
      }
    ]
  },
  {
    "ing": [
      "Chia seeds"
    ],
    "dsc": "Overview of chia seeds nutritional profile: contains calcium, iron, magnesium, phosphorus, zinc, vitamin C, vitamin E, niacin, riboflavin, thiamine, folate and more",
    "journal": "Nutrients, 2019",
    "citation": {
      "text": "Kulczyński B, Kobus-Cisowska J, Taczanowski M, Kmiecik D, Gramza-Michałowska A. The Chemical Composition and Nutritional Value of Chia Seeds-Current State of Knowledge. Nutrients. 2019 May 31;11(6):1242. doi: 10.3390/nu11061242. PMID: 31159190; PMCID: PMC6627181. [*]",
      "link": "https://pubmed.ncbi.nlm.nih.gov/31159190/"
    },
    "prods": [
      {
        "text": "Perfect Kibble Beef",
        "link": "/products/perfect-kibble-beef"
      },
      {
        "text": "Perfect Kibble Chicken",
        "link": "/products/perfect-kibble"
      },
      {
        "text": "Perfect Dog Food Mix",
        "link": "/products/perfect-dog-food-mix"
      }
    ]
  },
  {
    "ing": [
      "Chia seeds"
    ],
    "dsc": "Alpha-linoleic acid (high in chia seeds) is believed to aid fur and skin health.",
    "journal": "Lipids, 2002",
    "citation": {
      "text": "Sinclair AJ, Attar-Bashi NM, Li D. What is the role of alpha-linolenic acid for mammals? Lipids. 2002 Dec;37(12):1113-23. doi: 10.1007/s11745-002-1008-x. PMID: 12617463. [*]",
      "link": "https://pubmed.ncbi.nlm.nih.gov/12617463/"
    },
    "prods": [
      {
        "text": "Perfect Kibble Beef",
        "link": "/products/perfect-kibble-beef"
      },
      {
        "text": "Perfect Kibble Chicken",
        "link": "/products/perfect-kibble"
      },
      {
        "text": "Perfect Dog Food Mix",
        "link": "/products/perfect-dog-food-mix"
      }
    ]
  },
  {
    "ing": [
      "Chia seeds"
    ],
    "dsc": "Dogs supplemented with fibre (high in chia seeds) reduce obesity and mitigated canine diabetes.",
    "journal": "British Journal of Nutrition, 2009",
    "citation": {
      "text": "Bosch G, Verbrugghe A, Hesta M, Holst JJ, van der Poel AF, Janssens GP, Hendriks WH. The effects of dietary fibre type on satiety-related hormones and voluntary food intake in dogs. Br J Nutr. 2009 Jul;102(2):318-25. doi: 10.1017/S0007114508149194. Epub 2009 Jan 15. PMID: 19144213. [*]",
      "link": "https://pubmed.ncbi.nlm.nih.gov/19144213/"
    },
    "prods": [
      {
        "text": "Perfect Kibble Beef",
        "link": "/products/perfect-kibble-beef"
      },
      {
        "text": "Perfect Kibble Chicken",
        "link": "/products/perfect-kibble"
      },
      {
        "text": "Perfect Dog Food Mix",
        "link": "/products/perfect-dog-food-mix"
      }
    ]
  },
  {
    "ing": [
      "Chia seeds"
    ],
    "dsc": "Chia seeds are a very high source of dietary fibre: 34-40g per 100g of seeds.",
    "journal": "Molecules, 2020",
    "citation": {
      "text": "Knez Hrnčič M, Ivanovski M, Cör D, Knez Ž. Chia Seeds (Salvia hispanica L.): An Overview-Phytochemical Profile, Isolation Methods, and Application. Molecules. 2019;25(1):11. Published 2019 Dec 18. doi:10.3390/molecules25010011 [*]",
      "link": "https://www.ncbi.nlm.nih.gov/pmc/articles/PMC6994964/"
    },
    "prods": [
      {
        "text": "Perfect Kibble Beef",
        "link": "/products/perfect-kibble-beef"
      },
      {
        "text": "Perfect Kibble Chicken",
        "link": "/products/perfect-kibble"
      },
      {
        "text": "Perfect Dog Food Mix",
        "link": "/products/perfect-dog-food-mix"
      }
    ]
  },
  {
    "ing": [
      "Chia seeds"
    ],
    "dsc": "Chia seeds reduced arthritis via anti-inflammatory effects in obese and non-obese rats.",
    "journal": "Journal of Basic and Clinical Physiology and Pharmacology, 2020",
    "citation": {
      "text": "Mohamed DA, Mohamed RS, Fouda K. Anti-inflammatory potential of chia seeds oil and mucilage against adjuvant-induced arthritis in obese and non-obese rats. J Basic Clin Physiol Pharmacol. 2020 Mar 5;31(4):/j/jbcpp.2020.31.issue-4/jbcpp-2019-0236/jbcpp-2019-0236.xml. doi: 10.1515/jbcpp-2019-0236. PMID: 32134733. [*]",
      "link": "https://pubmed.ncbi.nlm.nih.gov/32134733/"
    },
    "prods": [
      {
        "text": "Perfect Kibble Beef",
        "link": "/products/perfect-kibble-beef"
      },
      {
        "text": "Perfect Kibble Chicken",
        "link": "/products/perfect-kibble"
      },
      {
        "text": "Perfect Dog Food Mix",
        "link": "/products/perfect-dog-food-mix"
      }
    ]
  },
  {
    "ing": [
      "Chia seeds"
    ],
    "dsc": "Alpha-linoleic acid (high in chia seeds) protects against heart attacks.",
    "journal": "Current Atherosclerosis Reports, 2010",
    "citation": {
      "text": "Geleijnse JM, de Goede J, Brouwer IA. Alpha-linolenic acid: is it essential to cardiovascular health? Curr Atheroscler Rep. 2010 Nov;12(6):359-67. doi: 10.1007/s11883-010-0137-0. PMID: 20814766; PMCID: PMC2943064. [*]",
      "link": "https://pubmed.ncbi.nlm.nih.gov/20814766/"
    },
    "prods": [
      {
        "text": "Perfect Kibble Beef",
        "link": "/products/perfect-kibble-beef"
      },
      {
        "text": "Perfect Kibble Chicken",
        "link": "/products/perfect-kibble"
      },
      {
        "text": "Perfect Dog Food Mix",
        "link": "/products/perfect-dog-food-mix"
      }
    ]
  },
  {
    "ing": [
      "Chia seeds"
    ],
    "dsc": "Evidence that alpha-linoleic acid (high in chia seeds) is beneficial against narrowing arteries, diabetes, and obesity.",
    "journal": "Current Atherosclerosis Reports, 2004",
    "citation": {
      "text": "Vanden Heuvel JP. Diet, fatty acids, and regulation of genes important for heart disease. Curr Atheroscler Rep. 2004 Nov;6(6):432-40. doi: 10.1007/s11883-004-0083-9. PMID: 15485588. [*]",
      "link": "https://pubmed.ncbi.nlm.nih.gov/15485588/"
    },
    "prods": [
      {
        "text": "Perfect Kibble Beef",
        "link": "/products/perfect-kibble-beef"
      },
      {
        "text": "Perfect Kibble Chicken",
        "link": "/products/perfect-kibble"
      },
      {
        "text": "Perfect Dog Food Mix",
        "link": "/products/perfect-dog-food-mix"
      }
    ]
  },
  {
    "ing": [
      "Chia seeds"
    ],
    "dsc": "Chia seeds signifcantly reduced blood pressure in a randomized trial.",
    "journal": "Nutrition and Health, 2021",
    "citation": {
      "text": "Alwosais EZM, Al-Ozairi E, Zafar TA, Alkandari S. Chia seed (Salvia hispanica L.) supplementation to the diet of adults with type 2 diabetes improved systolic blood pressure: A randomized controlled trial. Nutr Health. 2021 Jun;27(2):181-189. doi: 10.1177/0260106020981819. Epub 2021 Feb 2. PMID: 33530854. [*]",
      "link": "https://pubmed.ncbi.nlm.nih.gov/33530854/"
    },
    "prods": [
      {
        "text": "Perfect Kibble Beef",
        "link": "/products/perfect-kibble-beef"
      },
      {
        "text": "Perfect Kibble Chicken",
        "link": "/products/perfect-kibble"
      },
      {
        "text": "Perfect Dog Food Mix",
        "link": "/products/perfect-dog-food-mix"
      }
    ]
  },
  {
    "ing": [
      "Chia seeds"
    ],
    "dsc": "Chia seeds beneficial in managing feline idiopathic hypercalcemia",
    "journal": "Frontiers in Veterinary Science, 2020",
    "citation": {
      "text": "Fantinati M, Priymenko N. Managing Feline Idiopathic Hypercalcemia With Chia Seeds (Salvia hispanica L.): A Case Series. Front Vet Sci. 2020;7:421. Published 2020 Jul 22. doi:10.3389/fvets.2020.00421 [*]",
      "link": "https://www.ncbi.nlm.nih.gov/pmc/articles/PMC7387619/"
    },
    "prods": [
      {
        "text": "Perfect Kibble Beef",
        "link": "/products/perfect-kibble-beef"
      },
      {
        "text": "Perfect Kibble Chicken",
        "link": "/products/perfect-kibble"
      },
      {
        "text": "Perfect Dog Food Mix",
        "link": "/products/perfect-dog-food-mix"
      }
    ]
  },
  {
    "ing": [
      "Chia seeds"
    ],
    "dsc": "Chia seeds may be beneficial in obesity, hypertension, cancer, diabetes, and cardiovascular diseases.",
    "journal": "Roczniki Panstwowego Zakladu Higieny, 2017",
    "citation": {
      "text": "Marcinek K, Krejpcio Z. Chia seeds (Salvia hispanica): health promoting properties and therapeutic applications – a review. Rocz Panstw Zakl Hig. 2017;68(2):123-129. PMID: 28646829. [*]",
      "link": "https://pubmed.ncbi.nlm.nih.gov/28646829/"
    },
    "prods": [
      {
        "text": "Perfect Kibble Beef",
        "link": "/products/perfect-kibble-beef"
      },
      {
        "text": "Perfect Kibble Chicken",
        "link": "/products/perfect-kibble"
      },
      {
        "text": "Perfect Dog Food Mix",
        "link": "/products/perfect-dog-food-mix"
      }
    ]
  },
  {
    "ing": [
      "Chia seeds"
    ],
    "dsc": "Chia seeds increased bone mineral content and improved hepatic and intestinal morphology in rats.",
    "journal": "Nutrients, 2018",
    "citation": {
      "text": "Montes Chañi EM, Pacheco SOS, Martínez GA, et al. Long-Term Dietary Intake of Chia Seed Is Associated with Increased Bone Mineral Content and Improved Hepatic and Intestinal Morphology in Sprague-Dawley Rats. Nutrients. 2018;10(7):922. Published 2018 Jul 19. doi:10.3390/nu10070922 [*]",
      "link": "https://www.ncbi.nlm.nih.gov/pmc/articles/PMC6073254/"
    },
    "prods": [
      {
        "text": "Perfect Kibble Beef",
        "link": "/products/perfect-kibble-beef"
      },
      {
        "text": "Perfect Kibble Chicken",
        "link": "/products/perfect-kibble"
      },
      {
        "text": "Perfect Dog Food Mix",
        "link": "/products/perfect-dog-food-mix"
      }
    ]
  },
  {
    "ing": [
      "Chia seeds"
    ],
    "dsc": "Review: Chia seeds lowered blood glucose levels and blood pressure.",
    "journal": "Nutrition Reviews, 2018",
    "citation": {
      "text": "Teoh SL, Lai NM, Vanichkulpitak P, Vuksan V, Ho H, Chiayakunapruk N. Clinical evidence on dietary supplementation with chia seed (Salvia hispanica L.): a systematic review and meta-analysis. Nutr Rev. 2018 Apr 1;76(4):219-242. doi: 10.1093/nutrit/nux071. PMID: 29452425. [*]",
      "link": "https://pubmed.ncbi.nlm.nih.gov/29452425/"
    },
    "prods": [
      {
        "text": "Perfect Kibble Beef",
        "link": "/products/perfect-kibble-beef"
      },
      {
        "text": "Perfect Kibble Chicken",
        "link": "/products/perfect-kibble"
      },
      {
        "text": "Perfect Dog Food Mix",
        "link": "/products/perfect-dog-food-mix"
      }
    ]
  },
  {
    "ing": [
      "Chia seeds",
      "High omega-3"
    ],
    "dsc": "Alpha-linolenic acid (high in chia seeds) protects against stroke and neuro damage in rats.",
    "journal": "BioMed Research International, 2015",
    "citation": {
      "text": "Blondeau N, Lipsky RH, Bourourou M, Duncan MW, Gorelick PB, Marini AM. Alpha-linolenic acid: an omega-3 fatty acid with neuroprotective properties-ready for use in the stroke clinic?. Biomed Res Int. 2015;2015:519830. doi:10.1155/2015/519830 [*]",
      "link": "https://www.ncbi.nlm.nih.gov/pmc/articles/PMC4350958/"
    },
    "prods": [
      {
        "text": "Perfect Kibble Beef",
        "link": "/products/perfect-kibble-beef"
      },
      {
        "text": "Perfect Kibble Chicken",
        "link": "/products/perfect-kibble"
      },
      {
        "text": "Perfect Dog Food Mix",
        "link": "/products/perfect-dog-food-mix"
      }
    ]
  },
  {
    "ing": [
      "Chia seeds",
      "High omega-3"
    ],
    "dsc": "Alpha-linolenic acid is an antioxidant appropriate for treating diabetes, vascular disease, hypertension, and inflammation.",
    "journal": "Biochim Biophys Acta, 2009",
    "citation": {
      "text": "Shay KP, Moreau RF, Smith EJ, Smith AR, Hagen TM. Alpha-lipoic acid as a dietary supplement: molecular mechanisms and therapeutic potential. Biochim Biophys Acta. 2009;1790(10):1149-1160. doi:10.1016/j.bbagen.2009.07.026 [*]",
      "link": "https://www.ncbi.nlm.nih.gov/pmc/articles/PMC2756298/"
    },
    "prods": [
      {
        "text": "Perfect Kibble Beef",
        "link": "/products/perfect-kibble-beef"
      },
      {
        "text": "Perfect Kibble Chicken",
        "link": "/products/perfect-kibble"
      },
      {
        "text": "Perfect Dog Food Mix",
        "link": "/products/perfect-dog-food-mix"
      }
    ]
  },
  {
    "ing": [
      "Chia seeds",
      "High omega-3"
    ],
    "dsc": "Alpha-linolenic acid affects LDL cholesterol more effectively than EPA/DHA.",
    "journal": "European Journal of Clinical Nutrition, 2006",
    "citation": {
      "text": "Goyens PL, Mensink RP. Effects of alpha-linolenic acid versus those of EPA/DHA on cardiovascular risk markers in healthy elderly subjects. Eur J Clin Nutr. 2006 Aug;60(8):978-84. doi: 10.1038/sj.ejcn.1602408. Epub 2006 Feb 15. PMID: 16482073. [*]",
      "link": "https://pubmed.ncbi.nlm.nih.gov/16482073/"
    },
    "prods": [
      {
        "text": "Perfect Kibble Beef",
        "link": "/products/perfect-kibble-beef"
      },
      {
        "text": "Perfect Kibble Chicken",
        "link": "/products/perfect-kibble"
      },
      {
        "text": "Perfect Dog Food Mix",
        "link": "/products/perfect-dog-food-mix"
      }
    ]
  },
  {
    "ing": [
      "Coconut oil"
    ],
    "dsc": "Owners commonly reported opting for coconut oil after their dogs receive a diagnosis of idiopathic epilepsy (IE).",
    "journal": "Research in Veterinary Science, 2018",
    "citation": {
      "text": "Berk BA, Packer RMA, Law TH, Volk HA. Investigating owner use of dietary supplements in dogs with idiopathic epilepsy. Res Vet Sci. 2018 Aug;119:276-284. doi: 10.1016/j.rvsc.2018.07.004. Epub 2018 Jul 24. PMID: 30064067. [*]",
      "link": "https://pubmed.ncbi.nlm.nih.gov/30064067/"
    },
    "prods": [
      {
        "text": "Perfect Kibble Beef",
        "link": "/products/perfect-kibble-beef"
      },
      {
        "text": "Perfect Kibble Chicken",
        "link": "/products/perfect-kibble"
      }
    ]
  },
  {
    "ing": [
      "Coconut oil"
    ],
    "dsc": "Administration of a specialised diet (including coconut oil) lead to a significant reduction in seizures.",
    "journal": "Epilepsia Open, 2019",
    "citation": {
      "text": "Masino, SA, Freedgood, NR, Reichert, HR, Director, CJ, Whittemore, VH, Zupec-Kania, B. Dietary intervention for canine epilepsy: Two case reports. Epilepsia Open. 2019; 4: 193– 199. https://doi.org/10.1002/epi4.12305 [*]",
      "link": "https://www.ncbi.nlm.nih.gov/pmc/articles/PMC6398089/"
    },
    "prods": [
      {
        "text": "Perfect Kibble Beef",
        "link": "/products/perfect-kibble-beef"
      },
      {
        "text": "Perfect Kibble Chicken",
        "link": "/products/perfect-kibble"
      }
    ]
  },
  {
    "ing": [
      "Coconut oil"
    ],
    "dsc": "Administration of triglyceride oils (around half of which was coconut oil) led to significant reduction in seizures.",
    "journal": "The Veterinary Record, 2020",
    "citation": {
      "text": "Molina J, Jean-Philippe C, Conboy L, Añor S, de la Fuente C, Wrzosek MA, Spycher A, Luchsinger E, Wenger-Riggenbach B, Montoliu P, Gandini G, Menchetti M, Ribeiro JC, Varejão A, Ferreira A, Zanghi B, Volk HA. Efficacy of medium Chian triglyceride oil dietary supplementation in reducing seizure frequency in dogs with idiopathic epilepsy without cluster seizures: a non-blinded, prospective clinical trial. Vet Rec. 2020 Oct 31;187(9):356. doi: 10.1136/vr.105410. Epub 2020 Jun 12. PMID: 32532842; PMCID: PMC7799411. [*]",
      "link": "https://pubmed.ncbi.nlm.nih.gov/32532842/"
    },
    "prods": [
      {
        "text": "Perfect Kibble Beef",
        "link": "/products/perfect-kibble-beef"
      },
      {
        "text": "Perfect Kibble Chicken",
        "link": "/products/perfect-kibble"
      }
    ]
  },
  {
    "ing": [
      "Coconut oil"
    ],
    "dsc": "Review of studies for dogs, humans, and rats found MCTs (including coconut oil) led to a signficant decrease in epileptic symptoms.",
    "journal": "Epilepsia, 2021",
    "citation": {
      "text": "Han FY, Conboy-Schmidt L, Rybachuk G, Volk HA, Zanghi B, Pan Y, Borges K. Dietary medium Chian triglycerides for management of epilepsy: New data from human, dog, and rodent studies. Epilepsia. 2021 Aug;62(8):1790-1806. doi: 10.1111/epi.16972. Epub 2021 Jun 25. PMID: 34169513; PMCID: PMC8453917. [*]",
      "link": "https://pubmed.ncbi.nlm.nih.gov/34169513/"
    },
    "prods": [
      {
        "text": "Perfect Kibble Beef",
        "link": "/products/perfect-kibble-beef"
      },
      {
        "text": "Perfect Kibble Chicken",
        "link": "/products/perfect-kibble"
      }
    ]
  },
  {
    "ing": [
      "Coconut oil"
    ],
    "dsc": "Medium-Chian triglycerides (like coconut oil) prevent alcohol-induced liver injury in rats.",
    "journal": "American Journal of Physiology, 2000",
    "citation": {
      "text": "Kono H, Enomoto N, Connor HD, Wheeler MD, Bradford BU, Rivera CA, Kadiiska MB, Mason RP, Thurman RG. Medium-Chian triglycerides inhibit free radical formation and TNF-alpha production in rats given enteral ethanol. Am J Physiol Gastrointest Liver Physiol. 2000 Mar;278(3):G467-76. doi: 10.1152/ajpgi.2000.278.3.G467. PMID: 10712267. [*]",
      "link": "https://pubmed.ncbi.nlm.nih.gov/10712267/"
    },
    "prods": [
      {
        "text": "Perfect Kibble Beef",
        "link": "/products/perfect-kibble-beef"
      },
      {
        "text": "Perfect Kibble Chicken",
        "link": "/products/perfect-kibble"
      }
    ]
  },
  {
    "ing": [
      "Coconut oil"
    ],
    "dsc": "Review: coconut oil may prevent hair damage, helps weight loss, and benefics cardiovascular disease.",
    "journal": "Journal of the American College of Nutrition, 2019",
    "citation": {
      "text": "Wallace TC. Health Effects of Coconut Oil-A Narrative Review of Current Evidence. J Am Coll Nutr. 2019 Feb;38(2):97-107. doi: 10.1080/07315724.2018.1497562. Epub 2018 Nov 5. PMID: 30395784. [*]",
      "link": "https://pubmed.ncbi.nlm.nih.gov/30395784/"
    },
    "prods": [
      {
        "text": "Perfect Kibble Beef",
        "link": "/products/perfect-kibble-beef"
      },
      {
        "text": "Perfect Kibble Chicken",
        "link": "/products/perfect-kibble"
      }
    ]
  },
  {
    "ing": [
      "Coconut oil",
      "Anti-inflammatory"
    ],
    "dsc": "Coconul oil has anti-inflammatry, analgesic, and anti-fever properties.",
    "journal": "Pharmaceutical Biology, 2010",
    "citation": {
      "text": "Intahphuak S, Khonsung P, Panthong A. Anti-inflammatory, analgesic, and antipyretic activities of virgin coconut oil. Pharm Biol. 2010 Feb;48(2):151-7. doi: 10.3109/13880200903062614. PMID: 20645831. [*]",
      "link": "https://pubmed.ncbi.nlm.nih.gov/20645831/"
    },
    "prods": [
      {
        "text": "Perfect Kibble Beef",
        "link": "/products/perfect-kibble-beef"
      },
      {
        "text": "Perfect Kibble Chicken",
        "link": "/products/perfect-kibble"
      }
    ]
  },
  {
    "ing": [
      "Coconut oil"
    ],
    "dsc": "Medium-Chian triglycerides improve cognitive functioning and manage cognitive dysfunction syndrome in dogs.",
    "journal": "Frontiers in Nutrition, 2018",
    "citation": {
      "text": "Pan Y, Landsberg G, Mougeot I, et al. Efficacy of a Therapeutic Diet on Dogs With Signs of Cognitive Dysfunction Syndrome (CDS): A Prospective Double Blinded Placebo Controlled Clinical Study. Front Nutr. 2018;5:127. Published 2018 Dec 12. doi:10.3389/fnut.2018.00127 [*]",
      "link": "https://www.ncbi.nlm.nih.gov/pmc/articles/PMC6299068/"
    },
    "prods": [
      {
        "text": "Perfect Kibble Beef",
        "link": "/products/perfect-kibble-beef"
      },
      {
        "text": "Perfect Kibble Chicken",
        "link": "/products/perfect-kibble"
      }
    ]
  },
  {
    "ing": [
      "Coconut oil"
    ],
    "dsc": "Coconut oil has attracted attention due to its hypocholesterolemic, anticancer, antihepatosteatotic, antidiabetic, antioxidant, anti-inflammatory, antimicrobial and skin moisturizing properties.",
    "journal": "Journal of the Science of Food and Agriculture, 2021",
    "citation": {
      "text": "Deen A, Visvanathan R, Wickramarachchi D, Marikkar N, Nammi S, Jayawardana BC, Liyanage R. Chemical composition and health benefits of coconut oil: an overview. J Sci Food Agric. 2021 Apr;101(6):2182-2193. doi: 10.1002/jsfa.10870. Epub 2020 Oct 29. PMID: 33022082. [*]",
      "link": "https://pubmed.ncbi.nlm.nih.gov/33022082/"
    },
    "prods": [
      {
        "text": "Perfect Kibble Beef",
        "link": "/products/perfect-kibble-beef"
      },
      {
        "text": "Perfect Kibble Chicken",
        "link": "/products/perfect-kibble"
      }
    ]
  },
  {
    "ing": [
      "Coconut oil"
    ],
    "dsc": "Limited studies showed that topical use of coconut oil helps in the prevention and treatment of atopic dermatitis and oil pulling for the prevention of dental caries.",
    "journal": "Diabetes & Metabolic Syndrome, 2021",
    "citation": {
      "text": "Jayawardena R, Swarnamali H, Ranasinghe P, Misra A. Health effects of coconut oil: Summary of evidence from systematic reviews and meta-analysis of interventional studies. Diabetes Metab Syndr. 2021 Mar-Apr;15(2):549-555. doi: 10.1016/j.dsx.2021.02.032. Epub 2021 Mar 3. PMID: 33689936. [*]",
      "link": "https://pubmed.ncbi.nlm.nih.gov/33689936/"
    },
    "prods": [
      {
        "text": "Perfect Kibble Beef",
        "link": "/products/perfect-kibble-beef"
      },
      {
        "text": "Perfect Kibble Chicken",
        "link": "/products/perfect-kibble"
      }
    ]
  },
  {
    "ing": [
      "Coconut oil"
    ],
    "dsc": "Compared with animal oils, coconut oil demonstrated a better lipid profile in comparison with plant oils, coconut oil significantly increased HDL-C and LDL-C.",
    "journal": "Nutrition Reviews, 2020",
    "citation": {
      "text": "Teng M, Zhao YJ, Khoo AL, Yeo TC, Yong QW, Lim BP. Impact of coconut oil consumption on cardiovascular health: a systematic review and meta-analysis. Nutr Rev. 2020 Mar 1;78(3):249-259. doi: 10.1093/nutrit/nuz074. PMID: 31769848. [*]",
      "link": "https://pubmed.ncbi.nlm.nih.gov/31769848/"
    },
    "prods": [
      {
        "text": "Perfect Kibble Beef",
        "link": "/products/perfect-kibble-beef"
      },
      {
        "text": "Perfect Kibble Chicken",
        "link": "/products/perfect-kibble"
      }
    ]
  },
  {
    "ing": [
      "Cranberries"
    ],
    "dsc": "Cranberry may have a slightly protectative effect against E. coli UTIs.",
    "journal": "Journal of Veterinary Internal Medicine, 2017",
    "citation": {
      "text": "Olby, N J et al. “Effect of Cranberry Extract on the Frequency of Bacteriuria in Dogs with Acute Thoracolumbar Disk Herniation: A Randomized Controlled Clinical Trial.” Journal of veterinary internal medicine vol. 31,1 (2017): 60-68. doi:10.1111/jvim.14613 [*]",
      "link": "https://www.ncbi.nlm.nih.gov/pmc/articles/PMC5259620/"
    },
    "prods": [
      {
        "text": "Perfect Kibble Beef",
        "link": "/products/perfect-kibble-beef"
      },
      {
        "text": "Perfect Kibble Chicken",
        "link": "/products/perfect-kibble"
      },
      {
        "text": "Perfect Dog Food Mix",
        "link": "/products/perfect-dog-food-mix"
      }
    ]
  },
  {
    "ing": [
      "Cranberries"
    ],
    "dsc": "Oral administration of cranberry extract prevented development of a UTI and prevented E coli adherence to MDCK cells, which may indicate it has benefit for preventing UTIs in dogs.",
    "journal": "American Journal of Veterinary Research, 2016",
    "citation": {
      "text": "Chou HI, Chen KS, Wang HC, Lee WM. Effects of cranberry extract on prevention of urinary tract infection in dogs and on adhesion of Escherichia coli to Madin-Darby canine kidney cells. Am J Vet Res. 2016 Apr;77(4):421-7. doi: 10.2460/ajvr.77.4.421. PMID: 27027843. [*]",
      "link": "https://pubmed.ncbi.nlm.nih.gov/27027843/"
    },
    "prods": [
      {
        "text": "Perfect Kibble Beef",
        "link": "/products/perfect-kibble-beef"
      },
      {
        "text": "Perfect Kibble Chicken",
        "link": "/products/perfect-kibble"
      },
      {
        "text": "Perfect Dog Food Mix",
        "link": "/products/perfect-dog-food-mix"
      }
    ]
  },
  {
    "ing": [
      "Cranberries"
    ],
    "dsc": "Cranberry extracts did not induce significant changes in fecel microbiota, nor body mass gains.",
    "journal": "AIMS Microbiology, 2021",
    "citation": {
      "text": "Chettaoui R, Mayot G, De Almeida L, Di Martino P. Cranberry (Vaccinium macrocarpon) dietary supplementation and fecal microbiota of Wistar rats. AIMS Microbiol. 2021;7(2):257-270. Published 2021 Jun 30. doi:10.3934/microbiol.2021016 [*]",
      "link": "https://www.ncbi.nlm.nih.gov/pmc/articles/PMC8255906/"
    },
    "prods": [
      {
        "text": "Perfect Kibble Beef",
        "link": "/products/perfect-kibble-beef"
      },
      {
        "text": "Perfect Kibble Chicken",
        "link": "/products/perfect-kibble"
      },
      {
        "text": "Perfect Dog Food Mix",
        "link": "/products/perfect-dog-food-mix"
      }
    ]
  },
  {
    "ing": [
      "Cranberries"
    ],
    "dsc": "Review: cranberries contain flavonoids which protect again atherosclerosis.",
    "journal": "Critical Reviews in Food Science and Nutrition, 2002",
    "citation": {
      "text": "Reed J. Cranberry flavonoids, atherosclerosis and cardiovascular health. Crit Rev Food Sci Nutr. 2002;42(3 Suppl):301-16. doi: 10.1080/10408390209351919. PMID: 12058989. [*]",
      "link": "https://pubmed.ncbi.nlm.nih.gov/12058989/"
    },
    "prods": [
      {
        "text": "Perfect Kibble Beef",
        "link": "/products/perfect-kibble-beef"
      },
      {
        "text": "Perfect Kibble Chicken",
        "link": "/products/perfect-kibble"
      },
      {
        "text": "Perfect Dog Food Mix",
        "link": "/products/perfect-dog-food-mix"
      }
    ]
  },
  {
    "ing": [
      "Cranberries"
    ],
    "dsc": "Cranberries may reduce the risk of urinary tract infections (UTIs).",
    "journal": "Clinics, 2012",
    "citation": {
      "text": "Hisano M, Bruschini H, Nicodemo AC, Srougi M. Cranberries and lower urinary tract infection prevention. Clinics (Sao Paulo). 2012;67(6):661-668. doi:10.6061/clinics/2012(06)18 [*]",
      "link": "https://www.ncbi.nlm.nih.gov/pmc/articles/PMC3370320/"
    },
    "prods": [
      {
        "text": "Perfect Kibble Beef",
        "link": "/products/perfect-kibble-beef"
      },
      {
        "text": "Perfect Kibble Chicken",
        "link": "/products/perfect-kibble"
      },
      {
        "text": "Perfect Dog Food Mix",
        "link": "/products/perfect-dog-food-mix"
      }
    ]
  },
  {
    "ing": [
      "Cranberries"
    ],
    "dsc": "Cranberries prevent UTIs, and phytochemicals modulate gut microbiotia - potentially beneficial for CKD complications.",
    "journal": "Food & Function, 2019",
    "citation": {
      "text": "de Almeida Alvarenga L , Borges NA , Moreira LSG , Resende Teixeira KT , Carraro-Eduardo JC , Dai L , Stenvinkel P , Lindholm B , Mafra D . Cranberries - potential benefits in patients with chronic kidney disease. Food Funct. 2019 Jun 19;10(6):3103-3112. doi: 10.1039/c9fo00375d. PMID: 31140512. [*]",
      "link": "https://pubmed.ncbi.nlm.nih.gov/31140512/"
    },
    "prods": [
      {
        "text": "Perfect Kibble Beef",
        "link": "/products/perfect-kibble-beef"
      },
      {
        "text": "Perfect Kibble Chicken",
        "link": "/products/perfect-kibble"
      },
      {
        "text": "Perfect Dog Food Mix",
        "link": "/products/perfect-dog-food-mix"
      }
    ]
  },
  {
    "ing": [
      "Cranberries"
    ],
    "dsc": "Review: Cranberries are a distinct source of flavonoids and phenolic acids that protect against UTIs.",
    "journal": "Molecules, 2020",
    "citation": {
      "text": "González de Llano D, Moreno-Arribas MV, Bartolomé B. Cranberry Polyphenols and Prevention against Urinary Tract Infections: Relevant Considerations. Molecules. 2020;25(15):3523. Published 2020 Aug 1. doi:10.3390/molecules25153523 [*]",
      "link": "https://www.ncbi.nlm.nih.gov/pmc/articles/PMC7436188/"
    },
    "prods": [
      {
        "text": "Perfect Kibble Beef",
        "link": "/products/perfect-kibble-beef"
      },
      {
        "text": "Perfect Kibble Chicken",
        "link": "/products/perfect-kibble"
      },
      {
        "text": "Perfect Dog Food Mix",
        "link": "/products/perfect-dog-food-mix"
      }
    ]
  },
  {
    "ing": [
      "Cranberries",
      "High antioxidants"
    ],
    "dsc": "Cranberry extract equivalent to synthetic antioxidants.",
    "journal": "Journal of Veterinary Research, 2018",
    "citation": {
      "text": "Glodde F, Günal M, Kinsel ME, AbuGhazaleh A. Effects of Natural Antioxidants on The Stability of Omega-3 Fatty Acids in Dog Food. J Vet Res. 2018 Mar 30;62(1):103-108. doi: 10.1515/jvetres-2018-0014. PMID: 29978134; PMCID: PMC5957468. [*]",
      "link": "https://pubmed.ncbi.nlm.nih.gov/29978134/"
    },
    "prods": [
      {
        "text": "Perfect Kibble Beef",
        "link": "/products/perfect-kibble-beef"
      },
      {
        "text": "Perfect Kibble Chicken",
        "link": "/products/perfect-kibble"
      },
      {
        "text": "Perfect Dog Food Mix",
        "link": "/products/perfect-dog-food-mix"
      }
    ]
  },
  {
    "ing": [
      "Eggs"
    ],
    "dsc": "Chicken egg white derivatives enhance the fuction of white blood cells.",
    "journal": "Journal of Veterinary Medical Science, 1995",
    "citation": {
      "text": "Hirota Y, Yang MP, Araki S, Yoshihara K, Furusawa S, Yasuda M, Mohamed A, Matsumoto Y, Onodera T. Enhancing effects of chicken egg white derivatives on the phagocytic response in the dog. J Vet Med Sci. 1995 Oct;57(5):825-9. doi: 10.1292/jvms.57.825. PMID: 8593287. [*]",
      "link": "https://pubmed.ncbi.nlm.nih.gov/8593287/"
    },
    "prods": [
      {
        "text": "Perfect Kibble Beef",
        "link": "/products/perfect-kibble-beef"
      },
      {
        "text": "Perfect Kibble Chicken",
        "link": "/products/perfect-kibble"
      }
    ]
  },
  {
    "ing": [
      "Eggs"
    ],
    "dsc": "Eggs can be beneficial to chronic kidney disease patients - high in minerals and leucine.",
    "journal": "Nutrients, 2018",
    "citation": {
      "text": "Tallman DA, Sahathevan S, Karupaiah T, Khosla P. Egg Intake in Chronic Kidney Disease. Nutrients. 2018 Dec 7;10(12):1945. doi: 10.3390/nu10121945. PMID: 30544535; PMCID: PMC6315879. [*]",
      "link": "https://pubmed.ncbi.nlm.nih.gov/30544535/"
    },
    "prods": [
      {
        "text": "Perfect Kibble Beef",
        "link": "/products/perfect-kibble-beef"
      },
      {
        "text": "Perfect Kibble Chicken",
        "link": "/products/perfect-kibble"
      }
    ]
  },
  {
    "ing": [
      "Eggs"
    ],
    "dsc": "Selenium deficiency may play a role in fertility, parasitical diseases, and cancer in dogs. (Eggs are a source of selenium).",
    "journal": "Animals, 2021",
    "citation": {
      "text": "Zentrichová V, Pechová A, Kovaříková S. Selenium and Dogs: A Systematic Review. Animals (Basel). 2021;11(2):418. Published 2021 Feb 6. doi:10.3390/ani11020418 [*]",
      "link": "https://www.ncbi.nlm.nih.gov/pmc/articles/PMC7915357/"
    },
    "prods": [
      {
        "text": "Perfect Kibble Beef",
        "link": "/products/perfect-kibble-beef"
      },
      {
        "text": "Perfect Kibble Chicken",
        "link": "/products/perfect-kibble"
      }
    ]
  },
  {
    "ing": [
      "Eggs"
    ],
    "dsc": "Eggs appear to be safe for people with heart conditions.",
    "journal": "Nutrition, 2017",
    "citation": {
      "text": "Clayton ZS, Fusco E, Kern M. Egg consumption and heart health: A review. Nutrition. 2017 May;37:79-85. doi: 10.1016/j.nut.2016.12.014. Epub 2016 Dec 29. PMID: 28359368. [*]",
      "link": "https://pubmed.ncbi.nlm.nih.gov/28359368/"
    },
    "prods": [
      {
        "text": "Perfect Kibble Beef",
        "link": "/products/perfect-kibble-beef"
      },
      {
        "text": "Perfect Kibble Chicken",
        "link": "/products/perfect-kibble"
      }
    ]
  },
  {
    "ing": [
      "Eggs"
    ],
    "dsc": "Selenium levels were high in eggs.",
    "journal": "Poultry Science, 1975",
    "citation": {
      "text": "Latshaw JD, Osman M. Distribution of selenium in egg white and yolk after feeding natural and synthetic selenium compounds. Poult Sci. 1975 Jul;54(4):1244-52. doi: 10.3382/ps.0541244. PMID: 1161714. [*]",
      "link": "https://pubmed.ncbi.nlm.nih.gov/1161714/"
    },
    "prods": [
      {
        "text": "Perfect Kibble Beef",
        "link": "/products/perfect-kibble-beef"
      },
      {
        "text": "Perfect Kibble Chicken",
        "link": "/products/perfect-kibble"
      }
    ]
  },
  {
    "ing": [
      "Eggs"
    ],
    "dsc": "Dogs and cats overfed selenium did not show signs of selenosis.",
    "journal": "Journal of Animal Science, 2012",
    "citation": {
      "text": "Todd SE, Thomas DG, Bosch G, Hendriks WH. Selenium status in adult cats and dogs fed high levels of dietary inorganic and organic selenium. J Anim Sci. 2012 Aug;90(8):2549-55. doi: 10.2527/jas.2011-3911. Epub 2012 Feb 3. PMID: 22307479. [*]",
      "link": "https://pubmed.ncbi.nlm.nih.gov/22307479/"
    },
    "prods": [
      {
        "text": "Perfect Kibble Beef",
        "link": "/products/perfect-kibble-beef"
      },
      {
        "text": "Perfect Kibble Chicken",
        "link": "/products/perfect-kibble"
      }
    ]
  },
  {
    "ing": [
      "Eggs",
      "Minimally-processed"
    ],
    "dsc": "Lower selenim digestibility in canned versus kibble diets.",
    "journal": "PLoS One, 2016",
    "citation": {
      "text": "van Zelst M, Hesta M, Gray K, Beech K, Cools A, Alexander LG, Du Laing G, Janssens GP. Selenium Digestibility and Bioactivity in Dogs: What the Can Can, the Kibble Can't. PLoS One. 2016 Apr 4;11(4):e0152709. doi: 10.1371/journal.pone.0152709. PMID: 27043433; PMCID: PMC4820116. [*]",
      "link": "https://pubmed.ncbi.nlm.nih.gov/27043433/"
    },
    "prods": [
      {
        "text": "Perfect Kibble Beef",
        "link": "/products/perfect-kibble-beef"
      },
      {
        "text": "Perfect Kibble Chicken",
        "link": "/products/perfect-kibble"
      }
    ]
  },
  {
    "ing": [
      "Eggs"
    ],
    "dsc": "Overview of nutritional value of eggs: strong protein and nutrient profile.",
    "journal": "Nutrients, 2019",
    "citation": {
      "text": "Réhault-Godbert S, Guyot N, Nys Y. The Golden Egg: Nutritional Value, Bioactivities, and Emerging Benefits for Human Health. Nutrients. 2019;11(3):684. Published 2019 Mar 22. doi:10.3390/nu11030684 [*]",
      "link": "https://www.ncbi.nlm.nih.gov/pmc/articles/PMC6470839/"
    },
    "prods": [
      {
        "text": "Perfect Kibble Beef",
        "link": "/products/perfect-kibble-beef"
      },
      {
        "text": "Perfect Kibble Chicken",
        "link": "/products/perfect-kibble"
      }
    ]
  },
  {
    "ing": [
      "Eggs"
    ],
    "dsc": "Egg-protein diets useful in helping dogs with induced chronic renal failure.",
    "journal": "Journal of Veterinary Internal Medicine, 1988",
    "citation": {
      "text": "Polzin DJ, Osborne CA. The importance of egg protein in reduced protein diets designed for dogs with renal failure. J Vet Intern Med. 1988 Jan-Mar;2(1):15-21. doi: 10.1111/j.1939-1676.1988.tb01972.x. PMID: 3221351. [*]",
      "link": "https://pubmed.ncbi.nlm.nih.gov/3221351/"
    },
    "prods": [
      {
        "text": "Perfect Kibble Beef",
        "link": "/products/perfect-kibble-beef"
      },
      {
        "text": "Perfect Kibble Chicken",
        "link": "/products/perfect-kibble"
      }
    ]
  },
  {
    "ing": [
      "Flaxseed",
      "Anti-inflammatory"
    ],
    "dsc": "Flaxseed supplementation reduced the expression of inflammation-related genes in dogs.",
    "journal": "Genetics and Molecular Research, 2014",
    "citation": {
      "text": "Purushothaman D, Brown WY, Vanselow BA, Quinn K, Wu SB. Flaxseed oil supplementation alters the expression of inflammatory-related genes in dogs. Genet Mol Res. 2014 Jul 24;13(3):5322-32. doi: 10.4238/2014.July.24.11. PMID: 25078588. [*]",
      "link": "https://pubmed.ncbi.nlm.nih.gov/25078588/%20"
    },
    "prods": [
      {
        "text": "Perfect Kibble Beef",
        "link": "/products/perfect-kibble-beef"
      },
      {
        "text": "Perfect Kibble Chicken",
        "link": "/products/perfect-kibble"
      },
      {
        "text": "Perfect Dog Food Mix",
        "link": "/products/perfect-dog-food-mix"
      }
    ]
  },
  {
    "ing": [
      "Flaxseed",
      "Anti-inflammatory"
    ],
    "dsc": "Flaxseed supplementation improved kidney function and reduced systemating inflammation and oxidative stress in diabetic rats.",
    "journal": "PLoS One, 2021",
    "citation": {
      "text": "Al Za’abi M, Ali H, Ali BH (2021) Effect of flaxseed on systemic inflammation and oxidative stress in diabetic rats with or without chronic kidney disease. PLoS ONE 16(10): e0258800. https://doi.org/10.1371/journal.pone.0258800 [*]",
      "link": "https://www.ncbi.nlm.nih.gov/pmc/articles/PMC8525749/"
    },
    "prods": [
      {
        "text": "Perfect Kibble Beef",
        "link": "/products/perfect-kibble-beef"
      },
      {
        "text": "Perfect Kibble Chicken",
        "link": "/products/perfect-kibble"
      },
      {
        "text": "Perfect Dog Food Mix",
        "link": "/products/perfect-dog-food-mix"
      }
    ]
  },
  {
    "ing": [
      "Flaxseed"
    ],
    "dsc": "Overview of flaxseed nutrients: rich in fibre, omega-3s, protein, alpha-linolenic acid, lignans, and more",
    "journal": "Critical Reviews in Food Science and Nutrition, 2011",
    "citation": {
      "text": "Singh KK, Mridula D, Rehal J, Barnwal P. Flaxseed: a potential source of food, feed and fiber. Crit Rev Food Sci Nutr. 2011 Mar;51(3):210-22. doi: 10.1080/10408390903537241. PMID: 21390942. [*]",
      "link": "https://pubmed.ncbi.nlm.nih.gov/21390942/"
    },
    "prods": [
      {
        "text": "Perfect Kibble Beef",
        "link": "/products/perfect-kibble-beef"
      },
      {
        "text": "Perfect Kibble Chicken",
        "link": "/products/perfect-kibble"
      },
      {
        "text": "Perfect Dog Food Mix",
        "link": "/products/perfect-dog-food-mix"
      }
    ]
  },
  {
    "ing": [
      "Flaxseed"
    ],
    "dsc": "High fibre diets are prebiotic - producing substantial changes in a dog's guy microbiome (flaxseeds are rich in soluble fibre).",
    "journal": "Frontiers in Microbiology, 2020",
    "citation": {
      "text": "Wernimont SM, Radosevich J, Jackson MI, Ephraim E, Badri DV, MacLeay JM, Jewell DE and Suchodolski JS (2020) The Effects of Nutrition on the Gastrointestinal Microbiome of Cats and Dogs: Impact on Health and Disease. Front. Microbiol. 11:1266. doi: 10.3389/fmicb.2020.01266 [*]",
      "link": "https://www.ncbi.nlm.nih.gov/pmc/articles/PMC7329990/"
    },
    "prods": [
      {
        "text": "Perfect Kibble Beef",
        "link": "/products/perfect-kibble-beef"
      },
      {
        "text": "Perfect Kibble Chicken",
        "link": "/products/perfect-kibble"
      },
      {
        "text": "Perfect Dog Food Mix",
        "link": "/products/perfect-dog-food-mix"
      }
    ]
  },
  {
    "ing": [
      "Flaxseed"
    ],
    "dsc": "Flaxseed supplementation led to a significant improvement in skin and coat condition after 28 days.",
    "journal": "Veterinary Dermatology, 2001",
    "citation": {
      "text": "Rees CA, Bauer JE, Burkholder WJ, Kennis RA, Dunbar BL, Bigley KE. Effects of dietary flax seed and sunflower seed supplementation on normal canine serum polyunsaturated fatty acids and skin and hair coat condition scores. Vet Dermatol. 2001 Apr;12(2):111-7. doi: 10.1046/j.1365-3164.2001.00234.x. PMID: 11360337. [*]",
      "link": "https://pubmed.ncbi.nlm.nih.gov/11360337/"
    },
    "prods": [
      {
        "text": "Perfect Kibble Beef",
        "link": "/products/perfect-kibble-beef"
      },
      {
        "text": "Perfect Kibble Chicken",
        "link": "/products/perfect-kibble"
      },
      {
        "text": "Perfect Dog Food Mix",
        "link": "/products/perfect-dog-food-mix"
      }
    ]
  },
  {
    "ing": [
      "Flaxseed",
      "High antioxidants"
    ],
    "dsc": "Flaxseed oil saw improved outcomes during endotoxaemic shock (in dogs) - condition linked to heart disease and type II diabetes.",
    "journal": "Journal of Cardiovascular Pharmacology and Therapeutics, 1998",
    "citation": {
      "text": "Pattanaik U, Prasad K. Oxygen Free Radicals and Endotoxic Shock: Effect of Flaxseed. J Cardiovasc Pharmacol Ther. 1998 Oct;3(4):305-318. doi: 10.1177/107424849800300406. PMID: 10684513. [*]",
      "link": "https://pubmed.ncbi.nlm.nih.gov/10684513/"
    },
    "prods": [
      {
        "text": "Perfect Kibble Beef",
        "link": "/products/perfect-kibble-beef"
      },
      {
        "text": "Perfect Kibble Chicken",
        "link": "/products/perfect-kibble"
      },
      {
        "text": "Perfect Dog Food Mix",
        "link": "/products/perfect-dog-food-mix"
      }
    ]
  },
  {
    "ing": [
      "Flaxseed"
    ],
    "dsc": "Flaxseed protects against cancer, improved liver function, and increased longevity in hens.",
    "journal": "Molecules, 2021",
    "citation": {
      "text": "Weston WC, Hales KH, Hales DB. Flaxseed Increases Animal Lifespan and Reduces Ovarian Cancer Severity by Toxically Augmenting One-Carbon Metabolism. Molecules. 2021;26(18):5674. Published 2021 Sep 18. doi:10.3390/molecules26185674 [*]",
      "link": "https://www.ncbi.nlm.nih.gov/pmc/articles/PMC8471351/"
    },
    "prods": [
      {
        "text": "Perfect Kibble Beef",
        "link": "/products/perfect-kibble-beef"
      },
      {
        "text": "Perfect Kibble Chicken",
        "link": "/products/perfect-kibble"
      },
      {
        "text": "Perfect Dog Food Mix",
        "link": "/products/perfect-dog-food-mix"
      }
    ]
  },
  {
    "ing": [
      "Flaxseed"
    ],
    "dsc": "Flaxseed lignans may benefit cancer prevention and treatment.",
    "journal": "Pharmaceuticals, 2019",
    "citation": {
      "text": "De Silva SF, Alcorn J. Flaxseed Lignans as Important Dietary Polyphenols for Cancer Prevention and Treatment: Chemistry, Pharmacokinetics, and Molecular Targets. Pharmaceuticals (Basel). 2019;12(2):68. Published 2019 May 5. doi:10.3390/ph12020068 [*]",
      "link": "https://www.ncbi.nlm.nih.gov/pmc/articles/PMC6630319/"
    },
    "prods": [
      {
        "text": "Perfect Kibble Beef",
        "link": "/products/perfect-kibble-beef"
      },
      {
        "text": "Perfect Kibble Chicken",
        "link": "/products/perfect-kibble"
      },
      {
        "text": "Perfect Dog Food Mix",
        "link": "/products/perfect-dog-food-mix"
      }
    ]
  },
  {
    "ing": [
      "Flaxseed"
    ],
    "dsc": "How alpha-linolenic acid is metabolism from flaxseed in dogs.",
    "journal": "World Review of Nutrition and Dietetics, 1998",
    "citation": {
      "text": "Bibus DM, Stitt PA. Metabolism of alpha-linolenic acid from flaxseed in dogs. World Rev Nutr Diet. 1998;83:186-98. doi: 10.1159/000059664. PMID: 9648515. [*]",
      "link": "https://pubmed.ncbi.nlm.nih.gov/9648515/"
    },
    "prods": [
      {
        "text": "Perfect Kibble Beef",
        "link": "/products/perfect-kibble-beef"
      },
      {
        "text": "Perfect Kibble Chicken",
        "link": "/products/perfect-kibble"
      },
      {
        "text": "Perfect Dog Food Mix",
        "link": "/products/perfect-dog-food-mix"
      }
    ]
  },
  {
    "ing": [
      "Flaxseed"
    ],
    "dsc": "Flaxseed a major source of fibre, essential fatty acids, lignans, and other bioactive molecules.",
    "journal": "Journal of Food Science and Technology, 2015",
    "citation": {
      "text": "Kajla P, Sharma A, Sood DR. Flaxseed-a potential functional food source. J Food Sci Technol. 2015;52(4):1857-1871. doi:10.1007/s13197-014-1293-y [*]",
      "link": "https://www.ncbi.nlm.nih.gov/pmc/articles/PMC4375225/"
    },
    "prods": [
      {
        "text": "Perfect Kibble Beef",
        "link": "/products/perfect-kibble-beef"
      },
      {
        "text": "Perfect Kibble Chicken",
        "link": "/products/perfect-kibble"
      },
      {
        "text": "Perfect Dog Food Mix",
        "link": "/products/perfect-dog-food-mix"
      }
    ]
  },
  {
    "ing": [
      "Flaxseed"
    ],
    "dsc": "Flaxseed dietary fibres useful for lowering blood cholesterol and aiding energy balance.",
    "journal": "Nutrition and Metabolism, 2012",
    "citation": {
      "text": "Kristensen M, Jensen MG, Aarestrup J, Petersen KE, Søndergaard L, Mikkelsen MS, Astrup A. Flaxseed dietary fibers lower cholesterol and increase fecal fat excretion, but magnitude of effect depend on food type. Nutr Metab (Lond). 2012 Feb 3;9:8. doi: 10.1186/1743-7075-9-8. PMID: 22305169; PMCID: PMC3307491. [*]",
      "link": "https://pubmed.ncbi.nlm.nih.gov/22305169/"
    },
    "prods": [
      {
        "text": "Perfect Kibble Beef",
        "link": "/products/perfect-kibble-beef"
      },
      {
        "text": "Perfect Kibble Chicken",
        "link": "/products/perfect-kibble"
      },
      {
        "text": "Perfect Dog Food Mix",
        "link": "/products/perfect-dog-food-mix"
      }
    ]
  },
  {
    "ing": [
      "Flaxseed"
    ],
    "dsc": "Flaxseed has benefits associated with cardiovascular disease and cancer.",
    "journal": "Nutrients, 2019",
    "citation": {
      "text": "Parikh M, Maddaford TG, Austria JA, Aliani M, Netticadan T, Pierce GN. Dietary Flaxseed as a Strategy for Improving Human Health. Nutrients. 2019;11(5):1171. Published 2019 May 25. doi:10.3390/nu11051171 [*]",
      "link": "https://www.ncbi.nlm.nih.gov/pmc/articles/PMC6567199/"
    },
    "prods": [
      {
        "text": "Perfect Kibble Beef",
        "link": "/products/perfect-kibble-beef"
      },
      {
        "text": "Perfect Kibble Chicken",
        "link": "/products/perfect-kibble"
      },
      {
        "text": "Perfect Dog Food Mix",
        "link": "/products/perfect-dog-food-mix"
      }
    ]
  },
  {
    "ing": [
      "Flaxseed"
    ],
    "dsc": "Whole flaxseed, but not flaxseed oil and lignan extract, has significant effects on improving glycemic control.",
    "journal": "Nutrition Reviews, 2018",
    "citation": {
      "text": "Mohammadi-Sartang M, Sohrabi Z, Barati-Boldaji R, Raeisi-Dehkordi H, Mazloom Z. Flaxseed supplementation on glucose control and insulin sensitivity: a systematic review and meta-analysis of 25 randomized, placebo-controlled trials. Nutr Rev. 2018 Feb 1;76(2):125-139. doi: 10.1093/nutrit/nux052. PMID: 29228348. [*]",
      "link": "https://pubmed.ncbi.nlm.nih.gov/29228348/"
    },
    "prods": [
      {
        "text": "Perfect Kibble Beef",
        "link": "/products/perfect-kibble-beef"
      },
      {
        "text": "Perfect Kibble Chicken",
        "link": "/products/perfect-kibble"
      },
      {
        "text": "Perfect Dog Food Mix",
        "link": "/products/perfect-dog-food-mix"
      }
    ]
  },
  {
    "ing": [
      "Flaxseed"
    ],
    "dsc": "In animal studies, α-linolenic acids have been shown to be able to suppress growth, size, and proliferation of cancer cells and also to promote breast cancer cell death.",
    "journal": "Frontiers in Nutrition, 2018",
    "citation": {
      "text": "Calado A, Neves PM, Santos T, Ravasco P. The Effect of Flaxseed in Breast Cancer: A Literature Review. Front Nutr. 2018 Feb 7;5:4. doi: 10.3389/fnut.2018.00004. PMID: 29468163; PMCID: PMC5808339. [*]",
      "link": "https://pubmed.ncbi.nlm.nih.gov/29468163/"
    },
    "prods": [
      {
        "text": "Perfect Kibble Beef",
        "link": "/products/perfect-kibble-beef"
      },
      {
        "text": "Perfect Kibble Chicken",
        "link": "/products/perfect-kibble"
      },
      {
        "text": "Perfect Dog Food Mix",
        "link": "/products/perfect-dog-food-mix"
      }
    ]
  },
  {
    "ing": [
      "Flaxseed"
    ],
    "dsc": "The cardiovascular effects of dietary flaxseed have included an antihypertensive action, antiatherogenic effects, a lowering of cholesterol, an anti-inflammatory action, and an inhibition of arrhythmias.",
    "journal": "American Journal of Physiology, 2018",
    "citation": {
      "text": "Parikh M, Netticadan T, Pierce GN. Flaxseed: its bioactive components and their cardiovascular benefits. Am J Physiol Heart Circ Physiol. 2018 Feb 1;314(2):H146-H159. doi: 10.1152/ajpheart.00400.2017. Epub 2017 Nov 3. PMID: 29101172. [*]",
      "link": "https://pubmed.ncbi.nlm.nih.gov/29101172/"
    },
    "prods": [
      {
        "text": "Perfect Kibble Beef",
        "link": "/products/perfect-kibble-beef"
      },
      {
        "text": "Perfect Kibble Chicken",
        "link": "/products/perfect-kibble"
      },
      {
        "text": "Perfect Dog Food Mix",
        "link": "/products/perfect-dog-food-mix"
      }
    ]
  },
  {
    "ing": [
      "Flaxseed"
    ],
    "dsc": "Flaxseeds contain nutrients, lignans, dietary fibre, and essential fatty acids critical for canine health.",
    "journal": "Journal of Food Science and Technology, 2015",
    "citation": {
      "text": "Kajla P, Sharma A, Sood DR. Flaxseed-a potential functional food source. J Food Sci Technol. 2015 Apr;52(4):1857-71. doi: 10.1007/s13197-014-1293-y. Epub 2014 Feb 28. PMID: 25829567; PMCID: PMC4375225. [*]",
      "link": "https://pubmed.ncbi.nlm.nih.gov/25829567/"
    },
    "prods": [
      {
        "text": "Perfect Kibble Beef",
        "link": "/products/perfect-kibble-beef"
      },
      {
        "text": "Perfect Kibble Chicken",
        "link": "/products/perfect-kibble"
      },
      {
        "text": "Perfect Dog Food Mix",
        "link": "/products/perfect-dog-food-mix"
      }
    ]
  },
  {
    "ing": [
      "Flaxseed"
    ],
    "dsc": "Consumption of flaxseed may lower blood pressure slightly. The beneficial potential of flaxseed to reduce blood pressure (especially diastolic blood pressure) may be greater when it is consumed as a whole seed and for a duration of >12 wk.",
    "journal": "Journal of Nutrition, 2015",
    "citation": {
      "text": "Khalesi S, Irwin C, Schubert M. Flaxseed consumption may reduce blood pressure: a systematic review and meta-analysis of controlled trials. J Nutr. 2015 Apr;145(4):758-65. doi: 10.3945/jn.114.205302. Epub 2015 Mar 4. Erratum in: J Nutr. 2015 Nov;145(11):2633. PMID: 25740909. [*]",
      "link": "https://pubmed.ncbi.nlm.nih.gov/25740909/"
    },
    "prods": [
      {
        "text": "Perfect Kibble Beef",
        "link": "/products/perfect-kibble-beef"
      },
      {
        "text": "Perfect Kibble Chicken",
        "link": "/products/perfect-kibble"
      },
      {
        "text": "Perfect Dog Food Mix",
        "link": "/products/perfect-dog-food-mix"
      }
    ]
  },
  {
    "ing": [
      "Fresh beef"
    ],
    "dsc": "Overview of nutritional value of beeef: rich in iron, zinc, selenium, vitamin B12, B vitamins, and biologically useful proteins.",
    "journal": "Bulletin de l'Academie Nationale de Medecine, 2011",
    "citation": {
      "text": "Bourre JM. Apports nutritifs des viandes bovines [Nutritional value of beef]. Bull Acad Natl Med. 2011 Nov;195(8):1787-99. French. PMID: 22844741. [*]",
      "link": "https://pubmed.ncbi.nlm.nih.gov/22844741/"
    },
    "prods": [
      {
        "text": "Perfect Kibble Beef",
        "link": "/products/perfect-kibble-beef"
      },
      {
        "text": "Perfect Kibble Chicken",
        "link": "/products/perfect-kibble"
      }
    ]
  },
  {
    "ing": [
      "Fresh chicken",
      "Minimally-processed"
    ],
    "dsc": "Chicken meal better for digestibility than corn gluten meal for cat food.",
    "journal": "Canadian Journal of Veterinary Research, 2005",
    "citation": {
      "text": "Funaba M, Oka Y, Kobayashi S, et al. Evaluation of meat meal, chicken meal, and corn gluten meal as dietary sources of protein in dry cat food. Can J Vet Res. 2005;69(4):299-304. [*]",
      "link": "https://www.ncbi.nlm.nih.gov/pmc/articles/PMC1250243/"
    },
    "prods": [
      {
        "text": "Perfect Kibble Beef",
        "link": "/products/perfect-kibble-beef"
      },
      {
        "text": "Perfect Kibble Chicken",
        "link": "/products/perfect-kibble"
      }
    ]
  },
  {
    "ing": [
      "Fresh chicken",
      "Minimally-processed",
      "Fresh beef"
    ],
    "dsc": "Human-grade pet foods are highly digestible maintaining normal dog characteristics.",
    "journal": "Journal of Animal Science, 2021",
    "citation": {
      "text": "Do S, Phungviwatnikul T, de Godoy MRC, Swanson KS. Nutrient digestibility and fecal characteristics, microbiota, and metabolites in dogs fed human-grade foods. J Anim Sci. 2021 Feb 1;99(2):skab028. doi: 10.1093/jas/skab028. PMID: 33511410; PMCID: PMC8611730. [*]",
      "link": "https://pubmed.ncbi.nlm.nih.gov/33511410/"
    },
    "prods": [
      {
        "text": "Perfect Kibble Beef",
        "link": "/products/perfect-kibble-beef"
      },
      {
        "text": "Perfect Kibble Chicken",
        "link": "/products/perfect-kibble"
      }
    ]
  },
  {
    "ing": [
      "Fresh chicken"
    ],
    "dsc": "Poultry meat consumption is protective or neutral on cancer risk.",
    "journal": "Food and Nutrition Research, 2015",
    "citation": {
      "text": "Marangoni F, Corsello G, Cricelli C, et al. Role of poultry meat in a balanced diet aimed at maintaining health and wellbeing: an Italian consensus document. Food Nutr Res. 2015;59:27606. Published 2015 Jun 9. doi:10.3402/fnr.v59.27606 [*]",
      "link": "https://www.ncbi.nlm.nih.gov/pmc/articles/PMC4462824/"
    },
    "prods": [
      {
        "text": "Perfect Kibble Beef",
        "link": "/products/perfect-kibble-beef"
      },
      {
        "text": "Perfect Kibble Chicken",
        "link": "/products/perfect-kibble"
      }
    ]
  },
  {
    "ing": [
      "Fresh meat"
    ],
    "dsc": "High protein, high fibre diets improve weight loss in obese dogs.",
    "journal": "Veterinary Journal, 2010",
    "citation": {
      "text": "German AJ, Holden SL, Bissot T, Morris PJ, Biourge V. A high protein high fibre diet improves weight loss in obese dogs. Vet J. 2010 Mar;183(3):294-7. doi: 10.1016/j.tvjl.2008.12.004. Epub 2009 Jan 12. PMID: 19138868. [*]",
      "link": "https://pubmed.ncbi.nlm.nih.gov/19138868/"
    },
    "prods": [
      {
        "text": "Perfect Kibble Beef",
        "link": "/products/perfect-kibble-beef"
      },
      {
        "text": "Perfect Kibble Chicken",
        "link": "/products/perfect-kibble"
      }
    ]
  },
  {
    "ing": [
      "Fresh meat",
      "Minimally-processed"
    ],
    "dsc": "Protein requirements increase with age.",
    "journal": "Topics in Companion Animal Medicine, 2008",
    "citation": {
      "text": "Laflamme DP. Pet food safety: dietary protein. Top Companion Anim Med. 2008 Aug;23(3):154-7. doi: 10.1053/j.tcam.2008.04.009. PMID: 18656844. [*]",
      "link": "https://pubmed.ncbi.nlm.nih.gov/18656844/"
    },
    "prods": [
      {
        "text": "Perfect Kibble Beef",
        "link": "/products/perfect-kibble-beef"
      },
      {
        "text": "Perfect Kibble Chicken",
        "link": "/products/perfect-kibble"
      }
    ]
  },
  {
    "ing": [
      "Fresh meat"
    ],
    "dsc": "Pet owners unaware of the risks of a raw food diet for pets.",
    "journal": "BMC Veterinary Research, 2019",
    "citation": {
      "text": "Morelli G, Bastianello S, Catellani P, Ricci R. Raw meat-based diets for dogs: survey of owners' motivations, attitudes and practices. BMC Vet Res. 2019;15(1):74. Published 2019 Mar 4. doi:10.1186/s12917-019-1824-x [*]",
      "link": "https://www.ncbi.nlm.nih.gov/pmc/articles/PMC6399943/"
    },
    "prods": [
      {
        "text": "Perfect Kibble Beef",
        "link": "/products/perfect-kibble-beef"
      },
      {
        "text": "Perfect Kibble Chicken",
        "link": "/products/perfect-kibble"
      }
    ]
  },
  {
    "ing": [
      "Fresh meat",
      "Fresh chicken",
      "Fresh beef"
    ],
    "dsc": "Protein quantity and quality are critical to maintaining muscle mass and a healthy life.",
    "journal": "Frontiers in Nutrition, 2019",
    "citation": {
      "text": "Burd NA, McKenna CF, Salvador AF, Paulussen KJM, Moore DR. Dietary Protein Quantity, Quality, and Exercise Are Key to Healthy Living: A Muscle-Centric Perspective Across the Lifespan. Front Nutr. 2019;6:83. Published 2019 Jun 6. doi:10.3389/fnut.2019.00083 [*]",
      "link": "https://www.ncbi.nlm.nih.gov/pmc/articles/PMC6563776/"
    },
    "prods": [
      {
        "text": "Perfect Kibble Beef",
        "link": "/products/perfect-kibble-beef"
      },
      {
        "text": "Perfect Kibble Chicken",
        "link": "/products/perfect-kibble"
      }
    ]
  },
  {
    "ing": [
      "Fresh meat",
      "Fresh chicken",
      "Fresh beef"
    ],
    "dsc": "Evaluation of different protein types, highlighting the importance of animal protein as providing a complete source of essential amino acids.",
    "journal": "Journal of Sports Science & Medicine, 2004",
    "citation": {
      "text": "Hoffman JR, Falvo MJ. Protein - Which is Best?. J Sports Sci Med. 2004;3(3):118-130. Published 2004 Sep 1. [*]",
      "link": "https://www.ncbi.nlm.nih.gov/pmc/articles/PMC3905294/"
    },
    "prods": [
      {
        "text": "Perfect Kibble Beef",
        "link": "/products/perfect-kibble-beef"
      },
      {
        "text": "Perfect Kibble Chicken",
        "link": "/products/perfect-kibble"
      }
    ]
  },
  {
    "ing": [
      "Fresh meat",
      "Fresh chicken",
      "Fresh beef"
    ],
    "dsc": "A reliable source of amino acids is critical to ensure nutritional adequacy for dogs.",
    "journal": "Advances in Experimental Medicine and Biology, 2021",
    "citation": {
      "text": "Oberbauer AM, Larsen JA. Amino Acids in Dog Nutrition and Health. Adv Exp Med Biol. 2021;1285:199-216. doi: 10.1007/978-3-030-54462-1_10. PMID: 33770408. [*]",
      "link": "https://pubmed.ncbi.nlm.nih.gov/33770408/"
    },
    "prods": [
      {
        "text": "Perfect Kibble Beef",
        "link": "/products/perfect-kibble-beef"
      },
      {
        "text": "Perfect Kibble Chicken",
        "link": "/products/perfect-kibble"
      }
    ]
  },
  {
    "ing": [
      "Gluten-free oats",
      "Anti-inflammatory"
    ],
    "dsc": "Linoleic acid helps maintain the skin barrier, promote wound healing, and soothe inflammation. (Linoleic acid is found in oats.)",
    "journal": "Clinical Dermatology, 2010",
    "citation": {
      "text": "McCusker MM, Grant-Kels JM. Healing fats of the skin: the structural and immunologic roles of the omega-6 and omega-3 fatty acids. Clin Dermatol. 2010 Jul-Aug;28(4):440-51. doi: 10.1016/j.clindermatol.2010.03.020. PMID: 20620762. [*]",
      "link": "https://pubmed.ncbi.nlm.nih.gov/20620762/"
    },
    "prods": [
      {
        "text": "Perfect Kibble Beef",
        "link": "/products/perfect-kibble-beef"
      },
      {
        "text": "Perfect Kibble Chicken",
        "link": "/products/perfect-kibble"
      },
      {
        "text": "Perfect Dog Food Mix",
        "link": "/products/perfect-dog-food-mix"
      }
    ]
  },
  {
    "ing": [
      "Gluten-free oats"
    ],
    "dsc": "B vitamins play a critical role in producing healthy skin cells, needed for healing. (B vitamins found in oats.)",
    "journal": "Advances in Skin and Wound Care, 2018",
    "citation": {
      "text": "Rembe JD, Fromm-Dornieden C, Stuermer EK. Effects of Vitamin B Complex and Vitamin C on Human Skin Cells: Is the Perceived Effect Measurable? Adv Skin Wound Care. 2018 May;31(5):225-233. doi: 10.1097/01.ASW.0000531351.85866.d9. PMID: 29672394. [*]",
      "link": "https://pubmed.ncbi.nlm.nih.gov/29672394/"
    },
    "prods": [
      {
        "text": "Perfect Kibble Beef",
        "link": "/products/perfect-kibble-beef"
      },
      {
        "text": "Perfect Kibble Chicken",
        "link": "/products/perfect-kibble"
      },
      {
        "text": "Perfect Dog Food Mix",
        "link": "/products/perfect-dog-food-mix"
      }
    ]
  },
  {
    "ing": [
      "Gluten-free oats"
    ],
    "dsc": "Beta-clucans are anti-inflammatory, anti-obesity, immune system promoting. (Oats are rich on beta-glucans.)",
    "journal": "International Journal of Molecular Sciencies, 2017",
    "citation": {
      "text": "Bashir, K.M.I.; Choi, J.-S. Clinical and Physiological Perspectives of β-Glucans: The Past, Present, and Future. Int. J. Mol. Sci. 2017, 18, 1906. https://doi.org/10.3390/ijms18091906 [*]",
      "link": "https://www.ncbi.nlm.nih.gov/pmc/articles/PMC5618555/"
    },
    "prods": [
      {
        "text": "Perfect Kibble Beef",
        "link": "/products/perfect-kibble-beef"
      },
      {
        "text": "Perfect Kibble Chicken",
        "link": "/products/perfect-kibble"
      },
      {
        "text": "Perfect Dog Food Mix",
        "link": "/products/perfect-dog-food-mix"
      }
    ]
  },
  {
    "ing": [
      "Gluten-free oats"
    ],
    "dsc": "Following daily oat consumption, total cholesterol and LDL-cholesterol levels were significantly reduced below baseline.",
    "journal": "Journal of Medical Association of Thailand, 2013",
    "citation": {
      "text": "Thongoun P, Pavadhgul P, Bumrungpert A, Satitvipawee P, Harjani Y, Kurilich A. Effect of oat consumption on lipid profiles in hypercholesterolemic adults. J Med Assoc Thai. 2013 Dec;96 Suppl 5:S25-32. PMID: 24851570. [*]",
      "link": "https://pubmed.ncbi.nlm.nih.gov/24851570/"
    },
    "prods": [
      {
        "text": "Perfect Kibble Beef",
        "link": "/products/perfect-kibble-beef"
      },
      {
        "text": "Perfect Kibble Chicken",
        "link": "/products/perfect-kibble"
      },
      {
        "text": "Perfect Dog Food Mix",
        "link": "/products/perfect-dog-food-mix"
      }
    ]
  },
  {
    "ing": [
      "Gluten-free oats"
    ],
    "dsc": "Dogs fed oats saw lower levels of total cholesterol, LDLs, and VLDLs compared to baseline.",
    "journal": "PLoS One, 2018",
    "citation": {
      "text": "Ferreira LG, Endrighi M, Lisenko KG, de Oliveira MRD, Damasceno MR, Claudino JA, et al. (2018) Oat beta-glucan as a dietary supplement for dogs. PLoS ONE 13(7): e0201133. https://doi.org/10.1371/journal.pone.0201133 [*]",
      "link": "https://www.ncbi.nlm.nih.gov/pmc/articles/PMC6067736/"
    },
    "prods": [
      {
        "text": "Perfect Kibble Beef",
        "link": "/products/perfect-kibble-beef"
      },
      {
        "text": "Perfect Kibble Chicken",
        "link": "/products/perfect-kibble"
      },
      {
        "text": "Perfect Dog Food Mix",
        "link": "/products/perfect-dog-food-mix"
      }
    ]
  },
  {
    "ing": [
      "Gluten-free oats"
    ],
    "dsc": "Beta-glucans stimulated the immune system in mice, dogs, piglets, and chicks.",
    "journal": "Comparative Immunology, Microbiology, and Infectious Diseases, 2019",
    "citation": {
      "text": "de Oliveira CAF, Vetvicka V, Zanuzzo FS. β-Glucan successfully stimulated the immune system in different jawed vertebrate species. Comp Immunol Microbiol Infect Dis. 2019 Feb;62:1-6. doi: 10.1016/j.cimid.2018.11.006. Epub 2018 Nov 24. PMID: 30711038. [*]",
      "link": "https://pubmed.ncbi.nlm.nih.gov/30711038/"
    },
    "prods": [
      {
        "text": "Perfect Kibble Beef",
        "link": "/products/perfect-kibble-beef"
      },
      {
        "text": "Perfect Kibble Chicken",
        "link": "/products/perfect-kibble"
      },
      {
        "text": "Perfect Dog Food Mix",
        "link": "/products/perfect-dog-food-mix"
      }
    ]
  },
  {
    "ing": [
      "Gluten-free oats"
    ],
    "dsc": "Overview of oats dietary profile: high in vitamins, minerals, and other beneficial compounds, includng calcium, iron, magnesium, copper, thiamine, riboflavin, and niacin.",
    "journal": "Journal of Food Science and Technology, 2015",
    "citation": {
      "text": "Rasane, P., Jha, A., Sabikhi, L. et al. Nutritional advantages of oats and opportunities for its processing as value added foods - a review. J Food Sci Technol 52, 662–675 (2015). https://doi.org/10.1007/s13197-013-1072-1 [*]",
      "link": "https://www.ncbi.nlm.nih.gov/pmc/articles/PMC4325078/"
    },
    "prods": [
      {
        "text": "Perfect Kibble Beef",
        "link": "/products/perfect-kibble-beef"
      },
      {
        "text": "Perfect Kibble Chicken",
        "link": "/products/perfect-kibble"
      },
      {
        "text": "Perfect Dog Food Mix",
        "link": "/products/perfect-dog-food-mix"
      }
    ]
  },
  {
    "ing": [
      "Gluten-free oats"
    ],
    "dsc": "Low fibre causes altered gut microbiota which is associated with heart failure.",
    "journal": "ESC Heart Failure, 2020",
    "citation": {
      "text": "Mayerhofer CCK, Kummen M, Holm K, Broch K, Awoyemi A, Vestad B, Storm-Larsen C, Seljeflot I, Ueland T, Bohov P, Berge RK, Svardal A, Gullestad L, Yndestad A, Aukrust P, Hov JR, Trøseid M. Low fibre intake is associated with gut microbiota alterations in chronic heart failure. ESC Heart Fail. 2020 Apr;7(2):456-466. doi: 10.1002/ehf2.12596. Epub 2020 Jan 24. PMID: 31978943; PMCID: PMC7160496. [*]",
      "link": "https://pubmed.ncbi.nlm.nih.gov/31978943/"
    },
    "prods": [
      {
        "text": "Perfect Kibble Beef",
        "link": "/products/perfect-kibble-beef"
      },
      {
        "text": "Perfect Kibble Chicken",
        "link": "/products/perfect-kibble"
      },
      {
        "text": "Perfect Dog Food Mix",
        "link": "/products/perfect-dog-food-mix"
      }
    ]
  },
  {
    "ing": [
      "Gluten-free oats"
    ],
    "dsc": "Beta-glucans beneficial in insuline resistance, dyslipedemia, hypertension and obesity.",
    "journal": "Journal of Nutrition and Metabolism, 2012",
    "citation": {
      "text": "El Khoury D, Cuda C, Luhovyy BL, Anderson GH. Beta glucan: health benefits in obesity and metabolic syndrome. J Nutr Metab. 2012;2012:851362. doi:10.1155/2012/851362 [*]",
      "link": "https://www.ncbi.nlm.nih.gov/pmc/articles/PMC3236515/"
    },
    "prods": [
      {
        "text": "Perfect Kibble Beef",
        "link": "/products/perfect-kibble-beef"
      },
      {
        "text": "Perfect Kibble Chicken",
        "link": "/products/perfect-kibble"
      },
      {
        "text": "Perfect Dog Food Mix",
        "link": "/products/perfect-dog-food-mix"
      }
    ]
  },
  {
    "ing": [
      "Gluten-free oats"
    ],
    "dsc": "Beta-glucans improve satiety or fullness.",
    "journal": "Nutrition Reviews, 2016",
    "citation": {
      "text": "Rebello CJ, O'Neil CE, Greenway FL. Dietary fiber and satiety: the effects of oats on satiety. Nutr Rev. 2016 Feb;74(2):131-47. doi: 10.1093/nutrit/nuv063. Epub 2016 Jan 2. PMID: 26724486; PMCID: PMC4757923. [*]",
      "link": "https://pubmed.ncbi.nlm.nih.gov/26724486/"
    },
    "prods": [
      {
        "text": "Perfect Kibble Beef",
        "link": "/products/perfect-kibble-beef"
      },
      {
        "text": "Perfect Kibble Chicken",
        "link": "/products/perfect-kibble"
      },
      {
        "text": "Perfect Dog Food Mix",
        "link": "/products/perfect-dog-food-mix"
      }
    ]
  },
  {
    "ing": [
      "Gluten-free oats"
    ],
    "dsc": "Beta-glucans helps bolster the adaptive immune systems response to vaccines in dogs.",
    "journal": "Frontiers in Immunology, 2020",
    "citation": {
      "text": "Paris S, Chapat L, Martin-Cagnon N, Durand PY, Piney L, Cariou C, Bergamo P, Bonnet JM, Poulet H, Freyburger L, De Luca K. β-Glucan as Trained Immunity-Based Adjuvants for Rabies Vaccines in Dogs. Front Immunol. 2020 Oct 8;11:564497. doi: 10.3389/fimmu.2020.564497. PMID: 33162977; PMCID: PMC7580252. [*]",
      "link": "https://pubmed.ncbi.nlm.nih.gov/33162977/"
    },
    "prods": [
      {
        "text": "Perfect Kibble Beef",
        "link": "/products/perfect-kibble-beef"
      },
      {
        "text": "Perfect Kibble Chicken",
        "link": "/products/perfect-kibble"
      },
      {
        "text": "Perfect Dog Food Mix",
        "link": "/products/perfect-dog-food-mix"
      }
    ]
  },
  {
    "ing": [
      "Gluten-free oats"
    ],
    "dsc": "Beta-glucans are critical to helping beneficial gut microbiota.",
    "journal": "Journal of Nutritional Biochemistry, 2018",
    "citation": {
      "text": "Jayachandran M, Chen J, Chung SSM, Xu B. A critical review on the impacts of β-glucans on gut microbiota and human health. J Nutr Biochem. 2018 Nov;61:101-110. doi: 10.1016/j.jnutbio.2018.06.010. Epub 2018 Aug 10. PMID: 30196242. [*]",
      "link": "https://pubmed.ncbi.nlm.nih.gov/30196242/"
    },
    "prods": [
      {
        "text": "Perfect Kibble Beef",
        "link": "/products/perfect-kibble-beef"
      },
      {
        "text": "Perfect Kibble Chicken",
        "link": "/products/perfect-kibble"
      },
      {
        "text": "Perfect Dog Food Mix",
        "link": "/products/perfect-dog-food-mix"
      }
    ]
  },
  {
    "ing": [
      "Gluten-free oats"
    ],
    "dsc": "Beta-glucans aided white blood cells and bolstered the immune response.",
    "journal": "Frontiers in Immunology, 2020",
    "citation": {
      "text": "Paris S, Chapat L, Pasin M, Lambiel M, Sharrock TE, Shukla R, Sigoillot-Claude C, Bonnet JM, Poulet H, Freyburger L, De Luca K. β-Glucan-Induced Trained Immunity in Dogs. Front Immunol. 2020 Oct 9;11:566893. doi: 10.3389/fimmu.2020.566893. PMID: 33162983; PMCID: PMC7581789. [*]",
      "link": "https://pubmed.ncbi.nlm.nih.gov/33162983/"
    },
    "prods": [
      {
        "text": "Perfect Kibble Beef",
        "link": "/products/perfect-kibble-beef"
      },
      {
        "text": "Perfect Kibble Chicken",
        "link": "/products/perfect-kibble"
      },
      {
        "text": "Perfect Dog Food Mix",
        "link": "/products/perfect-dog-food-mix"
      }
    ]
  },
  {
    "ing": [
      "Gluten-free oats"
    ],
    "dsc": "Beta-glucans can help in obesity prevention and treatment.",
    "journal": "BMC Veterinary Research, 2022",
    "citation": {
      "text": "Ferreira CS, Vendramini THA, Amaral AR, et al. Metabolic variables of obese dogs with insulin resistance supplemented with yeast beta-glucan. BMC Vet Res. 2022;18(1):14. Published 2022 Jan 3. doi:10.1186/s12917-021-03106-2 [*]",
      "link": "https://www.ncbi.nlm.nih.gov/pmc/articles/PMC8722019/"
    },
    "prods": [
      {
        "text": "Perfect Kibble Beef",
        "link": "/products/perfect-kibble-beef"
      },
      {
        "text": "Perfect Kibble Chicken",
        "link": "/products/perfect-kibble"
      },
      {
        "text": "Perfect Dog Food Mix",
        "link": "/products/perfect-dog-food-mix"
      }
    ]
  },
  {
    "ing": [
      "High antioxidants",
      "Carrots"
    ],
    "dsc": "Antioxidant supplementation increase retinal responses and decreases refractive error in dogs.",
    "journal": "Journal of Nutritional Science, 2016",
    "citation": {
      "text": "Wang, W., Hernandez, J., Moore, C., Jackson, J., & Narfström, K. (2016). Antioxidant supplementation increases retinal responses and decreases refractive error changes in dogs. Journal of Nutritional Science, 5, E18. doi:10.1017/jns.2016.5 [*]",
      "link": "https://www.ncbi.nlm.nih.gov/pmc/articles/PMC4891559/"
    },
    "prods": [
      {
        "text": "Perfect Kibble Beef",
        "link": "/products/perfect-kibble-beef"
      },
      {
        "text": "Perfect Kibble Chicken",
        "link": "/products/perfect-kibble"
      },
      {
        "text": "Perfect Dog Food Mix",
        "link": "/products/perfect-dog-food-mix"
      }
    ]
  },
  {
    "ing": [
      "High antioxidants"
    ],
    "dsc": "Low antioxidant status in dogs is a marker of congestive heart failure.",
    "journal": "Journal of Veterinary Internal Medicine, 2005",
    "citation": {
      "text": "Freeman LM, Rush JE, Milbury PE, Blumberg JB. Antioxidant status and biomarkers of oxidative stress in dogs with congestive heart failure. J Vet Intern Med. 2005 Jul-Aug;19(4):537-41. doi: 10.1892/0891-6640(2005)19[537:asaboo]2.0.co;2. PMID: 16095171. [*]",
      "link": "https://pubmed.ncbi.nlm.nih.gov/16095171/"
    },
    "prods": [
      {
        "text": "Perfect Kibble Beef",
        "link": "/products/perfect-kibble-beef"
      },
      {
        "text": "Perfect Kibble Chicken",
        "link": "/products/perfect-kibble"
      },
      {
        "text": "Perfect Dog Food Mix",
        "link": "/products/perfect-dog-food-mix"
      }
    ]
  },
  {
    "ing": [
      "High antioxidants"
    ],
    "dsc": "Oxidative stress is a major factor in canine heart failure.",
    "journal": "Veterinary Medicine International, 2011",
    "citation": {
      "text": "Sagols E, Priymenko N. Oxidative stress in dog with heart failure: the role of dietary Fatty acids and antioxidants. Vet Med Int. 2011;2011:180206. Published 2011 Apr 6. doi:10.4061/2011/180206 [*]",
      "link": "https://www.ncbi.nlm.nih.gov/pmc/articles/PMC3087355/"
    },
    "prods": [
      {
        "text": "Perfect Kibble Beef",
        "link": "/products/perfect-kibble-beef"
      },
      {
        "text": "Perfect Kibble Chicken",
        "link": "/products/perfect-kibble"
      },
      {
        "text": "Perfect Dog Food Mix",
        "link": "/products/perfect-dog-food-mix"
      }
    ]
  },
  {
    "ing": [
      "High antioxidants"
    ],
    "dsc": "Oxidative damage leads to neuronal dysfunction and is linked to cognitive dysfunction in aged dogs.",
    "journal": "Biochim Biophys Acta, 2013",
    "citation": {
      "text": "Dowling AL, Head E. Antioxidants in the canine model of human aging. Biochim Biophys Acta. 2012;1822(5):685-689. doi:10.1016/j.bbadis.2011.09.020 [*]",
      "link": "https://www.ncbi.nlm.nih.gov/pmc/articles/PMC3291812/"
    },
    "prods": [
      {
        "text": "Perfect Kibble Beef",
        "link": "/products/perfect-kibble-beef"
      },
      {
        "text": "Perfect Kibble Chicken",
        "link": "/products/perfect-kibble"
      },
      {
        "text": "Perfect Dog Food Mix",
        "link": "/products/perfect-dog-food-mix"
      }
    ]
  },
  {
    "ing": [
      "High antioxidants"
    ],
    "dsc": "Antioxidant treatment can prevent oxidative damage impairing cognitive functioning in dogs.",
    "journal": "Neurobiology of Aging, 2002",
    "citation": {
      "text": "Cotman CW, Head E, Muggenburg BA, Zicker S, Milgram NW. Brain aging in the canine: a diet enriched in antioxidants reduces cognitive dysfunction. Neurobiol Aging. 2002 Sep-Oct;23(5):809-18. doi: 10.1016/s0197-4580(02)00073-8. PMID: 12392784. [*]",
      "link": "https://pubmed.ncbi.nlm.nih.gov/12392784/"
    },
    "prods": [
      {
        "text": "Perfect Kibble Beef",
        "link": "/products/perfect-kibble-beef"
      },
      {
        "text": "Perfect Kibble Chicken",
        "link": "/products/perfect-kibble"
      },
      {
        "text": "Perfect Dog Food Mix",
        "link": "/products/perfect-dog-food-mix"
      }
    ]
  },
  {
    "ing": [
      "High antioxidants"
    ],
    "dsc": "Antioxidants might be considered a valid alternative and a valuable strategy to counteract aging-related cognitive decline in elderly dogs.",
    "journal": "Journal of Veterinary Medicine, 2015",
    "citation": {
      "text": "Sechi S, Chiavolelli F, Spissu N, et al. An Antioxidant Dietary Supplement Improves Brain-Derived Neurotrophic Factor Levels in Serum of Aged Dogs: Preliminary Results. J Vet Med. 2015;2015:412501. doi:10.1155/2015/412501 [*]",
      "link": "https://www.ncbi.nlm.nih.gov/pmc/articles/PMC4590864/"
    },
    "prods": [
      {
        "text": "Perfect Kibble Beef",
        "link": "/products/perfect-kibble-beef"
      },
      {
        "text": "Perfect Kibble Chicken",
        "link": "/products/perfect-kibble"
      },
      {
        "text": "Perfect Dog Food Mix",
        "link": "/products/perfect-dog-food-mix"
      }
    ]
  },
  {
    "ing": [
      "High antioxidants"
    ],
    "dsc": "Increasing concentrations of alpha-lipoic acid induced a significant increase in the concentrations of intracellular glutathione, an important biomarker of the antioxidant system.",
    "journal": "Animals, 2021",
    "citation": {
      "text": "Anthony RM, MacLeay JM, Jewell DE, Brejda JJ, Gross KL. Alpha-Lipoic Acid Is an Effective Nutritive Antioxidant for Healthy Adult Dogs. Animals (Basel). 2021;11(2):274. Published 2021 Jan 22. doi:10.3390/ani11020274 [*]",
      "link": "https://www.ncbi.nlm.nih.gov/pmc/articles/PMC7912130/"
    },
    "prods": [
      {
        "text": "Perfect Kibble Beef",
        "link": "/products/perfect-kibble-beef"
      },
      {
        "text": "Perfect Kibble Chicken",
        "link": "/products/perfect-kibble"
      },
      {
        "text": "Perfect Dog Food Mix",
        "link": "/products/perfect-dog-food-mix"
      }
    ]
  },
  {
    "ing": [
      "High antioxidants"
    ],
    "dsc": "Therapies which prevent superoxide accumulation, maintain mitochondrial homeostasis and protect its DNA appear to be the most likely strategies to prevent the development of diabetic retinopathy.",
    "journal": "Current Pharmaceutical Biotechnology, 2012",
    "citation": {
      "text": "Santos JM, Mohammad G, Zhong Q, Kowluru RA. Diabetic retinopathy, superoxide damage and antioxidants. Curr Pharm Biotechnol. 2011;12(3):352-361. doi:10.2174/138920111794480507 [*]",
      "link": "https://www.ncbi.nlm.nih.gov/pmc/articles/PMC3214730/"
    },
    "prods": [
      {
        "text": "Perfect Kibble Beef",
        "link": "/products/perfect-kibble-beef"
      },
      {
        "text": "Perfect Kibble Chicken",
        "link": "/products/perfect-kibble"
      },
      {
        "text": "Perfect Dog Food Mix",
        "link": "/products/perfect-dog-food-mix"
      }
    ]
  },
  {
    "ing": [
      "High omega-3",
      "Wild Alaskan salmon oil"
    ],
    "dsc": "Omega-3s regulate abnormal heart rhythms, increase survival of dogs with heart faulure, reduce blood pressure and heart rate, and more.",
    "journal": "Journal of Small Animal Practice, 2010",
    "citation": {
      "text": "Freeman LM. Beneficial effects of omega-3 fatty acids in cardiovascular disease. J Small Anim Pract. 2010 Sep;51(9):462-70. doi: 10.1111/j.1748-5827.2010.00968.x. Epub 2010 Jul 29. PMID: 20673293. [*]",
      "link": "https://pubmed.ncbi.nlm.nih.gov/20673293/"
    },
    "prods": [
      {
        "text": "Perfect Wild Alaskan Salmon Oil",
        "link": "/products/perfect-wild-alaskan-salmon-oil"
      }
    ]
  },
  {
    "ing": [
      "High omega-3",
      "Wild Alaskan salmon oil"
    ],
    "dsc": "Omega-3s significantly reduce pain in rheumatoid arthritis.",
    "journal": "Arthritis and Rheumatism, 1994",
    "citation": {
      "text": "Geusens P, Wouters C, Nijs J, Jiang Y, Dequeker J. Long-term effect of omega-3 fatty acid supplementation in active rheumatoid arthritis. A 12-month, double-blind, controlled study. Arthritis Rheum. 1994 Jun;37(6):824-9. doi: 10.1002/art.1780370608. PMID: 8003055. [*]",
      "link": "https://pubmed.ncbi.nlm.nih.gov/8003055/"
    },
    "prods": [
      {
        "text": "Perfect Wild Alaskan Salmon Oil",
        "link": "/products/perfect-wild-alaskan-salmon-oil"
      }
    ]
  },
  {
    "ing": [
      "High omega-3",
      "Wild Alaskan salmon oil",
      "Anti-inflammatory"
    ],
    "dsc": "Omega-3's anti-inflammatory properties benefits autoimmune diseases like Crohn's disease, ulcerative colitis, and lupus.",
    "journal": "Journal of the American College of Nutrition, 2002",
    "citation": {
      "text": "Simopoulos AP. Omega-3 fatty acids in inflammation and autoimmune diseases. J Am Coll Nutr. 2002 Dec;21(6):495-505. doi: 10.1080/07315724.2002.10719248. PMID: 12480795. [*]",
      "link": "https://pubmed.ncbi.nlm.nih.gov/12480795/"
    },
    "prods": [
      {
        "text": "Perfect Wild Alaskan Salmon Oil",
        "link": "/products/perfect-wild-alaskan-salmon-oil"
      }
    ]
  },
  {
    "ing": [
      "High omega-3",
      "Wild Alaskan salmon oil"
    ],
    "dsc": "Omega-3s from fish oil modify inflammatory and immune responses in dogs. They also improve skin and coat and neurological development in puppies.",
    "journal": "Journal of the American Veterinary Medical Association, 2007",
    "citation": {
      "text": "Bauer JE. Responses of dogs to dietary omega-3 fatty acids. J Am Vet Med Assoc. 2007 Dec 1;231(11):1657-61. doi: 10.2460/javma.231.11.1657. PMID: 18052798. [*]",
      "link": "https://pubmed.ncbi.nlm.nih.gov/18052798/"
    },
    "prods": [
      {
        "text": "Perfect Wild Alaskan Salmon Oil",
        "link": "/products/perfect-wild-alaskan-salmon-oil"
      }
    ]
  },
  {
    "ing": [
      "High omega-3",
      "Wild Alaskan salmon oil"
    ],
    "dsc": "EPA and DHA reduce symptoms of canine atopic dermatitis.",
    "journal": "Journal of Small Animal Practice, 2004",
    "citation": {
      "text": "Mueller RS, Fieseler KV, Fettman MJ, Zabel S, Rosychuk RA, Ogilvie GK, Greenwalt TL. Effect of omega-3 fatty acids on canine atopic dermatitis. J Small Anim Pract. 2004 Jun;45(6):293-7. doi: 10.1111/j.1748-5827.2004.tb00238.x. PMID: 15206474. [*]",
      "link": "https://pubmed.ncbi.nlm.nih.gov/15206474/"
    },
    "prods": [
      {
        "text": "Perfect Wild Alaskan Salmon Oil",
        "link": "/products/perfect-wild-alaskan-salmon-oil"
      }
    ]
  },
  {
    "ing": [
      "High omega-3",
      "Wild Alaskan salmon oil"
    ],
    "dsc": "Osteoarthritic dogs fed a diet high in omega-3 walked and played better compared to acontrol.",
    "journal": "Journal of the American Veterinary Medical Association, 2010",
    "citation": {
      "text": "Roush JK, Dodd CE, Fritsch DA, Allen TA, Jewell DE, Schoenherr WD, Richardson DC, Leventhal PS, Hahn KA. Multicenter veterinary practice assessment of the effects of omega-3 fatty acids on osteoarthritis in dogs. J Am Vet Med Assoc. 2010 Jan 1;236(1):59-66. doi: 10.2460/javma.236.1.59. Erratum in: J Am Vet Med Assoc. 2010 Jun 1;236(11):1191. PMID: 20043800. [*]",
      "link": "https://pubmed.ncbi.nlm.nih.gov/20043800/"
    },
    "prods": [
      {
        "text": "Perfect Wild Alaskan Salmon Oil",
        "link": "/products/perfect-wild-alaskan-salmon-oil"
      }
    ]
  },
  {
    "ing": [
      "High omega-3"
    ],
    "dsc": "Almost half of all atopic dogs saw their pruritus controlled by a diet rich in omega-3s.",
    "journal": "Canadian Journal of Veterinary Research, 1997",
    "citation": {
      "text": "Scott DW, Miller WH Jr, Reinhart GA, Mohammed HO, Bagladi MS. Effect of an omega-3/omega-6 fatty acid-containing commercial lamb and rice diet on pruritus in atopic dogs: results of a single-blinded study. Can J Vet Res. 1997;61(2):145-153. [*]",
      "link": "https://www.ncbi.nlm.nih.gov/pmc/articles/PMC1189391/"
    },
    "prods": [
      {
        "text": "Perfect Wild Alaskan Salmon Oil",
        "link": "/products/perfect-wild-alaskan-salmon-oil"
      },
      {
        "text": "Perfect Kibble Beef",
        "link": "/products/perfect-kibble-beef"
      },
      {
        "text": "Perfect Kibble Chicken",
        "link": "/products/perfect-kibble"
      }
    ]
  },
  {
    "ing": [
      "High omega-3"
    ],
    "dsc": "Omega-3 fed dogs saw symptoms of osteoarthritis decrease and improved mobility and general performance.",
    "journal": "Journal of Animal Physiology and Animal Nutrition, 2013",
    "citation": {
      "text": "Moreau M, Troncy E, Del Castillo JR, Bédard C, Gauvin D, Lussier B. Effects of feeding a high omega-3 fatty acids diet in dogs with naturally occurring osteoarthritis. J Anim Physiol Anim Nutr (Berl). 2013 Oct;97(5):830-7. doi: 10.1111/j.1439-0396.2012.01325.x. Epub 2012 Jul 14. PMID: 22805303. [*]",
      "link": "https://pubmed.ncbi.nlm.nih.gov/22805303/"
    },
    "prods": [
      {
        "text": "Perfect Wild Alaskan Salmon Oil",
        "link": "/products/perfect-wild-alaskan-salmon-oil"
      },
      {
        "text": "Perfect Kibble Beef",
        "link": "/products/perfect-kibble-beef"
      },
      {
        "text": "Perfect Kibble Chicken",
        "link": "/products/perfect-kibble"
      }
    ]
  },
  {
    "ing": [
      "High omega-3"
    ],
    "dsc": "Omega-3 reduce the volumetric overload, and had antiarrhythmic effect in dogs with myxomatous mitral valve disease.",
    "journal": "PLoS One, 2021",
    "citation": {
      "text": "Nasciutti PR, Moraes AT, Santos TK, et al. Protective effects of omega-3 fatty acids in dogs with myxomatous mitral valve disease stages B2 and C. PLoS One. 2021;16(7):e0254887. Published 2021 Jul 15. doi:10.1371/journal.pone.0254887 [*]",
      "link": "https://www.ncbi.nlm.nih.gov/pmc/articles/PMC8282066/"
    },
    "prods": [
      {
        "text": "Perfect Wild Alaskan Salmon Oil",
        "link": "/products/perfect-wild-alaskan-salmon-oil"
      },
      {
        "text": "Perfect Kibble Beef",
        "link": "/products/perfect-kibble-beef"
      },
      {
        "text": "Perfect Kibble Chicken",
        "link": "/products/perfect-kibble"
      }
    ]
  },
  {
    "ing": [
      "High omega-3"
    ],
    "dsc": "Results of the study reported here support the hypothesis that a combination of omega-3 fatty acids, magnesium, and zinc may improve some of the behavioral disorders.",
    "journal": "Topics in Companion Animal Medicine, 2018",
    "citation": {
      "text": "Rahimi Niyyat M, Azizzadeh M, Khoshnegah J. Effect of Supplementation With Omega-3 Fatty Acids, Magnesium, and Zinc on Canine Behavioral Disorders: Results of a Pilot Study. Top Companion Anim Med. 2018 Dec;33(4):150-155. doi: 10.1053/j.tcam.2018.08.006. Epub 2018 Aug 30. PMID: 30502867. [*]",
      "link": "https://pubmed.ncbi.nlm.nih.gov/30502867/"
    },
    "prods": [
      {
        "text": "Perfect Wild Alaskan Salmon Oil",
        "link": "/products/perfect-wild-alaskan-salmon-oil"
      },
      {
        "text": "Perfect Kibble Beef",
        "link": "/products/perfect-kibble-beef"
      },
      {
        "text": "Perfect Kibble Chicken",
        "link": "/products/perfect-kibble"
      }
    ]
  },
  {
    "ing": [
      "High omega-3"
    ],
    "dsc": "Omega-3 may reduce osteoarthritis symptoms and development.",
    "journal": "Veterinary Clinics of North America. Small Animal Practice, 2006",
    "citation": {
      "text": "Budsberg SC, Bartges JW. Nutrition and osteoarthritis in dogs: does it help? Vet Clin North Am Small Anim Pract. 2006 Nov;36(6):1307-23, vii. doi: 10.1016/j.cvsm.2006.08.007. PMID: 17085237. [*]",
      "link": "https://pubmed.ncbi.nlm.nih.gov/17085237/"
    },
    "prods": [
      {
        "text": "Perfect Wild Alaskan Salmon Oil",
        "link": "/products/perfect-wild-alaskan-salmon-oil"
      },
      {
        "text": "Perfect Kibble Beef",
        "link": "/products/perfect-kibble-beef"
      },
      {
        "text": "Perfect Kibble Chicken",
        "link": "/products/perfect-kibble"
      }
    ]
  },
  {
    "ing": [
      "High omega-3"
    ],
    "dsc": "EPA and DHA (types of omega-3 fatty acids) benefit rheumatoid arthritis, inflammatory bowel disease, and asthma.",
    "journal": "British Journal of Clinical Pharmacology, 2013",
    "citation": {
      "text": "Calder PC. Omega-3 polyunsaturated fatty acids and inflammatory processes: nutrition or pharmacology? Br J Clin Pharmacol. 2013 Mar;75(3):645-62. doi: 10.1111/j.1365-2125.2012.04374.x. PMID: 22765297; PMCID: PMC3575932. [*]",
      "link": "https://pubmed.ncbi.nlm.nih.gov/22765297/"
    },
    "prods": [
      {
        "text": "Perfect Wild Alaskan Salmon Oil",
        "link": "/products/perfect-wild-alaskan-salmon-oil"
      },
      {
        "text": "Perfect Kibble Beef",
        "link": "/products/perfect-kibble-beef"
      },
      {
        "text": "Perfect Kibble Chicken",
        "link": "/products/perfect-kibble"
      }
    ]
  },
  {
    "ing": [
      "Inulin"
    ],
    "dsc": "Inulin and oligofructose supplementation reduce gut pathogens and increase beneficial bacteria.",
    "journal": "Journal of Nutrition, 1999",
    "citation": {
      "text": "Hussein HS, Flickinger EA, Fahey GC Jr. Petfood applications of inulin and oligofructose. J Nutr. 1999 Jul;129(7 Suppl):1454S-6S. doi: 10.1093/jn/129.7.1454S. PMID: 10395620. [*]",
      "link": "https://pubmed.ncbi.nlm.nih.gov/10395620/"
    },
    "prods": [
      {
        "text": "Perfect Kibble Beef",
        "link": "/products/perfect-kibble-beef"
      },
      {
        "text": "Perfect Kibble Chicken",
        "link": "/products/perfect-kibble"
      },
      {
        "text": "Perfect Dog Food Mix",
        "link": "/products/perfect-dog-food-mix"
      },
      {
        "text": "Perfect Wild Alaskan Salmon Oil",
        "link": "/products/perfect-wild-alaskan-salmon-oil"
      }
    ]
  },
  {
    "ing": [
      "Inulin"
    ],
    "dsc": "Inulin is a prebiotic that enhances growth and controls pathogenic bacteria in livestock.",
    "journal": "British Journal of Nutrition, 2002",
    "citation": {
      "text": "Flickinger EA, Fahey GC Jr. Pet food and feed applications of inulin, oligofructose and other oligosaccharides. Br J Nutr. 2002 May;87 Suppl 2:S297-300. doi: 10.1079/BJNBJN/2002552. PMID: 12088533. [*]",
      "link": "https://pubmed.ncbi.nlm.nih.gov/12088533/"
    },
    "prods": [
      {
        "text": "Perfect Kibble Beef",
        "link": "/products/perfect-kibble-beef"
      },
      {
        "text": "Perfect Kibble Chicken",
        "link": "/products/perfect-kibble"
      },
      {
        "text": "Perfect Dog Food Mix",
        "link": "/products/perfect-dog-food-mix"
      },
      {
        "text": "Perfect Wild Alaskan Salmon Oil",
        "link": "/products/perfect-wild-alaskan-salmon-oil"
      }
    ]
  },
  {
    "ing": [
      "Inulin"
    ],
    "dsc": "Inulin increases beneficial microbiota and decreases harmful microbiota in mice.",
    "journal": "PLoS One, 2019",
    "citation": {
      "text": "Hoffman JD, Yanckello LM, Chlipala G, et al. Dietary inulin alters the gut microbiome, enhances systemic metabolism and reduces neuroinflammation in an APOE4 mouse model. PLoS One. 2019;14(8):e0221828. Published 2019 Aug 28. doi:10.1371/journal.pone.0221828 [*]",
      "link": "https://www.ncbi.nlm.nih.gov/pmc/articles/PMC6713395/"
    },
    "prods": [
      {
        "text": "Perfect Kibble Beef",
        "link": "/products/perfect-kibble-beef"
      },
      {
        "text": "Perfect Kibble Chicken",
        "link": "/products/perfect-kibble"
      },
      {
        "text": "Perfect Dog Food Mix",
        "link": "/products/perfect-dog-food-mix"
      },
      {
        "text": "Perfect Wild Alaskan Salmon Oil",
        "link": "/products/perfect-wild-alaskan-salmon-oil"
      }
    ]
  },
  {
    "ing": [
      "Inulin"
    ],
    "dsc": "Inulin augments gut health and improve livestock vitality.",
    "journal": "Brazilian Journal of Microbiology, 2013",
    "citation": {
      "text": "Samanta AK, Jayapal N, Senani S, Kolte AP, Sridhar M. Prebiotic inulin: Useful dietary adjuncts to manipulate the livestock gut microflora. Braz J Microbiol. 2013;44(1):1-14. Published 2013 May 7. doi:10.1590/S1517-83822013005000023 [*]",
      "link": "https://www.ncbi.nlm.nih.gov/pmc/articles/PMC3804171/"
    },
    "prods": [
      {
        "text": "Perfect Kibble Beef",
        "link": "/products/perfect-kibble-beef"
      },
      {
        "text": "Perfect Kibble Chicken",
        "link": "/products/perfect-kibble"
      },
      {
        "text": "Perfect Dog Food Mix",
        "link": "/products/perfect-dog-food-mix"
      },
      {
        "text": "Perfect Wild Alaskan Salmon Oil",
        "link": "/products/perfect-wild-alaskan-salmon-oil"
      }
    ]
  },
  {
    "ing": [
      "Inulin"
    ],
    "dsc": "Inulin increased the number of beneficial bacteria in humans, and reduced the abundance of pathogenic bacteria.",
    "journal": "European Journal of Clinical Microbiology & Infectious Diseases, 2020",
    "citation": {
      "text": "Le Bastard Q, Chapelet G, Javaudin F, Lepelletier D, Batard E, Montassier E. The effects of inulin on gut microbial composition: a systematic review of evidence from human studies. Eur J Clin Microbiol Infect Dis. 2020 Mar;39(3):403-413. doi: 10.1007/s10096-019-03721-w. Epub 2019 Nov 9. PMID: 31707507. [*]",
      "link": "https://pubmed.ncbi.nlm.nih.gov/31707507/"
    },
    "prods": [
      {
        "text": "Perfect Kibble Beef",
        "link": "/products/perfect-kibble-beef"
      },
      {
        "text": "Perfect Kibble Chicken",
        "link": "/products/perfect-kibble"
      },
      {
        "text": "Perfect Dog Food Mix",
        "link": "/products/perfect-dog-food-mix"
      },
      {
        "text": "Perfect Wild Alaskan Salmon Oil",
        "link": "/products/perfect-wild-alaskan-salmon-oil"
      }
    ]
  },
  {
    "ing": [
      "Inulin"
    ],
    "dsc": "Inulin diets are regarded as hypoallergenic.",
    "journal": "British Journal of Nutrition, 2006",
    "citation": {
      "text": "Verlinden A, Hesta M, Hermans JM, Janssens GP. The effects of inulin supplementation of diets with or without hydrolysed protein sources on digestibility, faecal characteristics, haematology and immunoglobulins in dogs. Br J Nutr. 2006 Nov;96(5):936-44. doi: 10.1017/bjn20061912. PMID: 17092385. [*]",
      "link": "https://pubmed.ncbi.nlm.nih.gov/17092385/"
    },
    "prods": [
      {
        "text": "Perfect Kibble Beef",
        "link": "/products/perfect-kibble-beef"
      },
      {
        "text": "Perfect Kibble Chicken",
        "link": "/products/perfect-kibble"
      },
      {
        "text": "Perfect Dog Food Mix",
        "link": "/products/perfect-dog-food-mix"
      },
      {
        "text": "Perfect Wild Alaskan Salmon Oil",
        "link": "/products/perfect-wild-alaskan-salmon-oil"
      }
    ]
  },
  {
    "ing": [
      "Kelp"
    ],
    "dsc": "Kelp may aid recovery of pancreatici islet cells secreting function and reduce blood glucose levels.",
    "journal": "International Journal of Molecular Sciencies, 2012",
    "citation": {
      "text": "Long SH, Yu ZQ, Shuai L, et al. The hypoglycemic effect of the kelp on diabetes mellitus model induced by alloxan in rats. Int J Mol Sci. 2012;13(3):3354-3365. doi:10.3390/ijms13033354 [*]",
      "link": "https://www.ncbi.nlm.nih.gov/pmc/articles/PMC3317716/"
    },
    "prods": []
  },
  {
    "ing": [
      "Kelp"
    ],
    "dsc": "Kelp supplementation increases stimulation of thyroid-stimulating hormone.",
    "journal": "Endocrine Practice, 2003",
    "citation": {
      "text": "Clark CD, Bassett B, Burge MR. Effects of kelp supplementation on thyroid function in euthyroid subjects. Endocr Pract. 2003 Sep-Oct;9(5):363-9. doi: 10.4158/EP.9.5.363. PMID: 14583417. [*]",
      "link": "https://pubmed.ncbi.nlm.nih.gov/14583417/"
    },
    "prods": []
  },
  {
    "ing": [
      "Low carb"
    ],
    "dsc": "Low to moderate carb diets in diabetic dogs improve glucose, insulin, and triglyceride levels.",
    "journal": "Research in Veterinary Science, 2012",
    "citation": {
      "text": "Elliott KF, Rand JS, Fleeman LM, Morton JM, Litster AL, Biourge VC, Markwell PJ. A diet lower in digestible carbohydrate results in lower postprandial glucose concentrations compared with a traditional canine diabetes diet and an adult maintenance diet in healthy dogs. Res Vet Sci. 2012 Aug;93(1):288-95. doi: 10.1016/j.rvsc.2011.07.032. Epub 2011 Sep 22. PMID: 21944832. [*]",
      "link": "https://pubmed.ncbi.nlm.nih.gov/21944832/"
    },
    "prods": [
      {
        "text": "Perfect Kibble Beef",
        "link": "/products/perfect-kibble-beef"
      },
      {
        "text": "Perfect Kibble Chicken",
        "link": "/products/perfect-kibble"
      },
      {
        "text": "Perfect Dog Food Mix",
        "link": "/products/perfect-dog-food-mix"
      },
      {
        "text": "Perfect Wild Alaskan Salmon Oil",
        "link": "/products/perfect-wild-alaskan-salmon-oil"
      }
    ]
  },
  {
    "ing": [
      "Low carb"
    ],
    "dsc": "Dietary restruction increased median life span and delayed the onset signs of chronic disease in dogs.",
    "journal": "Journal of the American Veterinary Medical Association, 2002",
    "citation": {
      "text": "Kealy RD, Lawler DF, Ballam JM, Mantz SL, Biery DN, Greeley EH, Lust G, Segre M, Smith GK, Stowe HD. Effects of diet restriction on life span and age-related changes in dogs. J Am Vet Med Assoc. 2002 May 1;220(9):1315-20. doi: 10.2460/javma.2002.220.1315. PMID: 11991408. [*]",
      "link": "https://pubmed.ncbi.nlm.nih.gov/11991408/"
    },
    "prods": [
      {
        "text": "Perfect Kibble Beef",
        "link": "/products/perfect-kibble-beef"
      },
      {
        "text": "Perfect Kibble Chicken",
        "link": "/products/perfect-kibble"
      },
      {
        "text": "Perfect Dog Food Mix",
        "link": "/products/perfect-dog-food-mix"
      },
      {
        "text": "Perfect Wild Alaskan Salmon Oil",
        "link": "/products/perfect-wild-alaskan-salmon-oil"
      }
    ]
  },
  {
    "ing": [
      "Low carb"
    ],
    "dsc": "Diets low in carbs, high in protein, and moderate fat content can prevent and manage obesity and diabetes in dogs.",
    "journal": "Diabetes, 1967",
    "citation": {
      "text": "Vanden Heuvel JP. Diet, fatty acids, and regulation of genes important for heart disease. Curr Atheroscler Rep. 2004 Nov;6(6):432-40. doi: 10.1007/s11883-004-0083-9. PMID: 15485588. [*]",
      "link": "https://pubmed.ncbi.nlm.nih.gov/6066834/"
    },
    "prods": [
      {
        "text": "Perfect Kibble Beef",
        "link": "/products/perfect-kibble-beef"
      },
      {
        "text": "Perfect Kibble Chicken",
        "link": "/products/perfect-kibble"
      },
      {
        "text": "Perfect Dog Food Mix",
        "link": "/products/perfect-dog-food-mix"
      },
      {
        "text": "Perfect Wild Alaskan Salmon Oil",
        "link": "/products/perfect-wild-alaskan-salmon-oil"
      }
    ]
  },
  {
    "ing": [
      "Low carb",
      "Fresh meat"
    ],
    "dsc": "Low carb, high protein diet slowed glucose release, improved digestibility, and reduced intestinal fermentation in working dogs.",
    "journal": "New Zealnad Veterinary Journal, 2009",
    "citation": {
      "text": "Hill SR, Rutherfurd-Markwick KJ, Ravindran G, Ugarte CE, Thomas DG. The effects of the proportions of dietary macronutrients on the digestibility, post-prandial endocrine responses and large intestinal fermentation of carbohydrate in working dogs. N Z Vet J. 2009 Dec;57(6):313-8. doi: 10.1080/00480169.2009.64718. PMID: 19966890. [*]",
      "link": "https://pubmed.ncbi.nlm.nih.gov/19966890/"
    },
    "prods": [
      {
        "text": "Perfect Kibble Beef",
        "link": "/products/perfect-kibble-beef"
      },
      {
        "text": "Perfect Kibble Chicken",
        "link": "/products/perfect-kibble"
      }
    ]
  },
  {
    "ing": [
      "Low carb",
      "Fresh meat"
    ],
    "dsc": "Increase in dietary protein and reduced carb/protein reation stabilise bluud glucose levels and reduce postprandial insulin response.",
    "journal": "Journal of Nutrition, 2003",
    "citation": {
      "text": "Layman DK, Shiue H, Sather C, Erickson DJ, Baum J. Increased dietary protein modifies glucose and insulin homeostasis in adult women during weight loss. J Nutr. 2003 Feb;133(2):405-10. doi: 10.1093/jn/133.2.405. PMID: 12566475. [*]",
      "link": "https://pubmed.ncbi.nlm.nih.gov/12566475/"
    },
    "prods": [
      {
        "text": "Perfect Kibble Beef",
        "link": "/products/perfect-kibble-beef"
      },
      {
        "text": "Perfect Kibble Chicken",
        "link": "/products/perfect-kibble"
      }
    ]
  },
  {
    "ing": [
      "Low carb",
      "Fresh meat"
    ],
    "dsc": "Low, high fat and protein diets best support working dogs ad maintain thyroid health.",
    "journal": "Animals, 2019",
    "citation": {
      "text": "Chiofalo B, Fazio E, Cucinotta S, Cravana C. Thyroid and Lipid Status in Guide Dogs During Training: Effects of Dietary Protein and Fat Content. Animals (Basel). 2019;9(9):597. Published 2019 Aug 23. doi:10.3390/ani9090597 [*]",
      "link": "https://www.ncbi.nlm.nih.gov/pmc/articles/PMC6769750/"
    },
    "prods": [
      {
        "text": "Perfect Kibble Beef",
        "link": "/products/perfect-kibble-beef"
      },
      {
        "text": "Perfect Kibble Chicken",
        "link": "/products/perfect-kibble"
      }
    ]
  },
  {
    "ing": [
      "Low carb",
      "Fresh meat"
    ],
    "dsc": "Low carb, high protein diet improves weight loss in obese dogs.",
    "journal": "Journal of Nutrition, 2002",
    "citation": {
      "text": "Diez M, Nguyen P, Jeusette I, Devois C, Istasse L, Biourge V. Weight loss in obese dogs: evaluation of a high-protein, low-carbohydrate diet. J Nutr. 2002 Jun;132(6 Suppl 2):1685S-7S. doi: 10.1093/jn/132.6.1685S. PMID: 12042493. [*]",
      "link": "https://pubmed.ncbi.nlm.nih.gov/12042493/"
    },
    "prods": [
      {
        "text": "Perfect Kibble Beef",
        "link": "/products/perfect-kibble-beef"
      },
      {
        "text": "Perfect Kibble Chicken",
        "link": "/products/perfect-kibble"
      }
    ]
  },
  {
    "ing": [
      "Low carb"
    ],
    "dsc": "Working dogs fed an ultra-low carb diet saw lower intestitial glucose concentrations - though activity levels decreased.",
    "journal": "PLoS One, 2021",
    "citation": {
      "text": "Gal A, Cuttance W, Cave N, Lopez-Villalobos N, Herndon A, Giles J, Burchell R. Less is more? Ultra-low carbohydrate diet and working dogs' performance. PLoS One. 2021 Dec 23;16(12):e0261506. doi: 10.1371/journal.pone.0261506. PMID: 34941910; PMCID: PMC8699952. [*]",
      "link": "https://pubmed.ncbi.nlm.nih.gov/34941910/"
    },
    "prods": [
      {
        "text": "Perfect Kibble Beef",
        "link": "/products/perfect-kibble-beef"
      },
      {
        "text": "Perfect Kibble Chicken",
        "link": "/products/perfect-kibble"
      },
      {
        "text": "Perfect Dog Food Mix",
        "link": "/products/perfect-dog-food-mix"
      },
      {
        "text": "Perfect Wild Alaskan Salmon Oil",
        "link": "/products/perfect-wild-alaskan-salmon-oil"
      }
    ]
  },
  {
    "ing": [
      "Low carb"
    ],
    "dsc": "Carbohydrates are critical to dog's diets when supplied in the correct proportions.",
    "journal": "Canadian Journal of Veterinary Research, 1990",
    "citation": {
      "text": "Hilton J. Carbohydrates in the nutrition of the dog. Can Vet J. 1990;31(2):128-129. [*]",
      "link": "https://www.ncbi.nlm.nih.gov/pmc/articles/PMC1480633/"
    },
    "prods": [
      {
        "text": "Perfect Kibble Beef",
        "link": "/products/perfect-kibble-beef"
      },
      {
        "text": "Perfect Kibble Chicken",
        "link": "/products/perfect-kibble"
      },
      {
        "text": "Perfect Dog Food Mix",
        "link": "/products/perfect-dog-food-mix"
      },
      {
        "text": "Perfect Wild Alaskan Salmon Oil",
        "link": "/products/perfect-wild-alaskan-salmon-oil"
      }
    ]
  },
  {
    "ing": [
      "Low carb"
    ],
    "dsc": "The high protein low carb diet-fed dogs showed greater abundances of Firmicutes but fewer numbers of Bacteroidetes than other dogs - potential weight loss strategy.",
    "journal": "mBio, 2017",
    "citation": {
      "text": "Li Q, Lauber CL, Czarnecki-Maulden G, Pan Y, Hannah SS. Effects of the Dietary Protein and Carbohydrate Ratio on Gut Microbiomes in Dogs of Different Body Conditions. mBio. 2017 Jan 24;8(1):e01703-16. doi: 10.1128/mBio.01703-16. PMID: 28119466; PMCID: PMC5263242. [*]",
      "link": "https://pubmed.ncbi.nlm.nih.gov/28119466/"
    },
    "prods": [
      {
        "text": "Perfect Kibble Beef",
        "link": "/products/perfect-kibble-beef"
      },
      {
        "text": "Perfect Kibble Chicken",
        "link": "/products/perfect-kibble"
      },
      {
        "text": "Perfect Dog Food Mix",
        "link": "/products/perfect-dog-food-mix"
      },
      {
        "text": "Perfect Wild Alaskan Salmon Oil",
        "link": "/products/perfect-wild-alaskan-salmon-oil"
      }
    ]
  },
  {
    "ing": [
      "Low carb"
    ],
    "dsc": "The HPLC diet is a safe and effective option for medically supervised weight loss in severely obese adolescents.",
    "journal": "Journal of Pediatrics, 2010",
    "citation": {
      "text": "Krebs NF, Gao D, Gralla J, Collins JS, Johnson SL. Efficacy and safety of a high protein, low carbohydrate diet for weight loss in severely obese adolescents. J Pediatr. 2010 Aug;157(2):252-8. doi: 10.1016/j.jpeds.2010.02.010. Epub 2010 Mar 20. PMID: 20304413; PMCID: PMC2892194. [*]",
      "link": "https://pubmed.ncbi.nlm.nih.gov/20304413/"
    },
    "prods": [
      {
        "text": "Perfect Kibble Beef",
        "link": "/products/perfect-kibble-beef"
      },
      {
        "text": "Perfect Kibble Chicken",
        "link": "/products/perfect-kibble"
      },
      {
        "text": "Perfect Dog Food Mix",
        "link": "/products/perfect-dog-food-mix"
      },
      {
        "text": "Perfect Wild Alaskan Salmon Oil",
        "link": "/products/perfect-wild-alaskan-salmon-oil"
      }
    ]
  },
  {
    "ing": [
      "Low carb"
    ],
    "dsc": "High protein low carb diets are suitable for obesity-related conditions like type II diabetes as well as osteoarthritis.",
    "journal": "Veterinary Clinics of North America. Small Animal Practice, 2005",
    "citation": {
      "text": "Laflamme DP. Nutrition for aging cats and dogs and the importance of body condition. Vet Clin North Am Small Anim Pract. 2005 May;35(3):713-42. doi: 10.1016/j.cvsm.2004.12.011. PMID: 15833567. [*]",
      "link": "https://pubmed.ncbi.nlm.nih.gov/15833567/"
    },
    "prods": [
      {
        "text": "Perfect Kibble Beef",
        "link": "/products/perfect-kibble-beef"
      },
      {
        "text": "Perfect Kibble Chicken",
        "link": "/products/perfect-kibble"
      },
      {
        "text": "Perfect Dog Food Mix",
        "link": "/products/perfect-dog-food-mix"
      },
      {
        "text": "Perfect Wild Alaskan Salmon Oil",
        "link": "/products/perfect-wild-alaskan-salmon-oil"
      }
    ]
  },
  {
    "ing": [
      "Minimally-processed"
    ],
    "dsc": "Review: low fats reduce the risk of cancer, blood pressure, and cardiovascular disease in people.",
    "journal": "Cochrane Database of Systematic Reviews, 2015",
    "citation": {
      "text": "Hooper L, Martin N, Abdelhamid A, Davey Smith G. Reduction in saturated fat intake for cardiovascular disease. Cochrane Database Syst Rev. 2015 Jun 10;(6):CD011737. doi: 10.1002/14651858.CD011737. Update in: Cochrane Database Syst Rev. 2020 May 19;5:CD011737. PMID: 26068959. [*]",
      "link": "https://pubmed.ncbi.nlm.nih.gov/26068959/"
    },
    "prods": [
      {
        "text": "Perfect Kibble Beef",
        "link": "/products/perfect-kibble-beef"
      },
      {
        "text": "Perfect Kibble Chicken",
        "link": "/products/perfect-kibble"
      },
      {
        "text": "Perfect Dog Food Mix",
        "link": "/products/perfect-dog-food-mix"
      },
      {
        "text": "Perfect Wild Alaskan Salmon Oil",
        "link": "/products/perfect-wild-alaskan-salmon-oil"
      },
      {
        "text": "Perfect Probiotics Food Topper",
        "link": "/products/perfect-probiotics-dog-food-topper"
      }
    ]
  },
  {
    "ing": [
      "Minimally-processed",
      "Fresh meat"
    ],
    "dsc": "Commercial dog foods often have low nutritional value and digestibility.",
    "journal": "Journal of Nutritional Science, 2014",
    "citation": {
      "text": "Daumas C, Paragon BM, Thorin C, et al. Evaluation of eight commercial dog diets. J Nutr Sci. 2014;3:e63. Published 2014 Dec 30. doi:10.1017/jns.2014.65 [*]",
      "link": "https://www.ncbi.nlm.nih.gov/pmc/articles/PMC4473150/"
    },
    "prods": [
      {
        "text": "Perfect Kibble Beef",
        "link": "/products/perfect-kibble-beef"
      },
      {
        "text": "Perfect Kibble Chicken",
        "link": "/products/perfect-kibble"
      }
    ]
  },
  {
    "ing": [
      "Minimally-processed"
    ],
    "dsc": "Processed commercial dog foods met only minimum mutritional requirements, not optimum levels.",
    "journal": "Veterinary Research Communications, 2021",
    "citation": {
      "text": "Kazimierska K, Biel W, Witkowicz R, Karakulska J, Stachurska X. Evaluation of nutritional value and microbiological safety in commercial dog food. Vet Res Commun. 2021;45(2-3):111-128. doi:10.1007/s11259-021-09791-6 [*]",
      "link": "https://www.ncbi.nlm.nih.gov/pmc/articles/PMC8373756/"
    },
    "prods": [
      {
        "text": "Perfect Kibble Beef",
        "link": "/products/perfect-kibble-beef"
      },
      {
        "text": "Perfect Kibble Chicken",
        "link": "/products/perfect-kibble"
      },
      {
        "text": "Perfect Dog Food Mix",
        "link": "/products/perfect-dog-food-mix"
      },
      {
        "text": "Perfect Wild Alaskan Salmon Oil",
        "link": "/products/perfect-wild-alaskan-salmon-oil"
      },
      {
        "text": "Perfect Probiotics Food Topper",
        "link": "/products/perfect-probiotics-dog-food-topper"
      }
    ]
  },
  {
    "ing": [
      "Minimally-processed"
    ],
    "dsc": "Gut microbiota more diverse and abundant in natural rather than commercial dog food.",
    "journal": "Gut Pathogens, 2017",
    "citation": {
      "text": "Kim J, An JU, Kim W, Lee S, Cho S. Differences in the gut microbiota of dogs (Canis lupus familiaris) fed a natural diet or a commercial feed revealed by the Illumina MiSeq platform. Gut Pathog. 2017;9:68. Published 2017 Nov 21. doi:10.1186/s13099-017-0218-5 [*]",
      "link": "https://www.ncbi.nlm.nih.gov/pmc/articles/PMC5697093/"
    },
    "prods": [
      {
        "text": "Perfect Kibble Beef",
        "link": "/products/perfect-kibble-beef"
      },
      {
        "text": "Perfect Kibble Chicken",
        "link": "/products/perfect-kibble"
      },
      {
        "text": "Perfect Dog Food Mix",
        "link": "/products/perfect-dog-food-mix"
      },
      {
        "text": "Perfect Wild Alaskan Salmon Oil",
        "link": "/products/perfect-wild-alaskan-salmon-oil"
      },
      {
        "text": "Perfect Probiotics Food Topper",
        "link": "/products/perfect-probiotics-dog-food-topper"
      }
    ]
  },
  {
    "ing": [
      "Minimally-processed"
    ],
    "dsc": "Dogs adjust their food preferences depend on their characteristics.",
    "journal": "Animals, 2019",
    "citation": {
      "text": "Alegría-Morán RA, Guzmán-Pino SA, Egaña JI, Muñoz C, Figueroa J. Food Preferences in Dogs: Effect of Dietary Composition and Intrinsic Variables on Diet Selection. Animals (Basel). 2019;9(5):219. Published 2019 May 6. doi:10.3390/ani9050219 [*]",
      "link": "https://www.ncbi.nlm.nih.gov/pmc/articles/PMC6562821/"
    },
    "prods": [
      {
        "text": "Perfect Kibble Beef",
        "link": "/products/perfect-kibble-beef"
      },
      {
        "text": "Perfect Kibble Chicken",
        "link": "/products/perfect-kibble"
      },
      {
        "text": "Perfect Dog Food Mix",
        "link": "/products/perfect-dog-food-mix"
      },
      {
        "text": "Perfect Wild Alaskan Salmon Oil",
        "link": "/products/perfect-wild-alaskan-salmon-oil"
      },
      {
        "text": "Perfect Probiotics Food Topper",
        "link": "/products/perfect-probiotics-dog-food-topper"
      }
    ]
  },
  {
    "ing": [
      "Minimally-processed"
    ],
    "dsc": "Commercial pet food does not meet the needs of every pet.",
    "journal": "Veterinary Clinics of North America. Small Animal Practice, 2021",
    "citation": {
      "text": "Sanderson SL. Pros and Cons of Commercial Pet Foods (Including Grain/Grain Free) for Dogs and Cats. Vet Clin North Am Small Anim Pract. 2021 May;51(3):529-550. doi: 10.1016/j.cvsm.2021.01.009. PMID: 33773644. [*]",
      "link": "https://pubmed.ncbi.nlm.nih.gov/33773644/"
    },
    "prods": [
      {
        "text": "Perfect Kibble Beef",
        "link": "/products/perfect-kibble-beef"
      },
      {
        "text": "Perfect Kibble Chicken",
        "link": "/products/perfect-kibble"
      },
      {
        "text": "Perfect Dog Food Mix",
        "link": "/products/perfect-dog-food-mix"
      },
      {
        "text": "Perfect Wild Alaskan Salmon Oil",
        "link": "/products/perfect-wild-alaskan-salmon-oil"
      },
      {
        "text": "Perfect Probiotics Food Topper",
        "link": "/products/perfect-probiotics-dog-food-topper"
      }
    ]
  },
  {
    "ing": [
      "Minimally-processed"
    ],
    "dsc": "Owners of obese dogs were less likely to care about the quality of ingredients and nutritional composition of dog food.",
    "journal": "Journal of Animal Physiology and Animal Nutrition, 2012",
    "citation": {
      "text": "Suarez L, Peña C, Carretón E, Juste MC, Bautista-Castaño I, Montoya-Alonso JA. Preferences of owners of overweight dogs when buying commercial pet food. J Anim Physiol Anim Nutr (Berl). 2012 Aug;96(4):655-9. doi: 10.1111/j.1439-0396.2011.01193.x. Epub 2011 Jul 6. PMID: 21732995. [*]",
      "link": "https://pubmed.ncbi.nlm.nih.gov/21732995/"
    },
    "prods": [
      {
        "text": "Perfect Kibble Beef",
        "link": "/products/perfect-kibble-beef"
      },
      {
        "text": "Perfect Kibble Chicken",
        "link": "/products/perfect-kibble"
      },
      {
        "text": "Perfect Dog Food Mix",
        "link": "/products/perfect-dog-food-mix"
      },
      {
        "text": "Perfect Wild Alaskan Salmon Oil",
        "link": "/products/perfect-wild-alaskan-salmon-oil"
      },
      {
        "text": "Perfect Probiotics Food Topper",
        "link": "/products/perfect-probiotics-dog-food-topper"
      }
    ]
  },
  {
    "ing": [
      "Minimally-processed"
    ],
    "dsc": "Of the 27 foods, 25 met or exceeded the AAFCO nutrient recommendations. Only 9 foods met all nutrient content claims listed in their guaranteed analyses.",
    "journal": "Canadian Veterinary Journal, 2018",
    "citation": {
      "text": "Burdett SW, Mansilla WD, Shoveller AK. Many Canadian dog and cat foods fail to comply with the guaranteed analyses reported on packages. Can Vet J. 2018 Nov;59(11):1181-1186. PMID: 30410174; PMCID: PMC6190176. [*]",
      "link": "https://pubmed.ncbi.nlm.nih.gov/30410174/"
    },
    "prods": [
      {
        "text": "Perfect Kibble Beef",
        "link": "/products/perfect-kibble-beef"
      },
      {
        "text": "Perfect Kibble Chicken",
        "link": "/products/perfect-kibble"
      },
      {
        "text": "Perfect Dog Food Mix",
        "link": "/products/perfect-dog-food-mix"
      },
      {
        "text": "Perfect Wild Alaskan Salmon Oil",
        "link": "/products/perfect-wild-alaskan-salmon-oil"
      },
      {
        "text": "Perfect Probiotics Food Topper",
        "link": "/products/perfect-probiotics-dog-food-topper"
      }
    ]
  },
  {
    "ing": [
      "Minimally-processed"
    ],
    "dsc": "With the exception of Se, all trace elements were supplied above the nutritional requirements of adult dogs. Legal limits of Cu, Se, and Zn were surpassed.",
    "journal": "Journal of Agricultural Food Chemistry, 2018",
    "citation": {
      "text": "Pereira AM, Pinto E, Matos E, Castanheira F, Almeida AA, Baptista CS, Segundo MA, Fonseca AJM, Cabrita ARJ. Mineral Composition of Dry Dog Foods: Impact on Nutrition and Potential Toxicity. J Agric Food Chem. 2018 Jul 25;66(29):7822-7830. doi: 10.1021/acs.jafc.8b02552. Epub 2018 Jul 11. PMID: 29953228. [*]",
      "link": "https://pubmed.ncbi.nlm.nih.gov/29953228/"
    },
    "prods": [
      {
        "text": "Perfect Kibble Beef",
        "link": "/products/perfect-kibble-beef"
      },
      {
        "text": "Perfect Kibble Chicken",
        "link": "/products/perfect-kibble"
      },
      {
        "text": "Perfect Dog Food Mix",
        "link": "/products/perfect-dog-food-mix"
      },
      {
        "text": "Perfect Wild Alaskan Salmon Oil",
        "link": "/products/perfect-wild-alaskan-salmon-oil"
      },
      {
        "text": "Perfect Probiotics Food Topper",
        "link": "/products/perfect-probiotics-dog-food-topper"
      }
    ]
  },
  {
    "ing": [
      "Minimally-processed"
    ],
    "dsc": "Functional foods modify gastrointestinal physiology, promote changes in biochemical parameters, improve brain functions and may reduce or minimize the risk of developing specific pathologies.",
    "journal": "Research in Veterinary Science, 2017",
    "citation": {
      "text": "Di Cerbo A, Morales-Medina JC, Palmieri B, Pezzuto F, Cocco R, Flores G, Iannitti T. Functional foods in pet nutrition: Focus on dogs and cats. Res Vet Sci. 2017 Jun;112:161-166. doi: 10.1016/j.rvsc.2017.03.020. Epub 2017 Apr 7. PMID: 28433933. [*]",
      "link": "https://pubmed.ncbi.nlm.nih.gov/28433933/"
    },
    "prods": [
      {
        "text": "Perfect Kibble Beef",
        "link": "/products/perfect-kibble-beef"
      },
      {
        "text": "Perfect Kibble Chicken",
        "link": "/products/perfect-kibble"
      },
      {
        "text": "Perfect Dog Food Mix",
        "link": "/products/perfect-dog-food-mix"
      },
      {
        "text": "Perfect Wild Alaskan Salmon Oil",
        "link": "/products/perfect-wild-alaskan-salmon-oil"
      },
      {
        "text": "Perfect Probiotics Food Topper",
        "link": "/products/perfect-probiotics-dog-food-topper"
      }
    ]
  },
  {
    "ing": [
      "Minimally-processed"
    ],
    "dsc": "The inclusion of whole food ingredients in natural pet foods as opposed to fractionated ingredients may result in higher nutrient concentrations, including phytonutrients. Additionally, the processing of commercial pet food can impact digestibility, nutrient bioavailability, and safety, which are particularly important considerations with new product formats in the natural pet food category.",
    "journal": "Journal of Animal Science, 2014",
    "citation": {
      "text": "Buff PR, Carter RA, Bauer JE, Kersey JH. Natural pet food: a review of natural diets and their impact on canine and feline physiology. J Anim Sci. 2014 Sep;92(9):3781-91. doi: 10.2527/jas.2014-7789. Epub 2014 Jul 8. PMID: 25006071. [*]",
      "link": "https://pubmed.ncbi.nlm.nih.gov/25006071/"
    },
    "prods": [
      {
        "text": "Perfect Kibble Beef",
        "link": "/products/perfect-kibble-beef"
      },
      {
        "text": "Perfect Kibble Chicken",
        "link": "/products/perfect-kibble"
      },
      {
        "text": "Perfect Dog Food Mix",
        "link": "/products/perfect-dog-food-mix"
      },
      {
        "text": "Perfect Wild Alaskan Salmon Oil",
        "link": "/products/perfect-wild-alaskan-salmon-oil"
      },
      {
        "text": "Perfect Probiotics Food Topper",
        "link": "/products/perfect-probiotics-dog-food-topper"
      }
    ]
  },
  {
    "ing": [
      "Minimally-processed"
    ],
    "dsc": "Eighteen tested dog foods (60%) did not meet at least one recommendation of nutritional guidelines. Four dog foods exceeded the legal limit of Fe and five foods exceeded the legal limit of Zn; in one of them, Zn level was almost twice higher.",
    "journal": "Molecules, 2020",
    "citation": {
      "text": "Kazimierska K, Biel W, Witkowicz R. Mineral Composition of Cereal and Cereal-Free Dry Dog Foods versus Nutritional Guidelines. Molecules. 2020 Nov 6;25(21):5173. doi: 10.3390/molecules25215173. PMID: 33172044; PMCID: PMC7664208. [*]",
      "link": "https://pubmed.ncbi.nlm.nih.gov/33172044/"
    },
    "prods": [
      {
        "text": "Perfect Kibble Beef",
        "link": "/products/perfect-kibble-beef"
      },
      {
        "text": "Perfect Kibble Chicken",
        "link": "/products/perfect-kibble"
      },
      {
        "text": "Perfect Dog Food Mix",
        "link": "/products/perfect-dog-food-mix"
      },
      {
        "text": "Perfect Wild Alaskan Salmon Oil",
        "link": "/products/perfect-wild-alaskan-salmon-oil"
      },
      {
        "text": "Perfect Probiotics Food Topper",
        "link": "/products/perfect-probiotics-dog-food-topper"
      }
    ]
  },
  {
    "ing": [
      "Minimally-processed"
    ],
    "dsc": "Human-grade pet foods are highly digestible and suitable for canine nutrition.",
    "journal": "Translational Animal Science, 2019",
    "citation": {
      "text": "Oba PM, Utterback PL, Parsons CM, Swanson KS. True nutrient and amino acid digestibility of dog foods made with human-grade ingredients using the precision-fed cecectomized rooster assay. Transl Anim Sci. 2019 Dec 6;4(1):442-451. doi: 10.1093/tas/txz175. PMID: 32705002; PMCID: PMC6994059. [*]",
      "link": "https://pubmed.ncbi.nlm.nih.gov/32705002/"
    },
    "prods": [
      {
        "text": "Perfect Kibble Beef",
        "link": "/products/perfect-kibble-beef"
      },
      {
        "text": "Perfect Kibble Chicken",
        "link": "/products/perfect-kibble"
      },
      {
        "text": "Perfect Dog Food Mix",
        "link": "/products/perfect-dog-food-mix"
      },
      {
        "text": "Perfect Wild Alaskan Salmon Oil",
        "link": "/products/perfect-wild-alaskan-salmon-oil"
      },
      {
        "text": "Perfect Probiotics Food Topper",
        "link": "/products/perfect-probiotics-dog-food-topper"
      }
    ]
  },
  {
    "ing": [
      "Minimally-processed"
    ],
    "dsc": "Claims of nutritional adequacy of pet foods based on the current Association of American Feed Control Official (AAFCO) nutrient allowances (\"profiles\") do not give assurances of nutritional adequacy",
    "journal": "Journal of Nutrition, 1994",
    "citation": {
      "text": "Morris JG, Rogers QR. Assessment of the nutritional adequacy of pet foods through the life cycle. J Nutr. 1994 Dec;124(12 Suppl):2520S-2534S. doi: 10.1093/jn/124.suppl_12.2520S. PMID: 7996231. [*]",
      "link": "https://pubmed.ncbi.nlm.nih.gov/7996231/"
    },
    "prods": [
      {
        "text": "Perfect Kibble Beef",
        "link": "/products/perfect-kibble-beef"
      },
      {
        "text": "Perfect Kibble Chicken",
        "link": "/products/perfect-kibble"
      },
      {
        "text": "Perfect Dog Food Mix",
        "link": "/products/perfect-dog-food-mix"
      },
      {
        "text": "Perfect Wild Alaskan Salmon Oil",
        "link": "/products/perfect-wild-alaskan-salmon-oil"
      },
      {
        "text": "Perfect Probiotics Food Topper",
        "link": "/products/perfect-probiotics-dog-food-topper"
      }
    ]
  },
  {
    "ing": [
      "Minimally-processed"
    ],
    "dsc": "Several commercial pet foods had amino acid bioavailablity below the realistic nutrient allowance estimates.",
    "journal": "Journal of Animal Science, 2015",
    "citation": {
      "text": "Hendriks WH, Bakker EJ, Bosch G. Protein and amino acid bioavailability estimates for canine foods. J Anim Sci. 2015 Oct;93(10):4788-95. doi: 10.2527/jas.2015-9231. PMID: 26523572. [*]",
      "link": "https://pubmed.ncbi.nlm.nih.gov/26523572/"
    },
    "prods": [
      {
        "text": "Perfect Kibble Beef",
        "link": "/products/perfect-kibble-beef"
      },
      {
        "text": "Perfect Kibble Chicken",
        "link": "/products/perfect-kibble"
      },
      {
        "text": "Perfect Dog Food Mix",
        "link": "/products/perfect-dog-food-mix"
      },
      {
        "text": "Perfect Wild Alaskan Salmon Oil",
        "link": "/products/perfect-wild-alaskan-salmon-oil"
      },
      {
        "text": "Perfect Probiotics Food Topper",
        "link": "/products/perfect-probiotics-dog-food-topper"
      }
    ]
  },
  {
    "ing": [
      "No peas or legumes"
    ],
    "dsc": "Peas and legums had the highest concentrations of 3P/FDA - a compound associated with canine dilated cardiomyopathy.",
    "journal": "Scientific Reports, 2021",
    "citation": {
      "text": "Smith CE, Parnell LD, Lai CQ, Rush JE, Freeman LM. Investigation of diets associated with dilated cardiomyopathy in dogs using foodomics analysis. Sci Rep. 2021 Aug 5;11(1):15881. doi: 10.1038/s41598-021-94464-2. PMID: 34354102; PMCID: PMC8342479. [*]",
      "link": "https://pubmed.ncbi.nlm.nih.gov/34354102/"
    },
    "prods": [
      {
        "text": "Perfect Kibble Beef",
        "link": "/products/perfect-kibble-beef"
      },
      {
        "text": "Perfect Kibble Chicken",
        "link": "/products/perfect-kibble"
      },
      {
        "text": "Perfect Dog Food Mix",
        "link": "/products/perfect-dog-food-mix"
      },
      {
        "text": "Perfect Wild Alaskan Salmon Oil",
        "link": "/products/perfect-wild-alaskan-salmon-oil"
      },
      {
        "text": "Perfect Probiotics Food Topper",
        "link": "/products/perfect-probiotics-dog-food-topper"
      }
    ]
  },
  {
    "ing": [
      "No peas or legumes"
    ],
    "dsc": "Food and Drug Administration warned about a possible relationship between dilated cardiomyopathy (DCM) in dogs and the consumption of dog food formulated with potatoes and pulse ingredients.",
    "journal": "Journal of Animal Science, 2019",
    "citation": {
      "text": "Mansilla WD, Marinangeli CPF, Ekenstedt KJ, et al. Special topic: The association between pulse ingredients and canine dilated cardiomyopathy: addressing the knowledge gaps before establishing causation. J Anim Sci. 2019;97(3):983-997. doi:10.1093/jas/sky488 [*]",
      "link": "https://www.ncbi.nlm.nih.gov/pmc/articles/PMC6396252/"
    },
    "prods": [
      {
        "text": "Perfect Kibble Beef",
        "link": "/products/perfect-kibble-beef"
      },
      {
        "text": "Perfect Kibble Chicken",
        "link": "/products/perfect-kibble"
      },
      {
        "text": "Perfect Dog Food Mix",
        "link": "/products/perfect-dog-food-mix"
      },
      {
        "text": "Perfect Wild Alaskan Salmon Oil",
        "link": "/products/perfect-wild-alaskan-salmon-oil"
      },
      {
        "text": "Perfect Probiotics Food Topper",
        "link": "/products/perfect-probiotics-dog-food-topper"
      }
    ]
  },
  {
    "ing": [
      "No peas or legumes"
    ],
    "dsc": "This systematic review supports inverse associations between eating nuts and incident IHD and diabetes and eating legumes and incident IHD.",
    "journal": "American Journal of Clinical Nutrition, 2014",
    "citation": {
      "text": "Afshin A, Micha R, Khatibzadeh S, Mozaffarian D. Consumption of nuts and legumes and risk of incident ischemic heart disease, stroke, and diabetes: a systematic review and meta-analysis. Am J Clin Nutr. 2014 Jul;100(1):278-88. doi: 10.3945/ajcn.113.076901. Epub 2014 Jun 4. PMID: 24898241; PMCID: PMC4144102. [*]",
      "link": "https://pubmed.ncbi.nlm.nih.gov/24898241/"
    },
    "prods": [
      {
        "text": "Perfect Kibble Beef",
        "link": "/products/perfect-kibble-beef"
      },
      {
        "text": "Perfect Kibble Chicken",
        "link": "/products/perfect-kibble"
      },
      {
        "text": "Perfect Dog Food Mix",
        "link": "/products/perfect-dog-food-mix"
      },
      {
        "text": "Perfect Wild Alaskan Salmon Oil",
        "link": "/products/perfect-wild-alaskan-salmon-oil"
      },
      {
        "text": "Perfect Probiotics Food Topper",
        "link": "/products/perfect-probiotics-dog-food-topper"
      }
    ]
  },
  {
    "ing": [
      "No peas or legumes",
      "Minimally-processed",
      "Fresh meat"
    ],
    "dsc": "All foods analyzed had one or more nutrients below the recommended levels and some presented zinc and copper excess, therefore, these foods should not be recommended for dogs and cats.",
    "journal": "PLoS One, 2020",
    "citation": {
      "text": "Zafalon RVA, Risolia LW, Vendramini THA, et al. Nutritional inadequacies in commercial vegan foods for dogs and cats. PLoS One. 2020;15(1):e0227046. Published 2020 Jan 17. doi:10.1371/journal.pone.0227046 [*]",
      "link": "https://www.ncbi.nlm.nih.gov/pmc/articles/PMC6968870/"
    },
    "prods": [
      {
        "text": "Perfect Kibble Beef",
        "link": "/products/perfect-kibble-beef"
      },
      {
        "text": "Perfect Kibble Chicken",
        "link": "/products/perfect-kibble"
      }
    ]
  },
  {
    "ing": [
      "Probiotics"
    ],
    "dsc": "Gut microbiome is critical to a the immune systema and systemic health.",
    "journal": "Frontiers in Veterinary Science, 2020",
    "citation": {
      "text": "Pilla R, Suchodolski JS. The Role of the Canine Gut Microbiome and Metabolome in Health and Gastrointestinal Disease. Front Vet Sci. 2020 Jan 14;6:498. doi: 10.3389/fvets.2019.00498. PMID: 31993446; PMCID: PMC6971114. [*]",
      "link": "https://pubmed.ncbi.nlm.nih.gov/31993446/"
    },
    "prods": []
  },
  {
    "ing": [
      "Probiotics"
    ],
    "dsc": "Probiotics and prebiotics can improve microbial diversity and normalise metabolism in diseased dogs.",
    "journal": "The Veterinary Clinical of North America. Small Animal Practice, 2021",
    "citation": {
      "text": "Pilla R, Suchodolski JS. The Gut Microbiome of Dogs and Cats, and the Influence of Diet. Vet Clin North Am Small Anim Pract. 2021 May;51(3):605-621. doi: 10.1016/j.cvsm.2021.01.002. Epub 2021 Feb 27. PMID: 33653538. [*]",
      "link": "https://pubmed.ncbi.nlm.nih.gov/33653538/"
    },
    "prods": []
  },
  {
    "ing": [
      "Probiotics"
    ],
    "dsc": "The skin microbiome has a lower species richness in allergic dogs than healthy dogs.",
    "journal": "PLoS One, 2014",
    "citation": {
      "text": "Rodrigues Hoffmann A, Patterson AP, Diesel A, Lawhon SD, Ly HJ, Elkins Stephenson C, Mansell J, Steiner JM, Dowd SE, Olivry T, Suchodolski JS. The skin microbiome in healthy and allergic dogs. PLoS One. 2014 Jan 8;9(1):e83197. doi: 10.1371/journal.pone.0083197. PMID: 24421875; PMCID: PMC3885435. [*]",
      "link": "https://pubmed.ncbi.nlm.nih.gov/24421875/"
    },
    "prods": []
  },
  {
    "ing": [
      "Probiotics"
    ],
    "dsc": "Probiotics reduce levels of IgE - a key indicator of allergy found in dogs.",
    "journal": "Clinical Infectious Diseases, 2008",
    "citation": {
      "text": "Walker WA. Mechanisms of action of probiotics. Clin Infect Dis. 2008 Feb 1;46 Suppl 2:S87-91; discussion S144-51. doi: 10.1086/523335. PMID: 18181730. [*]",
      "link": "https://pubmed.ncbi.nlm.nih.gov/18181730/"
    },
    "prods": []
  },
  {
    "ing": [
      "Probiotics"
    ],
    "dsc": "Early exposure to probiotics deceased allergen-specific IgE.",
    "journal": "Veterinary Immunology and Immunopathology, 2012",
    "citation": {
      "text": "Marsella R, Santoro D, Ahrens K. Early exposure to probiotics in a canine model of atopic dermatitis has long-term clinical and immunological effects. Vet Immunol Immunopathol. 2012 Apr 15;146(2):185-9. doi: 10.1016/j.vetimm.2012.02.013. Epub 2012 Mar 1. PMID: 22436376. [*]",
      "link": "https://pubmed.ncbi.nlm.nih.gov/22436376/"
    },
    "prods": []
  },
  {
    "ing": [
      "Probiotics"
    ],
    "dsc": "Beagle puppies exposure to probiotics had significantly less allergic markers.",
    "journal": "American Journal of Veterinary Research, 2009",
    "citation": {
      "text": "Marsella R. Evaluation of Lactobacillus rhamnosus strain GG for the prevention of atopic dermatitis in dogs. Am J Vet Res. 2009 Jun;70(6):735-40. doi: 10.2460/ajvr.70.6.735. PMID: 19496662. [*]",
      "link": "https://pubmed.ncbi.nlm.nih.gov/19496662/"
    },
    "prods": []
  },
  {
    "ing": [
      "Probiotics"
    ],
    "dsc": "Lactobacillus and Enterococcus are theorised to alter the immune cell response, stopping the allergic overreaction.",
    "journal": "Veterinary Sciences, 2020",
    "citation": {
      "text": "Marchegiani A, Fruganti A, Spaterna A, Dalle Vedove E, Bachetti B, Massimini M, Di Pierro F, Gavazza A, Cerquetella M. Impact of Nutritional Supplementation on Canine Dermatological Disorders. Vet Sci. 2020 Apr 3;7(2):38. doi: 10.3390/vetsci7020038. PMID: 32260299; PMCID: PMC7355824. [*]",
      "link": "https://pubmed.ncbi.nlm.nih.gov/32260299/"
    },
    "prods": []
  },
  {
    "ing": [
      "Probiotics"
    ],
    "dsc": "Healthy dogs did not show any negative GI or immune system effects form probiotic supplementation",
    "journal": "Anaerobe, 2015",
    "citation": {
      "text": "Grześkowiak Ł, Endo A, Beasley S, Salminen S. Microbiota and probiotics in canine and feline welfare. Anaerobe. 2015;34:14-23. doi:10.1016/j.anaerobe.2015.04.002 [*]",
      "link": "https://www.ncbi.nlm.nih.gov/pmc/articles/PMC7111060/#bib5"
    },
    "prods": []
  },
  {
    "ing": [
      "Probiotics"
    ],
    "dsc": "Decrease in GI dysbiosis and diarrhea in dogs receiving probiotics.",
    "journal": "Vet Record Open, 2021",
    "citation": {
      "text": "Jugan, Maria C et al. “Preliminary evaluation of probiotic effects on gastrointestinal signs in dogs with multicentric lymphoma undergoing multi-agent chemotherapy: A randomised, placebo-controlled study.” Veterinary record open vol. 8,1 e2. 29 Mar. 2021, doi:10.1002/vro2.2 [*]",
      "link": "https://www.ncbi.nlm.nih.gov/pmc/articles/PMC8109851/"
    },
    "prods": []
  },
  {
    "ing": [
      "Probiotics"
    ],
    "dsc": "GI microbiota critical for health and physiological functioning.",
    "journal": "Open Veterinary Journal, 2019",
    "citation": {
      "text": "Mondo E, Marliani G, Accorsi PA, Cocchi M, Di Leone A. Role of gut microbiota in dog and cat's health and diseases. Open Vet J. 2019;9(3):253-258. doi:10.4314/ovj.v9i3.10 [*]",
      "link": "https://www.ncbi.nlm.nih.gov/pmc/articles/PMC6794400/"
    },
    "prods": []
  },
  {
    "ing": [
      "Probiotics"
    ],
    "dsc": "Probiotic treatments in elderly dogs shifted gut bacteria towards a younger looking composition.",
    "journal": "Frontiers in Immunology, 2019",
    "citation": {
      "text": "Xu H, Huang W, Hou Q, et al. Oral Administration of Compound Probiotics Improved Canine Feed Intake, Weight Gain, Immunity and Intestinal Microbiota. Front Immunol. 2019;10:666. Published 2019 Apr 2. doi:10.3389/fimmu.2019.00666 [*]",
      "link": "https://www.ncbi.nlm.nih.gov/pmc/articles/PMC6454072/"
    },
    "prods": []
  },
  {
    "ing": [
      "Probiotics"
    ],
    "dsc": "Probiotics and diet help minimise GI disease.",
    "journal": "Journal of Veterinary Internal Medicine, 2019",
    "citation": {
      "text": "Jensen AP, Bjørnvad CR. Clinical effect of probiotics in prevention or treatment of gastrointestinal disease in dogs: A systematic review. J Vet Intern Med. 2019;33(5):1849-1864. doi:10.1111/jvim.15554 [*]",
      "link": "https://www.ncbi.nlm.nih.gov/pmc/articles/PMC6766488/"
    },
    "prods": []
  },
  {
    "ing": [
      "Probiotics"
    ],
    "dsc": "Lactobacillus can enhance intestinal health and improve immune function in dogs.",
    "journal": "American Journal of Veterinary Research, 2004",
    "citation": {
      "text": "Baillon ML, Marshall-Jones ZV, Butterwick RF. Effects of probiotic Lactobacillus acidophilus strain DSM13241 in healthy adult dogs. Am J Vet Res. 2004 Mar;65(3):338-43. doi: 10.2460/ajvr.2004.65.338. PMID: 15027683. [*]",
      "link": "https://pubmed.ncbi.nlm.nih.gov/15027683/"
    },
    "prods": []
  },
  {
    "ing": [
      "Probiotics"
    ],
    "dsc": "Byproducts of probiotic bacteria in crease the visbility and decreased oxidative stress in mouse and dog cells.",
    "journal": "Frontiers in Microbiology, 2021",
    "citation": {
      "text": "Jang HJ, Son S, Kim JA, et al. Characterization and Functional Test of Canine Probiotics. Front Microbiol. 2021;12:625562. Published 2021 Mar 8. doi:10.3389/fmicb.2021.625562 [*]",
      "link": "https://www.ncbi.nlm.nih.gov/pmc/articles/PMC7982664/"
    },
    "prods": []
  },
  {
    "ing": [
      "Probiotics"
    ],
    "dsc": "Lactobacillus strain amongst the best probiotics for dogs.",
    "journal": "Journal of Applied Microbiology, 2019",
    "citation": {
      "text": "Coman MM, Verdenelli MC, Cecchini C, Belà B, Gramenzi A, Orpianesi C, Cresci A, Silvi S. Probiotic characterization of Lactobacillus isolates from canine faeces. J Appl Microbiol. 2019 Apr;126(4):1245-1256. doi: 10.1111/jam.14197. Epub 2019 Feb 18. PMID: 30614169. [*]",
      "link": "https://pubmed.ncbi.nlm.nih.gov/30614169/"
    },
    "prods": []
  },
  {
    "ing": [
      "Probiotics"
    ],
    "dsc": "0",
    "journal": "Journal of Veterinary Internal Medicine, 2013",
    "citation": {
      "text": "Hutchins RG, Bailey CS, Jacob ME, Harris TL, Wood MW, Saker KE, Vaden SL. The effect of an oral probiotic containing lactobacillus, bifidobacterium, and bacillus species on the vaginal microbiota of spayed female dogs. J Vet Intern Med. 2013 Nov-Dec;27(6):1368-71. doi: 10.1111/jvim.12174. Epub 2013 Aug 28. PMID: 24033665. [*]",
      "link": "https://pubmed.ncbi.nlm.nih.gov/24033665/"
    },
    "prods": []
  },
  {
    "ing": [
      "Probiotics",
      "Inulin"
    ],
    "dsc": "Probiotics led to a lower incidence in diarrhea and a change in gut microbial community.",
    "journal": "Animal Microbiome, 2021",
    "citation": {
      "text": "Tanprasertsuk J, Jha AR, Shmalberg J, Jones RB, Perry LM, Maughan H, Honaker RW. The microbiota of healthy dogs demonstrates individualized responses to synbiotic supplementation in a randomized controlled trial. Anim Microbiome. 2021 May 10;3(1):36. doi: 10.1186/s42523-021-00098-0. PMID: 33971985; PMCID: PMC8111948. [*]",
      "link": "https://pubmed.ncbi.nlm.nih.gov/33971985/"
    },
    "prods": [
      {
        "text": "Perfect Dog Food Mix",
        "link": "/products/perfect-dog-food-mix"
      }
    ]
  },
  {
    "ing": [
      "Probiotics"
    ],
    "dsc": "Probiotic used in livestock improved gut health and microbiota.",
    "journal": "Beneficial Microbes, 2010",
    "citation": {
      "text": "Chaucheyras-Durand F, Durand H. Probiotics in animal nutrition and health. Benef Microbes. 2010 Mar;1(1):3-9. doi: 10.3920/BM2008.1002. PMID: 21840795. [*]",
      "link": "https://pubmed.ncbi.nlm.nih.gov/21840795/"
    },
    "prods": []
  },
  {
    "ing": [
      "Probiotics"
    ],
    "dsc": "Aged male animals eating probiotics exhibited increased subcuticular folliculogenesis, yielding luxuriant fur only in probiotic-fed subjects. Female animals displayed probiotic-induced hyperacidity coinciding with shinier hair.",
    "journal": "PLoS One, 2013",
    "citation": {
      "text": "Levkovich T, Poutahidis T, Smillie C, et al. Probiotic bacteria induce a 'glow of health'. PLoS One. 2013;8(1):e53867. doi:10.1371/journal.pone.0053867 [*]",
      "link": "https://www.ncbi.nlm.nih.gov/pmc/articles/PMC3547054/"
    },
    "prods": []
  },
  {
    "ing": [
      "Probiotics"
    ],
    "dsc": "Products claiming \"probiotics\" often see no relevant bacterial growth - inaccurate labels relative to actual contents.",
    "journal": "Canadian Journal of Veterinary Research, 2003",
    "citation": {
      "text": "Weese JS, Arroyo L. Bacteriological evaluation of dog and cat diets that claim to contain probiotics. Can Vet J. 2003;44(3):212-216. [*]",
      "link": "https://www.ncbi.nlm.nih.gov/pmc/articles/PMC340078/"
    },
    "prods": []
  },
  {
    "ing": [
      "Probiotics"
    ],
    "dsc": "All dogs clinically improved after probiotic treatment, but cytokine patterns were not associated with the clinical features irrespective of the dietary supplementation.",
    "journal": "Journal of Animal Physiology and Animal Nutrition, 2006",
    "citation": {
      "text": "Sauter SN, Benyacoub J, Allenspach K, Gaschen F, Ontsouka E, Reuteler G, Cavadini C, Knorr R, Blum JW. Effects of probiotic bacteria in dogs with food responsive diarrhoea treated with an elimination diet. J Anim Physiol Anim Nutr (Berl). 2006 Aug;90(7-8):269-77. doi: 10.1111/j.1439-0396.2005.00595.x. PMID: 16867072. [*]",
      "link": "https://pubmed.ncbi.nlm.nih.gov/16867072/"
    },
    "prods": []
  },
  {
    "ing": [
      "Probiotics"
    ],
    "dsc": "Supplementation of L acidophilus D2/CSL (CECT 4529) significantly improved the nutritional status and faecal parameters of dogs.",
    "journal": "The Veterinary Record, 2020",
    "citation": {
      "text": "Marelli SP, Fusi E, Giardini A, et al. Effects of probiotic Lactobacillus acidophilus D2/CSL (CECT 4529) on the nutritional and health status of boxer dogs. Vet Rec. 2020;187(4):e28. doi:10.1136/vr.105434 [*]",
      "link": "https://www.ncbi.nlm.nih.gov/pmc/articles/PMC7456698/"
    },
    "prods": []
  },
  {
    "ing": [
      "Probiotics"
    ],
    "dsc": "Review: Probiotic administration improved the clinical symptoms, histological alterations, and mucus production in most of the evaluated animal studies.",
    "journal": "Nutrients, 2017",
    "citation": {
      "text": "Plaza-Díaz J, Ruiz-Ojeda FJ, Vilchez-Padial LM, Gil A. Evidence of the Anti-Inflammatory Effects of Probiotics and Synbiotics in Intestinal Chronic Diseases. Nutrients. 2017;9(6):555. Published 2017 May 28. doi:10.3390/nu9060555 [*]",
      "link": "https://www.ncbi.nlm.nih.gov/pmc/articles/PMC5490534/"
    },
    "prods": []
  },
  {
    "ing": [
      "Probiotics"
    ],
    "dsc": "Review: Several probiotic species are widely considered beneficial. Safety concerns prevent Enterococcus from being included - though there is potential for development.",
    "journal": "Frontiers in Microbiology, 2018",
    "citation": {
      "text": "Hanchi H, Mottawea W, Sebei K, Hammami R. The Genus Enterococcus: Between Probiotic Potential and Safety Concerns-An Update. Front Microbiol. 2018;9:1791. Published 2018 Aug 3. doi:10.3389/fmicb.2018.01791 [*]",
      "link": "https://www.ncbi.nlm.nih.gov/pmc/articles/PMC6085487/"
    },
    "prods": []
  },
  {
    "ing": [
      "Probiotics"
    ],
    "dsc": "Administration of probiotic Lactobacillu sakei probio-65 reduced disease severity for canine atopic dermatitis.",
    "journal": "Journal of Microbiology & Biotechnology, 2015",
    "citation": {
      "text": "Kim H, Rather IA, Kim H, Kim S, Kim T, Jang J, Seo J, Lim J, Park YH. A Double-Blind, Placebo Controlled-Trial of a Probiotic Strain Lactobacillus sakei Probio-65 for the Prevention of Canine Atopic Dermatitis. J Microbiol Biotechnol. 2015 Nov;25(11):1966-9. doi: 10.4014/jmb.1506.06065. PMID: 26282691. [*]",
      "link": "https://pubmed.ncbi.nlm.nih.gov/26282691/"
    },
    "prods": []
  },
  {
    "ing": [
      "Probiotics"
    ],
    "dsc": "Novel probiotics are being developed for use in pet nutrition programs.",
    "journal": "Probiotics and Antimicrobial Proteins, 2017",
    "citation": {
      "text": "Kumar S, Pattanaik AK, Sharma S, Jadhav SE, Dutta N, Kumar A. Probiotic Potential of a Lactobacillus Bacterium of Canine Faecal-Origin and Its Impact on Select Gut Health Indices and Immune Response of Dogs. Probiotics Antimicrob Proteins. 2017 Sep;9(3):262-277. doi: 10.1007/s12602-017-9256-z. PMID: 28188477. [*]",
      "link": "https://pubmed.ncbi.nlm.nih.gov/28188477/"
    },
    "prods": []
  },
  {
    "ing": [
      "Pumpkin",
      "High antioxidants"
    ],
    "dsc": "Pumpkins are a potent source of antioxidants.",
    "journal": "Food Chemistry, 2012",
    "citation": {
      "text": "Oloyede FM, Agbaje GO, Obuotor EM, Obisesan IO. Nutritional and antioxidant profiles of pumpkin (Cucurbita pepo Linn.) immature and mature fruits as influenced by NPK fertilizer. Food Chem. 2012 Nov 15;135(2):460-3. doi: 10.1016/j.foodchem.2012.04.124. Epub 2012 Apr 30. PMID: 22868114. [*]",
      "link": "https://pubmed.ncbi.nlm.nih.gov/22868114/"
    },
    "prods": [
      {
        "text": "Perfect Kibble Beef",
        "link": "/products/perfect-kibble-beef"
      },
      {
        "text": "Perfect Kibble Chicken",
        "link": "/products/perfect-kibble"
      },
      {
        "text": "Perfect Dog Food Mix",
        "link": "/products/perfect-dog-food-mix"
      }
    ]
  },
  {
    "ing": [
      "Pumpkin"
    ],
    "dsc": "Pumpkin seeds contain all essential amino acids except lysine and threonine.",
    "journal": "Food Chemistry, 2021",
    "citation": {
      "text": "Vinayashree S, Vasu P. Biochemical, nutritional and functional properties of protein isolate and fractions from pumpkin (Cucurbita moschata var. Kashi Harit) seeds. Food Chem. 2021 Mar 15;340:128177. doi: 10.1016/j.foodchem.2020.128177. Epub 2020 Sep 24. PMID: 33002826. [*]",
      "link": "https://pubmed.ncbi.nlm.nih.gov/33002826/"
    },
    "prods": [
      {
        "text": "Perfect Kibble Beef",
        "link": "/products/perfect-kibble-beef"
      },
      {
        "text": "Perfect Kibble Chicken",
        "link": "/products/perfect-kibble"
      },
      {
        "text": "Perfect Dog Food Mix",
        "link": "/products/perfect-dog-food-mix"
      }
    ]
  },
  {
    "ing": [
      "Pumpkin"
    ],
    "dsc": "Pumpkin seeds decrease GI helminiths in ostriches.",
    "journal": "Tropical Animal Health and Production, 2013",
    "citation": {
      "text": "Feitosa TF, Vilela VL, Athayde AC, Braga FR, Dantas ES, Vieira VD, de Melo LR. Anthelmintic efficacy of pumpkin seed (Cucurbita pepo Linnaeus, 1753) on ostrich gastrointestinal nematodes in a semiarid region of Paraíba State, Brazil. Trop Anim Health Prod. 2013 Jan;45(1):123-7. doi: 10.1007/s11250-012-0182-5. Epub 2012 Jun 9. PMID: 22684690. [*]",
      "link": "https://pubmed.ncbi.nlm.nih.gov/22684690/"
    },
    "prods": [
      {
        "text": "Perfect Kibble Beef",
        "link": "/products/perfect-kibble-beef"
      },
      {
        "text": "Perfect Kibble Chicken",
        "link": "/products/perfect-kibble"
      },
      {
        "text": "Perfect Dog Food Mix",
        "link": "/products/perfect-dog-food-mix"
      }
    ]
  },
  {
    "ing": [
      "Pumpkin"
    ],
    "dsc": "Pumpkin contains several phyto-constituents belonging to the categories of alkaloids, flavonoids, and palmitic, oleic and linoleic acids. Various important medicinal properties including anti-diabetic, antioxidant, anti-carcinogenic, anti-inflammatory and others have been well documented.",
    "journal": "Nutrition Research Reviews, 2010",
    "citation": {
      "text": "Yadav M, Jain S, Tomar R, Prasad GB, Yadav H. Medicinal and biological potential of pumpkin: an updated review. Nutr Res Rev. 2010 Dec;23(2):184-90. doi: 10.1017/S0954422410000107. PMID: 21110905. [*]",
      "link": "https://pubmed.ncbi.nlm.nih.gov/21110905/"
    },
    "prods": [
      {
        "text": "Perfect Kibble Beef",
        "link": "/products/perfect-kibble-beef"
      },
      {
        "text": "Perfect Kibble Chicken",
        "link": "/products/perfect-kibble"
      },
      {
        "text": "Perfect Dog Food Mix",
        "link": "/products/perfect-dog-food-mix"
      }
    ]
  },
  {
    "ing": [
      "Pumpkin"
    ],
    "dsc": "Pumpkin seed oil lowers blood pressure and is cardioprotective.",
    "journal": "Journal of Medical Food, 2012",
    "citation": {
      "text": "El-Mosallamy AE, Sleem AA, Abdel-Salam OM, Shaffie N, Kenawy SA. Antihypertensive and cardioprotective effects of pumpkin seed oil. J Med Food. 2012 Feb;15(2):180-9. doi: 10.1089/jmf.2010.0299. Epub 2011 Nov 14. PMID: 22082068. [*]",
      "link": "https://pubmed.ncbi.nlm.nih.gov/22082068/"
    },
    "prods": [
      {
        "text": "Perfect Kibble Beef",
        "link": "/products/perfect-kibble-beef"
      },
      {
        "text": "Perfect Kibble Chicken",
        "link": "/products/perfect-kibble"
      },
      {
        "text": "Perfect Dog Food Mix",
        "link": "/products/perfect-dog-food-mix"
      }
    ]
  },
  {
    "ing": [
      "Pumpkin"
    ],
    "dsc": "Pumpkin could enhance animal health and vitality in livestock.",
    "journal": "Animals, 2019",
    "citation": {
      "text": "Valdez-Arjona LP, Ramírez-Mella M. Pumpkin Waste as Livestock Feed: Impact on Nutrition and Animal Health and on Quality of Meat, Milk, and Egg. Animals (Basel). 2019 Oct 8;9(10):769. doi: 10.3390/ani9100769. PMID: 31597395; PMCID: PMC6826842. [*]",
      "link": "https://pubmed.ncbi.nlm.nih.gov/31597395/"
    },
    "prods": [
      {
        "text": "Perfect Kibble Beef",
        "link": "/products/perfect-kibble-beef"
      },
      {
        "text": "Perfect Kibble Chicken",
        "link": "/products/perfect-kibble"
      },
      {
        "text": "Perfect Dog Food Mix",
        "link": "/products/perfect-dog-food-mix"
      }
    ]
  },
  {
    "ing": [
      "Pumpkin"
    ],
    "dsc": "Pumpkin seed extract is reported to be useful for immunomodulation, reproductive health, therapeutics over a wide range of disease conditions and stimulates metabolism of accumulated fats.",
    "journal": "Journal of Animal Physiology and Animal Nutrition, 2018",
    "citation": {
      "text": "Achilonu MC, Nwafor IC, Umesiobi DO, Sedibe MM. Biochemical proximates of pumpkin (Cucurbitaeae spp.) and their beneficial effects on the general well-being of poultry species. J Anim Physiol Anim Nutr (Berl). 2018 Feb;102(1):5-16. doi: 10.1111/jpn.12654. Epub 2017 Feb 3. PMID: 28158900. [*]",
      "link": "https://pubmed.ncbi.nlm.nih.gov/28158900/"
    },
    "prods": [
      {
        "text": "Perfect Kibble Beef",
        "link": "/products/perfect-kibble-beef"
      },
      {
        "text": "Perfect Kibble Chicken",
        "link": "/products/perfect-kibble"
      },
      {
        "text": "Perfect Dog Food Mix",
        "link": "/products/perfect-dog-food-mix"
      }
    ]
  },
  {
    "ing": [
      "Pumpkin"
    ],
    "dsc": "Pumpkin seed extracts may be used to control of Gastrointestinal (G.I.) nematode infections.",
    "journal": "International Journal of Molecular Sciencies, 2016",
    "citation": {
      "text": "Grzybek M, Kukula-Koch W, Strachecka A, et al. Evaluation of Anthelmintic Activity and Composition of Pumpkin (Cucurbita pepo L.) Seed Extracts-In Vitro and in Vivo Studies. Int J Mol Sci. 2016;17(9):1456. Published 2016 Sep 1. doi:10.3390/ijms17091456 [*]",
      "link": "https://www.ncbi.nlm.nih.gov/pmc/articles/PMC5037735/"
    },
    "prods": [
      {
        "text": "Perfect Kibble Beef",
        "link": "/products/perfect-kibble-beef"
      },
      {
        "text": "Perfect Kibble Chicken",
        "link": "/products/perfect-kibble"
      },
      {
        "text": "Perfect Dog Food Mix",
        "link": "/products/perfect-dog-food-mix"
      }
    ]
  },
  {
    "ing": [
      "Pumpkin"
    ],
    "dsc": "Pumpkins recommended alternative to sugar, with high total phenolics and moderate antioxidant activity.",
    "journal": "Journal of Medicinal Food, 2007",
    "citation": {
      "text": "Kwon YI, Apostolidis E, Kim YC, Shetty K. Health benefits of traditional corn, beans, and pumpkin: in vitro studies for hyperglycemia and hypertension management. J Med Food. 2007 Jun;10(2):266-75. doi: 10.1089/jmf.2006.234. PMID: 17651062. [*]",
      "link": "https://pubmed.ncbi.nlm.nih.gov/17651062/"
    },
    "prods": [
      {
        "text": "Perfect Kibble Beef",
        "link": "/products/perfect-kibble-beef"
      },
      {
        "text": "Perfect Kibble Chicken",
        "link": "/products/perfect-kibble"
      },
      {
        "text": "Perfect Dog Food Mix",
        "link": "/products/perfect-dog-food-mix"
      }
    ]
  },
  {
    "ing": [
      "Seaweed"
    ],
    "dsc": "Seaweeds are functional foods alleviate risk factors for numerous chronic diseases",
    "journal": "Nutrition Reviews, 2019",
    "citation": {
      "text": "Cherry P, O'Hara C, Magee PJ, McSorley EM, Allsopp PJ. Risks and benefits of consuming edible seaweeds. Nutr Rev. 2019;77(5):307-329. doi:10.1093/nutrit/nuy066 [*]",
      "link": "https://www.ncbi.nlm.nih.gov/pmc/articles/PMC6551690/"
    },
    "prods": [
      {
        "text": "Perfect Kibble Beef",
        "link": "/products/perfect-kibble-beef"
      },
      {
        "text": "Perfect Kibble Chicken",
        "link": "/products/perfect-kibble"
      }
    ]
  },
  {
    "ing": [
      "Seaweed"
    ],
    "dsc": "Dietary seaweed contain numerous components, including ACE inhibitory peptides, soluble dietary fibers (eg, fucoidan, porphyran), omega-3 fatty acids, fucoxanthin, fucosterol, vitamins D3 and B12, and phlorotannins. These components exert antioxidant, anti-inflammatory, and antiviral effects directly as well as indirectly through prebiotic effects.",
    "journal": "Nutrition Reviews, 2020",
    "citation": {
      "text": "Tamama K. Potential benefits of dietary seaweeds as protection against COVID-19. Nutr Rev. 2021;79(7):814-823. doi:10.1093/nutrit/nuaa126 [*]",
      "link": "https://www.ncbi.nlm.nih.gov/pmc/articles/PMC7798825/"
    },
    "prods": [
      {
        "text": "Perfect Kibble Beef",
        "link": "/products/perfect-kibble-beef"
      },
      {
        "text": "Perfect Kibble Chicken",
        "link": "/products/perfect-kibble"
      }
    ]
  },
  {
    "ing": [
      "Seaweed"
    ],
    "dsc": "Seaweeds may be protective against melanoma.",
    "journal": "Journal of Applied Phycology, 2017",
    "citation": {
      "text": "Teas J, Irhimeh MR. Melanoma and brown seaweed: an integrative hypothesis. J Appl Phycol. 2017;29(2):941-948. doi:10.1007/s10811-016-0979-0 [*]",
      "link": "https://www.ncbi.nlm.nih.gov/pmc/articles/PMC5387006/"
    },
    "prods": [
      {
        "text": "Perfect Kibble Beef",
        "link": "/products/perfect-kibble-beef"
      },
      {
        "text": "Perfect Kibble Chicken",
        "link": "/products/perfect-kibble"
      }
    ]
  },
  {
    "ing": [
      "Seaweed"
    ],
    "dsc": "Polyphenolic compounds found in seaweed can be highly antiviral.",
    "journal": "Biomedicines, 2021",
    "citation": {
      "text": "Besednova NN, Andryukov BG, Zaporozhets TS, et al. Antiviral Effects of Polyphenols from Marine Algae. Biomedicines. 2021;9(2):200. Published 2021 Feb 17. doi:10.3390/biomedicines9020200 [*]",
      "link": "https://www.ncbi.nlm.nih.gov/pmc/articles/PMC7921925/"
    },
    "prods": [
      {
        "text": "Perfect Kibble Beef",
        "link": "/products/perfect-kibble-beef"
      },
      {
        "text": "Perfect Kibble Chicken",
        "link": "/products/perfect-kibble"
      }
    ]
  },
  {
    "ing": [
      "Seaweed"
    ],
    "dsc": "Oligo fucoidan derived by from oceanic brown seaweed improve quality of life in dogs being treated with chemotherapy for cancer.",
    "journal": "Topics in Companion Animal Medicine, 2022",
    "citation": {
      "text": "Post GS, Lustgarten J. The Use of Oligo Fucoidan in Cancer Bearing Dogs Undergoing Chemotherapy: A Double-Blinded Study. Top Companion Anim Med. 2022 Jan-Feb;46:100616. doi: 10.1016/j.tcam.2021.100616. Epub 2021 Dec 2. PMID: 34864255. [*]",
      "link": "https://pubmed.ncbi.nlm.nih.gov/34864255/"
    },
    "prods": [
      {
        "text": "Perfect Kibble Beef",
        "link": "/products/perfect-kibble-beef"
      },
      {
        "text": "Perfect Kibble Chicken",
        "link": "/products/perfect-kibble"
      }
    ]
  },
  {
    "ing": [
      "Seaweed"
    ],
    "dsc": "Seaweeds' indigestible polysaccharides have strong prebiotic properties.",
    "journal": "Animals, 2021",
    "citation": {
      "text": "Pinna C, Vecchiato CG, Grandi M, Stefanelli C, Zannoni A, Biagi G. Seaweed Supplementation Failed to Affect Fecal Microbiota and Metabolome as Well as Fecal IgA and Apparent Nutrient Digestibility in Adult Dogs. Animals (Basel). 2021;11(8):2234. Published 2021 Jul 29. doi:10.3390/ani11082234 [*]",
      "link": "https://www.ncbi.nlm.nih.gov/pmc/articles/PMC8388444/"
    },
    "prods": [
      {
        "text": "Perfect Kibble Beef",
        "link": "/products/perfect-kibble-beef"
      },
      {
        "text": "Perfect Kibble Chicken",
        "link": "/products/perfect-kibble"
      }
    ]
  },
  {
    "ing": [
      "Seaweed Kelp"
    ],
    "dsc": "Overview of nutritional value of seaweeds.",
    "journal": "Nutrition Reviews, 2007",
    "citation": {
      "text": "MacArtain P, Gill CI, Brooks M, Campbell R, Rowland IR. Nutritional value of edible seaweeds. Nutr Rev. 2007 Dec;65(12 Pt 1):535-43. doi: 10.1301/nr.2007.dec.535-543. PMID: 18236692. [*]",
      "link": "https://pubmed.ncbi.nlm.nih.gov/18236692/"
    },
    "prods": [
      {
        "text": "Perfect Kibble Beef",
        "link": "/products/perfect-kibble-beef"
      },
      {
        "text": "Perfect Kibble Chicken",
        "link": "/products/perfect-kibble"
      }
    ]
  },
  {
    "ing": [
      "Seaweed"
    ],
    "dsc": "Nutritional profile of seaweeds useful in prevention and treatment of neurodegenerative diseases.",
    "journal": "Marine Drugs, 2021",
    "citation": {
      "text": "Pereira L, Valado A. The Seaweed Diet in Prevention and Treatment of the Neurodegenerative Diseases. Mar Drugs. 2021;19(3):128. Published 2021 Feb 26. doi:10.3390/md19030128 [*]",
      "link": "https://www.ncbi.nlm.nih.gov/pmc/articles/PMC7996752/"
    },
    "prods": [
      {
        "text": "Perfect Kibble Beef",
        "link": "/products/perfect-kibble-beef"
      },
      {
        "text": "Perfect Kibble Chicken",
        "link": "/products/perfect-kibble"
      }
    ]
  },
  {
    "ing": [
      "Seaweed"
    ],
    "dsc": "Seaweeds contain minerals, vitamins, soluble dietary fibers, and flavonoids, which are regarded as preventive agents against lifestyle-related diseases.",
    "journal": "European Journal of Clinical Nutrition, 2021",
    "citation": {
      "text": "Murai U, Yamagishi K, Kishida R, Iso H. Impact of seaweed intake on health. Eur J Clin Nutr. 2021 Jun;75(6):877-889. doi: 10.1038/s41430-020-00739-8. Epub 2020 Sep 9. Erratum in: Eur J Clin Nutr. 2020 Oct 15;: PMID: 32908248. [*]",
      "link": "https://pubmed.ncbi.nlm.nih.gov/32908248/"
    },
    "prods": [
      {
        "text": "Perfect Kibble Beef",
        "link": "/products/perfect-kibble-beef"
      },
      {
        "text": "Perfect Kibble Chicken",
        "link": "/products/perfect-kibble"
      }
    ]
  },
  {
    "ing": [
      "Seaweed"
    ],
    "dsc": "Seaweed is rich in some health-promoting molecules and materials such as, dietary fiber, ω-3 fatty acids, essential amino acids, and vitamins A, B, C, and E.",
    "journal": "Advances in Food and Nutrition Research, 2011",
    "citation": {
      "text": "Rajapakse N, Kim SK. Nutritional and digestive health benefits of seaweed. Adv Food Nutr Res. 2011;64:17-28. doi: 10.1016/B978-0-12-387669-0.00002-8. PMID: 22054935. [*]",
      "link": "https://pubmed.ncbi.nlm.nih.gov/22054935/"
    },
    "prods": [
      {
        "text": "Perfect Kibble Beef",
        "link": "/products/perfect-kibble-beef"
      },
      {
        "text": "Perfect Kibble Chicken",
        "link": "/products/perfect-kibble"
      }
    ]
  },
  {
    "ing": [
      "Taurine"
    ],
    "dsc": "Dogs with taurine deficiency and dilated cardiomyopathy saw significant improvement with taurine supplementation.",
    "journal": "PLoS One, 2018",
    "citation": {
      "text": "Kaplan JL, Stern JA, Fascetti AJ, Larsen JA, Skolnik H, Peddle GD, Kienle RD, Waxman A, Cocchiaro M, Gunther-Harrington CT, Klose T, LaFauci K, Lefbom B, Machen Lamy M, Malakoff R, Nishimura S, Oldach M, Rosenthal S, Stauthammer C, O'Sullivan L, Visser LC, Williams R, Ontiveros E. Taurine deficiency and dilated cardiomyopathy in golden retrievers fed commercial diets. PLoS One. 2018 Dec 13;13(12):e0209112. doi: 10.1371/journal.pone.0209112. Erratum in: PLoS One. 2018 Dec 31;13(12):e0210233. PMID: 30543707; PMCID: PMC6292607. [*]",
      "link": "https://pubmed.ncbi.nlm.nih.gov/30543707/"
    },
    "prods": [
      {
        "text": "Perfect Dog Food Mix",
        "link": "/products/perfect-dog-food-mix"
      },
      {
        "text": "Perfect Kibble Beef",
        "link": "/products/perfect-kibble-beef"
      },
      {
        "text": "Perfect Kibble Chicken",
        "link": "/products/perfect-kibble"
      }
    ]
  },
  {
    "ing": [
      "Taurine",
      "Carrots",
      "Fresh chicken"
    ],
    "dsc": "Source of carbohydrates affected blood MHCH and platelets - no effect in taurine levels.",
    "journal": "Frontiers in Veterinary Science, 2021",
    "citation": {
      "text": "Gizzarelli M, Calabrò S, Vastolo A, Molinaro G, Balestrino I, Cutrignelli MI. Clinical Findings in Healthy Dogs Fed With Diets Characterized by Different Carbohydrates Sources. Front Vet Sci. 2021;8:667318. Published 2021 Apr 22. doi:10.3389/fvets.2021.667318 [*]",
      "link": "https://www.ncbi.nlm.nih.gov/pmc/articles/PMC8100497/"
    },
    "prods": [
      {
        "text": "Perfect Kibble Chicken",
        "link": "/products/perfect-kibble"
      }
    ]
  },
  {
    "ing": [
      "Taurine"
    ],
    "dsc": "Tauricine deficiency is a significant problem in dogs with dilated cardiomyopathy (DCM).",
    "journal": "Veterinary Clinics of North America. Small Animal Practice, 2006",
    "citation": {
      "text": "Sanderson SL. Taurine and carnitine in canine cardiomyopathy. Vet Clin North Am Small Anim Pract. 2006 Nov;36(6):1325-43, vii-viii. doi: 10.1016/j.cvsm.2006.08.010. PMID: 17085238. [*]",
      "link": "https://pubmed.ncbi.nlm.nih.gov/17085238/"
    },
    "prods": [
      {
        "text": "Perfect Dog Food Mix",
        "link": "/products/perfect-dog-food-mix"
      },
      {
        "text": "Perfect Kibble Beef",
        "link": "/products/perfect-kibble-beef"
      },
      {
        "text": "Perfect Kibble Chicken",
        "link": "/products/perfect-kibble"
      }
    ]
  },
  {
    "ing": [
      "Taurine"
    ],
    "dsc": "Taurine essential for photoreceptor survival in the eye.",
    "journal": "Advances in Experimental Medicine and Biology, 2013",
    "citation": {
      "text": "Rosolen SG, Neveux N, Sahel JA, Picaud S, Froger N. Evaluation of the taurine concentrations in dog plasma and aqueous humour: a pilot study. Adv Exp Med Biol. 2013;775:145-54. doi: 10.1007/978-1-4614-6130-2_12. PMID: 23392931. [*]",
      "link": "https://pubmed.ncbi.nlm.nih.gov/23392931/"
    },
    "prods": [
      {
        "text": "Perfect Dog Food Mix",
        "link": "/products/perfect-dog-food-mix"
      },
      {
        "text": "Perfect Kibble Beef",
        "link": "/products/perfect-kibble-beef"
      },
      {
        "text": "Perfect Kibble Chicken",
        "link": "/products/perfect-kibble"
      }
    ]
  },
  {
    "ing": [
      "Taurine"
    ],
    "dsc": "Taurine deficiency should be a major dietary concern in DCM.",
    "journal": "Journal of Animal Science, 2020",
    "citation": {
      "text": "McCauley SR, Clark SD, Quest BW, Streeter RM, Oxford EM. Review of canine dilated cardiomyopathy in the wake of diet-associated concerns [published correction appears in J Anim Sci. 2020 Jul 1;98(7):]. J Anim Sci. 2020;98(6):skaa155. doi:10.1093/jas/skaa155 [*]",
      "link": "https://www.ncbi.nlm.nih.gov/pmc/articles/PMC7447921/"
    },
    "prods": [
      {
        "text": "Perfect Dog Food Mix",
        "link": "/products/perfect-dog-food-mix"
      },
      {
        "text": "Perfect Kibble Beef",
        "link": "/products/perfect-kibble-beef"
      },
      {
        "text": "Perfect Kibble Chicken",
        "link": "/products/perfect-kibble"
      }
    ]
  },
  {
    "ing": [
      "Taurine"
    ],
    "dsc": "Taurine supplementation protects against pathologies associated with mitochondrial defects, such as aging, mitochondrial diseases, metabolic syndrome, cancer, cardiovascular diseases and neurological disorders.",
    "journal": "Molecules, 2021",
    "citation": {
      "text": "Jong CJ, Sandal P, Schaffer SW. The Role of Taurine in Mitochondria Health: More Than Just an Antioxidant. Molecules. 2021;26(16):4913. Published 2021 Aug 13. doi:10.3390/molecules26164913 [*]",
      "link": "https://www.ncbi.nlm.nih.gov/pmc/articles/PMC8400259/"
    },
    "prods": [
      {
        "text": "Perfect Dog Food Mix",
        "link": "/products/perfect-dog-food-mix"
      },
      {
        "text": "Perfect Kibble Beef",
        "link": "/products/perfect-kibble-beef"
      },
      {
        "text": "Perfect Kibble Chicken",
        "link": "/products/perfect-kibble"
      }
    ]
  },
  {
    "ing": [
      "Taurine"
    ],
    "dsc": "Taurine is pivotal to the health and survival of ocular tissues - also one of the most essential substances in the body.",
    "journal": "Molecular Vision, 2012",
    "citation": {
      "text": "Ripps H, Shen W. Review: taurine: a \"very essential\" amino acid. Mol Vis. 2012;18:2673-2686. [*]",
      "link": "https://www.ncbi.nlm.nih.gov/pmc/articles/PMC3501277/"
    },
    "prods": [
      {
        "text": "Perfect Dog Food Mix",
        "link": "/products/perfect-dog-food-mix"
      },
      {
        "text": "Perfect Kibble Beef",
        "link": "/products/perfect-kibble-beef"
      },
      {
        "text": "Perfect Kibble Chicken",
        "link": "/products/perfect-kibble"
      }
    ]
  },
  {
    "ing": [
      "Taurine"
    ],
    "dsc": "Taurine deficiency is a possible caused of diet-associated dilated cardiomyopathy.",
    "journal": "Journal of Veterinary Internal Medicine, 2022",
    "citation": {
      "text": "Freeman L, Rush J, Adin D, et al. Prospective study of dilated cardiomyopathy in dogs eating nontraditional or traditional diets and in dogs with subclinical cardiac abnormalities. J Vet Intern Med. 2022;36(2):451-463. doi:10.1111/jvim.16397 [*]",
      "link": "https://www.ncbi.nlm.nih.gov/pmc/articles/PMC8965249/"
    },
    "prods": [
      {
        "text": "Perfect Dog Food Mix",
        "link": "/products/perfect-dog-food-mix"
      },
      {
        "text": "Perfect Kibble Beef",
        "link": "/products/perfect-kibble-beef"
      },
      {
        "text": "Perfect Kibble Chicken",
        "link": "/products/perfect-kibble"
      }
    ]
  },
  {
    "ing": [
      "Taurine"
    ],
    "dsc": "Different carbohydrate sources do not affect taurine status in dogs.",
    "journal": "Journal of Animal Science, 2020",
    "citation": {
      "text": "Pezzali JG, Acuff HL, Henry W, Alexander C, Swanson KS, Aldrich CG. Effects of different carbohydrate sources on taurine status in healthy Beagle dogs. J Anim Sci. 2020;98(2):skaa010. doi:10.1093/jas/skaa010 [*]",
      "link": "https://www.ncbi.nlm.nih.gov/pmc/articles/PMC7007769/"
    },
    "prods": [
      {
        "text": "Perfect Dog Food Mix",
        "link": "/products/perfect-dog-food-mix"
      },
      {
        "text": "Perfect Kibble Beef",
        "link": "/products/perfect-kibble-beef"
      },
      {
        "text": "Perfect Kibble Chicken",
        "link": "/products/perfect-kibble"
      }
    ]
  },
  {
    "ing": [
      "Taurine"
    ],
    "dsc": "Taurine has beneficial effects in in congestive heart failure, hypertension, ischemic heart disease, atherosclerosis and diabetic cardiomyopathy.",
    "journal": "Experimental & Clinical Cardiology, 2008",
    "citation": {
      "text": "Xu YJ, Arneja AS, Tappia PS, Dhalla NS. The potential health benefits of taurine in cardiovascular disease. Exp Clin Cardiol. 2008;13(2):57-65. [*]",
      "link": "https://www.ncbi.nlm.nih.gov/pmc/articles/PMC2586397/"
    },
    "prods": [
      {
        "text": "Perfect Dog Food Mix",
        "link": "/products/perfect-dog-food-mix"
      },
      {
        "text": "Perfect Kibble Beef",
        "link": "/products/perfect-kibble-beef"
      },
      {
        "text": "Perfect Kibble Chicken",
        "link": "/products/perfect-kibble"
      }
    ]
  },
  {
    "ing": [
      "Taurine",
      "Minimally-processed/span> Fresh chicken",
      "Fresh chicken"
    ],
    "dsc": "Chicken is greater for taurine bioavailability compared to lamb-meal.",
    "journal": "Journal of Animal Physiology and Animal Nutrition, 2003",
    "citation": {
      "text": "Tôrres CL, Backus RC, Fascetti AJ, Rogers QR. Taurine status in normal dogs fed a commercial diet associated with taurine deficiency and dilated cardiomyopathy. J Anim Physiol Anim Nutr (Berl). 2003 Oct;87(9-10):359-72. doi: 10.1046/j.1439-0396.2003.00446.x. PMID: 14507418. [*]",
      "link": "https://pubmed.ncbi.nlm.nih.gov/14507418/"
    },
    "prods": [
      {
        "text": "Perfect Kibble Chicken",
        "link": "/products/perfect-kibble"
      }
    ]
  },
  {
    "ing": [
      "Taurine",
      "Minimally-processed"
    ],
    "dsc": "Certain commercial diet associated with low taurine concentrations and DCM in dogs. Taurine supplementation increases survival times in such dogs.",
    "journal": "Journal of the American Veterinary Medical Association, 2003",
    "citation": {
      "text": "Fascetti AJ, Reed JR, Rogers QR, Backus RC. Taurine deficiency in dogs with dilated cardiomyopathy: 12 cases (1997-2001). J Am Vet Med Assoc. 2003 Oct 15;223(8):1137-41. doi: 10.2460/javma.2003.223.1137. PMID: 14584743. [*]",
      "link": "https://pubmed.ncbi.nlm.nih.gov/14584743/"
    },
    "prods": [
      {
        "text": "Perfect Dog Food Mix",
        "link": "/products/perfect-dog-food-mix"
      },
      {
        "text": "Perfect Kibble Beef",
        "link": "/products/perfect-kibble-beef"
      },
      {
        "text": "Perfect Kibble Chicken",
        "link": "/products/perfect-kibble"
      }
    ]
  },
  {
    "ing": [
      "Taurine"
    ],
    "dsc": "Taurine insufficiency is greater in bigger dogs due to differences in taurine biosynthesis rate.",
    "journal": "Journal of Nutrition, 2007",
    "citation": {
      "text": "Ko KS, Backus RC, Berg JR, Lame MW, Rogers QR. Differences in taurine synthesis rate among dogs relate to differences in their maintenance energy requirement. J Nutr. 2007 May;137(5):1171-5. doi: 10.1093/jn/137.5.1171. PMID: 17449577. [*]",
      "link": "https://pubmed.ncbi.nlm.nih.gov/17449577/"
    },
    "prods": [
      {
        "text": "Perfect Dog Food Mix",
        "link": "/products/perfect-dog-food-mix"
      },
      {
        "text": "Perfect Kibble Beef",
        "link": "/products/perfect-kibble-beef"
      },
      {
        "text": "Perfect Kibble Chicken",
        "link": "/products/perfect-kibble"
      }
    ]
  },
  {
    "ing": [
      "Taurine"
    ],
    "dsc": "Low taurine and DCM may be specifically associated with Cocker Spaniels or Golden Retrievers.",
    "journal": "Journal of Veterinary Internal Medicine, 1995",
    "citation": {
      "text": "Kramer GA, Kittleson MD, Fox PR, Lewis J, Pion PD. Plasma taurine concentrations in normal dogs and in dogs with heart disease. J Vet Intern Med. 1995 Jul-Aug;9(4):253-8. doi: 10.1111/j.1939-1676.1995.tb01076.x. PMID: 8523322. [*]",
      "link": "https://pubmed.ncbi.nlm.nih.gov/8523322/"
    },
    "prods": [
      {
        "text": "Perfect Dog Food Mix",
        "link": "/products/perfect-dog-food-mix"
      },
      {
        "text": "Perfect Kibble Beef",
        "link": "/products/perfect-kibble-beef"
      },
      {
        "text": "Perfect Kibble Chicken",
        "link": "/products/perfect-kibble"
      }
    ]
  },
  {
    "ing": [
      "Taurine"
    ],
    "dsc": "Taurine deficiencies can cause serious issues; however, green lentils do not cause a lower blood concentration of taurine.",
    "journal": "Journal of Animal Science, 2021",
    "citation": {
      "text": "Reilly LM, He F, Clark L, de Godoy MRC. Longitudinal assessment of taurine and amino acid concentrations in dogs fed a green lentil diet. J Anim Sci. 2021 Nov 1;99(11):skab315. doi: 10.1093/jas/skab315. PMID: 34747447; PMCID: PMC8763241. [*]",
      "link": "https://pubmed.ncbi.nlm.nih.gov/34747447/"
    },
    "prods": [
      {
        "text": "Perfect Dog Food Mix",
        "link": "/products/perfect-dog-food-mix"
      },
      {
        "text": "Perfect Kibble Beef",
        "link": "/products/perfect-kibble-beef"
      },
      {
        "text": "Perfect Kibble Chicken",
        "link": "/products/perfect-kibble"
      }
    ]
  },
  {
    "ing": [
      "Wild Alaskan salmon oil"
    ],
    "dsc": "Puppies receiving high-DHA food were better at task learning, visual contrast discrimination, and early psychomotor performance (salmon oil is high in DHA).",
    "journal": "Journal of the American Veterinary Medical Association, 2012",
    "citation": {
      "text": "Zicker SC, Jewell DE, Yamka RM, Milgram NW. Evaluation of cognitive learning, memory, psychomotor, immunologic, and retinal functions in healthy puppies fed foods fortified with docosahexaenoic acid-rich fish oil from 8 to 52 weeks of age. J Am Vet Med Assoc. 2012 Sep 1;241(5):583-94. doi: 10.2460/javma.241.5.583. PMID: 22916855. [*]",
      "link": "https://pubmed.ncbi.nlm.nih.gov/22916855/"
    },
    "prods": [
      {
        "text": "Perfect Wild Alaskan Salmon Oil",
        "link": "/products/perfect-wild-alaskan-salmon-oil"
      }
    ]
  },
  {
    "ing": [
      "Wild Alaskan salmon oil"
    ],
    "dsc": "DHA improved memory and learning skills in young dogs.",
    "journal": "Journal of the American Veterinary Medical Association, 2006",
    "citation": {
      "text": "Heinemann KM, Bauer JE. Docosahexaenoic acid and neurologic development in animals. J Am Vet Med Assoc. 2006 Mar 1;228(5):700-5, 655. doi: 10.2460/javma.228.5.700. PMID: 16506930. [*]",
      "link": "https://pubmed.ncbi.nlm.nih.gov/16506930/"
    },
    "prods": [
      {
        "text": "Perfect Wild Alaskan Salmon Oil",
        "link": "/products/perfect-wild-alaskan-salmon-oil"
      }
    ]
  },
  {
    "ing": [
      "Wild Alaskan salmon oil",
      "High omega-3"
    ],
    "dsc": "Fish oil high in EPA and DHA reduced lameness and slowed the progression of ostearthritis in dogs.",
    "journal": "Journal of Veterinary Internal Medicine, 2010",
    "citation": {
      "text": "Fritsch D, Allen TA, Dodd CE, Jewell DE, Sixby KA, Leventhal PS, Hahn KA. Dose-titration effects of fish oil in osteoarthritic dogs. J Vet Intern Med. 2010 Sep-Oct;24(5):1020-6. doi: 10.1111/j.1939-1676.2010.0572.x. Epub 2010 Aug 12. Erratum in: J Vet Intern Med. 2011 Jan-Feb;25(1):167. PMID: 20707845. [*]",
      "link": "https://pubmed.ncbi.nlm.nih.gov/20707845/"
    },
    "prods": [
      {
        "text": "Perfect Wild Alaskan Salmon Oil",
        "link": "/products/perfect-wild-alaskan-salmon-oil"
      }
    ]
  },
  {
    "ing": [
      "Wild Alaskan salmon oil",
      "High omega-4"
    ],
    "dsc": "Fish oil omega-3 fattty acids improved weight-bearing in dogs with osteoarthritis.",
    "journal": "Journal of the American Veterinary Medical Association, 2010",
    "citation": {
      "text": "Roush JK, Cross AR, Renberg WC, Dodd CE, Sixby KA, Fritsch DA, Allen TA, Jewell DE, Richardson DC, Leventhal PS, Hahn KA. Evaluation of the effects of dietary supplementation with fish oil omega-3 fatty acids on weight bearing in dogs with osteoarthritis. J Am Vet Med Assoc. 2010 Jan 1;236(1):67-73. doi: 10.2460/javma.236.1.67. PMID: 20043801. [*]",
      "link": "https://pubmed.ncbi.nlm.nih.gov/20043801/"
    },
    "prods": [
      {
        "text": "Perfect Wild Alaskan Salmon Oil",
        "link": "/products/perfect-wild-alaskan-salmon-oil"
      }
    ]
  },
  {
    "ing": [
      "Wild Alaskan salmon oil"
    ],
    "dsc": "Low-dose salmon oil altered serum phospholipid fatty acid profile in two weeks.",
    "journal": "Journal of Small Animal Practice, 2012",
    "citation": {
      "text": "Hesta M, Verbrugghe A, Gulbrandsen KE, Christophe A, Zentek J, Hellweg P, Janssens GP. Biological effects of short-term salmon oil administration, using distinct salmon oil sources in healthy dogs. J Small Anim Pract. 2012 Dec;53(12):699-704. doi: 10.1111/j.1748-5827.2012.12000.x. PMID: 23173908. [*]",
      "link": "https://pubmed.ncbi.nlm.nih.gov/23173908/"
    },
    "prods": [
      {
        "text": "Perfect Wild Alaskan Salmon Oil",
        "link": "/products/perfect-wild-alaskan-salmon-oil"
      }
    ]
  },
  {
    "ing": [
      "Wild Alaskan salmon oil",
      "High omega-3"
    ],
    "dsc": "Fish oil equally effective as cyclosporine in trated symmetrical onchyomadesis.",
    "journal": "Acta Veterinaria Scandinavica, 2014",
    "citation": {
      "text": "Ziener ML, Nødtvedt A. A treatment study of canine symmetrical onychomadesis (symmetrical lupoid onychodystrophy) comparing fish oil and cyclosporine supplementation in addition to a diet rich in omega-3 fatty acids. Acta Vet Scand. 2014;56(1):66. Published 2014 Oct 4. doi:10.1186/s13028-014-0066-y [*]",
      "link": "https://www.ncbi.nlm.nih.gov/pmc/articles/PMC4189663/"
    },
    "prods": [
      {
        "text": "Perfect Wild Alaskan Salmon Oil",
        "link": "/products/perfect-wild-alaskan-salmon-oil"
      }
    ]
  },
  {
    "ing": [
      "Wild Alaskan salmon oil"
    ],
    "dsc": "Fish oil supplementation significantly increased circulating concentration of adiponectin in healthy non-obese dogs.",
    "journal": "Journal of Small Animal Practice, 2014",
    "citation": {
      "text": "Mazaki-Tovi M, Abood SK, Schenck PA. Fish oil supplementation increases concentration of adiponectin in healthy dogs. J Small Anim Pract. 2014 May;55(5):247-53. doi: 10.1111/jsap.12194. Epub 2014 Feb 25. PMID: 24611954. [*]",
      "link": "https://pubmed.ncbi.nlm.nih.gov/24611954/"
    },
    "prods": [
      {
        "text": "Perfect Wild Alaskan Salmon Oil",
        "link": "/products/perfect-wild-alaskan-salmon-oil"
      }
    ]
  },
  {
    "ing": [
      "Wild Alaskan salmon oil"
    ],
    "dsc": "Long-term fish oil supplementation increases semen quality and testosterone concentrations in dogs.",
    "journal": "International Journal of Fertility and Sterility, 2016",
    "citation": {
      "text": "Risso A, Pellegrino FJ, Relling AE, Corrada Y. Effect of Long-Term Fish Oil Supplementation on Semen Quality and Serum Testosterone Concentrations in Male Dogs. Int J Fertil Steril. 2016;10(2):223-231. doi:10.22074/ijfs.2016.4913 [*]",
      "link": "https://www.ncbi.nlm.nih.gov/pmc/articles/PMC4948075/"
    },
    "prods": [
      {
        "text": "Perfect Wild Alaskan Salmon Oil",
        "link": "/products/perfect-wild-alaskan-salmon-oil"
      }
    ]
  },
  {
    "ing": [
      "Wild Alaskan salmon oil"
    ],
    "dsc": "Fish oil supplementation decreased IL-1 concentrations and improved cachexia in canine heart failure - reductions in IL-1 predicted survival.",
    "journal": "Journal of Veterinary Internal Medicine, 1998",
    "citation": {
      "text": "Freeman LM, Rush JE, Kehayias JJ, Ross JN Jr, Meydani SN, Brown DJ, Dolnikowski GG, Marmor BN, White ME, Dinarello CA, Roubenoff R. Nutritional alterations and the effect of fish oil supplementation in dogs with heart failure. J Vet Intern Med. 1998 Nov-Dec;12(6):440-8. doi: 10.1111/j.1939-1676.1998.tb02148.x. PMID: 9857337. [*]",
      "link": "https://pubmed.ncbi.nlm.nih.gov/9857337/"
    },
    "prods": [
      {
        "text": "Perfect Wild Alaskan Salmon Oil",
        "link": "/products/perfect-wild-alaskan-salmon-oil"
      }
    ]
  },
  {
    "ing": [
      "Wild Alaskan salmon oil",
      "Minimally-processed"
    ],
    "dsc": "Commerical diets had significantly lower omega-3 fatty accids than self-made diets.",
    "journal": "Metabolomics, 2019",
    "citation": {
      "text": "Boretti FS, Burla B, Deuel J, Gao L, Wenk MR, Liesegang A, Sieber-Ruckstuhl NS. Serum lipidome analysis of healthy beagle dogs receiving different diets. Metabolomics. 2019 Dec 3;16(1):1. doi: 10.1007/s11306-019-1621-3. PMID: 31797205; PMCID: PMC6890591. [*]",
      "link": "https://pubmed.ncbi.nlm.nih.gov/31797205/"
    },
    "prods": [
      {
        "text": "Perfect Wild Alaskan Salmon Oil",
        "link": "/products/perfect-wild-alaskan-salmon-oil"
      }
    ]
  },
  {
    "ing": [
      "Wild Alaskan salmon oil"
    ],
    "dsc": "Dietary MCT, fish oil, and L-carnitine counterbalanced the effects of aging on circulating concentrations of these compounds.",
    "journal": "PLoS One, 2012",
    "citation": {
      "text": "Hall JA, Jewell DE. Feeding healthy beagles medium-Chian triglycerides, fish oil, and carnitine offsets age-related changes in serum fatty acids and carnitine metabolites. PLoS One. 2012;7(11):e49510. doi: 10.1371/journal.pone.0049510. Epub 2012 Nov 7. PMID: 23145181; PMCID: PMC3492282. [*]",
      "link": "https://pubmed.ncbi.nlm.nih.gov/23145181/"
    },
    "prods": [
      {
        "text": "Perfect Wild Alaskan Salmon Oil",
        "link": "/products/perfect-wild-alaskan-salmon-oil"
      }
    ]
  },
  {
    "ing": [
      "Wild Alaskan salmon oil"
    ],
    "dsc": "Salmon oil supplementation increased testicular blood supply.",
    "journal": "Reproduction in Domestic Animals, 2021",
    "citation": {
      "text": "Santos MC, Milani C, Zucchini P, Quirino CR, Romagnoli S, da Cunha ICN. Salmon oil supplementation in dogs affects the blood flow of testicular arteries. Reprod Domest Anim. 2021 Mar;56(3):476-483. doi: 10.1111/rda.13886. Epub 2021 Jan 19. PMID: 33378121. [*]",
      "link": "https://pubmed.ncbi.nlm.nih.gov/33378121/"
    },
    "prods": [
      {
        "text": "Perfect Wild Alaskan Salmon Oil",
        "link": "/products/perfect-wild-alaskan-salmon-oil"
      }
    ]
  },
  {
    "ing": [
      "Wild Alaskan salmon oil"
    ],
    "dsc": "Dietary fish oil may exert beneficial effects on synovial fluid MMP and TIMP-2 equilibrium in the uninjured stifle of dogs with unilateral CCL injury.",
    "journal": "Journal of Nutritional Biochemistry, 2008",
    "citation": {
      "text": "Hansen RA, Harris MA, Pluhar GE, Motta T, Brevard S, Ogilvie GK, Fettman MJ, Allen KG. Fish oil decreases matrix metalloproteinases in knee synovia of dogs with inflammatory joint disease. J Nutr Biochem. 2008 Feb;19(2):101-8. doi: 10.1016/j.jnutbio.2007.01.008. Epub 2007 May 24. PMID: 17531456. [*]",
      "link": "https://pubmed.ncbi.nlm.nih.gov/17531456/"
    },
    "prods": [
      {
        "text": "Perfect Wild Alaskan Salmon Oil",
        "link": "/products/perfect-wild-alaskan-salmon-oil"
      }
    ]
  },
  {
    "ing": [
      "Wild Alaskan salmon oil"
    ],
    "dsc": "Fish oil supplementation slightly improve the physiological response of dogs to exercise during training.",
    "journal": "Journal of Animal Physiology and Animal Nutrition, 2019",
    "citation": {
      "text": "Pellegrino FJ, Risso A, Relling AE, Corrada Y. Physical response of dogs supplemented with fish oil during a treadmill training programme. J Anim Physiol Anim Nutr (Berl). 2019 Mar;103(2):653-660. doi: 10.1111/jpn.13033. Epub 2018 Dec 5. PMID: 30520172. [*]",
      "link": "https://pubmed.ncbi.nlm.nih.gov/30520172/"
    },
    "prods": [
      {
        "text": "Perfect Wild Alaskan Salmon Oil",
        "link": "/products/perfect-wild-alaskan-salmon-oil"
      }
    ]
  },
  {
    "ing": [
      "Wild Alaskan salmon oil"
    ],
    "dsc": "Dogs receiving salmon oil had higher levels of vitamin D than controls.",
    "journal": "BMC Research Notes, 2015",
    "citation": {
      "text": "Sharp CR, Selting KA, Ringold R. The effect of diet on serum 25-hydroxyvitamin D concentrations in dogs. BMC Res Notes. 2015 Sep 15;8:442. doi: 10.1186/s13104-015-1360-0. PMID: 26374201; PMCID: PMC4570747. [*]",
      "link": "https://pubmed.ncbi.nlm.nih.gov/26374201/"
    },
    "prods": [
      {
        "text": "Perfect Wild Alaskan Salmon Oil",
        "link": "/products/perfect-wild-alaskan-salmon-oil"
      }
    ]
  },
  {
    "ing": [
      "Wild Alaskan salmon oil",
      "High omega-3"
    ],
    "dsc": "Supplementation with salmon oil increased semen quality and testosterone levels in dogs.",
    "journal": "Reproduction in Domestic Animals, 2019",
    "citation": {
      "text": "Santos MC, Milani C, Zucchini P, Quirino CR, Romagnoli S, da Cunha ICN. Residual effect after salmon oil supplementation on semen quality and serum levels of testosterone in dogs. Reprod Domest Anim. 2019 Oct;54(10):1393-1399. doi: 10.1111/rda.13530. Epub 2019 Aug 13. PMID: 31348842. [*]",
      "link": "https://pubmed.ncbi.nlm.nih.gov/31348842/"
    },
    "prods": [
      {
        "text": "Perfect Wild Alaskan Salmon Oil",
        "link": "/products/perfect-wild-alaskan-salmon-oil"
      }
    ]
  },
  {
    "ing": [
      "Wild Alaskan salmon oil",
      "High omega-3"
    ],
    "dsc": "Fish oil supplementation for six weeks reduces arrhythmias in Boxers with arrhythmogenic right ventricular cardiomyopathy.",
    "journal": "Journal of Veterinary Internal Medicine, 2007",
    "citation": {
      "text": "Smith CE, Freeman LM, Rush JE, Cunningham SM, Biourge V. Omega-3 fatty acids in Boxer dogs with arrhythmogenic right ventricular cardiomyopathy. J Vet Intern Med. 2007 Mar-Apr;21(2):265-73. doi: 10.1892/0891-6640(2007)21[265:ofaibd]2.0.co;2. PMID: 17427387. [*]",
      "link": "https://pubmed.ncbi.nlm.nih.gov/17427387/"
    },
    "prods": [
      {
        "text": "Perfect Wild Alaskan Salmon Oil",
        "link": "/products/perfect-wild-alaskan-salmon-oil"
      }
    ]
  }
]